import { CHECK_COMPANY_TENANT, CheckFunction, CREDFIN_LIKE } from "../layouts/MainTenantconfig";

const { COMPANY_NAME: companyName, BASE_URL: base_url, TENANT_ID: tenantId, ESIGN_KEY: esignKey, WEB_URL: webUrl, REPORT_DB_KEY: ReportDbKey, LLM_BASE_URL: LLmBaseUrl,LEADDASHBOARD_URL } = CheckFunction();


const COMPANY_NAME = companyName;
const BASE_URL = base_url;
// const BASE_URL = "http://192.168.1.20:8070/";
const TENANT_ID = tenantId;
let ESIGN_KEY = esignKey

const REPORT_DB_KEY = ReportDbKey;


const BASE_URL_ANALYSIS = BASE_URL;
const LLM_BASE_URL = LLmBaseUrl;

// const LLM_NEW_BASE_URL = "https://llm.infitouch.in/";
const LLM_NEW_BASE_URL = LLmBaseUrl;

const BI_URL = BASE_URL

const ANALYSIS_URL = BASE_URL

const STATEMENT_URL = BASE_URL

const PSYCHOMETRIC_URL = BASE_URL

const BI_GRAPH_URL = BASE_URL

const CARD_URL = BASE_URL

// const FINANCE_BACKEND = 'http://192.168.1.19:8080/'
const FINANCE_BACKEND = 'https://finance.infitouch.in/'
const BRE_BASE_URL = 'https://bre.infitouch.in/'
// const BRE_BASE_URL = 'http://192.168.1.38:8080/'
const COMMUNICATION_URL = 'https://icommunication.infitouch.in/';
const REPORT_URL = 'https://reports.infitouch.in/'
const PAYMENT_SERVICE_URL = 'https://paymentservice.infitouch.in/'
// const PAYMENT_SERVICE_URL = "http://192.168.1.11:8090/";
const LEAD_DASHBOARD_URL =LEADDASHBOARD_URL
// const LEAD_DASHBOARD_URL =  "http://192.168.1.8:8010/";
const BASE_URL_MARKETING = FINANCE_BACKEND;


const CREDIT_BASE_URL = BASE_URL




const APIS = {
    BASE_URL: BASE_URL,
    CARD_URL: CARD_URL,

    GET_ADMIN_USER: BASE_URL + 'getAdminUser',
    GET_ADMIN_USER_NEW: BASE_URL + 'accessAndSessions/me',
    ADMIN_REFRESH_TOKEN_NEW: BASE_URL + 'accessAndSessions/refreshToken',
    ADMIN_LOGOUT_NEW: BASE_URL + 'accessAndSessions/logout',

    GET_CAPTCHA: BASE_URL + 'generateRandonCaptcha',

    NBFC_LIST: BASE_URL + 'getListOfNbfc',

    GET_INCOME_COLLECTION_API: BASE_URL + 'getIncomeCollectedAnalytics?startDate=',

    GET_ASSET_QUALITY: BASE_URL + 'getAssetQuality',
    // admin and user
    PAN_VERIFY_CUSTOMER: BASE_URL + 'userDetails/panVerify?userId=',
    // get userDetail by userId
    USER_DETAIL_BY_ID: BASE_URL + 'userDetails/userDetailById?userId=',
    // upload image and pdf
    UPLOAD_FILE: BASE_URL + 'multipleuploadpdf',
    // edit basic detail
    USER_BASIC_DETAIL: BASE_URL + 'userDetails/basicDetailAdmin',
    // edit address detail
    USER_ADDRESS_DETAIL: BASE_URL + 'userDetails/addressDetail',
    // edit employment detail
    USER_EMPLOYMENT_DETAIL: BASE_URL + 'userDetails/employmentDetail',
    SAVE_NET_TAKE_HOME_SALARY: BASE_URL + 'userDetails/saveNetTakeHomeSalary',
    // edit bank detail
    FORM_BANK_DETAIL: BASE_URL + 'userDetails/addAccountDetails',
    // fetch all pincode and bak branch
    ZIP_DETAIL: BASE_URL + 'userDetails/codeDetail?code=',
    // edit loan details
    LOAN_UPDATE: BASE_URL + 'userDetails/updateloanDetail',
    // follow up status change
    SAVE_FOLLOW_UP_STATUS: BASE_URL + 'loan/applicationStatus?loanId=',
    // password check in doc upload
    DOC_PASSWORD_PROTECT: BASE_URL + 'docPasswordProtect',
    //check loan eligibility
    CHECK_LOAN_ELIGIBILITY: BASE_URL + 'userDetails/getPersonalAdvanceFlag?userId=',
    // transaction save
    SAVE_TRANSACTION: BASE_URL + 'saveTransaction',
    // get transaction by userId
    GET_TRANSACTIONS: BASE_URL + 'getTransaction?userId=',
    // check pan number in form
    CHECK_PEN_NUMBER: BASE_URL + 'userDetails/newPanNumberExist?panNumber=',

    EMI_CALCULATOR: BASE_URL + 'getmonthemiamount/',

    BULLET_TO_EMI_CONVERSION: BASE_URL + 'getbulletemitopayuser',

    SAVE_CONVERTED_EMI: BASE_URL + 'savebulletemitopayuser',

    CHECK_REPEAT_USER: BASE_URL + 'repeatUser?userId=',

    //user

    // login mobile number save
    SEND_MOBILE_NUMBER: BASE_URL + 'otpMessage/mobile?mobile=',
    // for OTP check
    SEND_OTP: BASE_URL + 'otpMessage/otp?otp=',
    // edit loan detail
    USER_LOAN_DETAIL: BASE_URL + 'userDetails/loanDetail',
    // save feedback data
    USER_FEEDBACK: BASE_URL + 'userDetails/saveFeedbackDetail',
    // form document page next button
    FORM_DOCUMENT_NEXT: BASE_URL + '/userDetails/thanks?userId=',
    // form document page next button
    FORM_DOCUMENT_PAGE_NEXT: BASE_URL + 'userDetails/updateDocumentFormStatus?userId=',
    // login with google
    GOOGLE_LOGIN: BASE_URL + 'authorize?userId=',
    // login with facebook
    FACEBOOK_LOGIN: BASE_URL + 'authorize/facebook?userId=',
    // get notification by userId
    GET_NOTIFICATION: BASE_URL + 'getNotificationByUserId?userId=',
    // notification count 0
    READ_NOTIFICATION: BASE_URL + 'readNotification?userId=',
    // delete notification by notification id
    DELETE_NOTIFICATION_BY_ID: BASE_URL + 'deleteNotificationById?id=',
    // payment page get amount
    GET_PAID_AMOUNT: BASE_URL + 'getPaidAmount?loanId=',
    // get app from website
    GET_APP: BASE_URL + 'getApp?mobileNumber=',
    // offer by user id
    OFFER_BY_USERID: BASE_URL + 'offerByUserId?userId=',
    // check coupon by user id and coupon code
    CHECK_COUPON_CODE: BASE_URL + 'checkCoupanByUserIdCoupanCode?userId=',
    //get company list by company name
    GET_COMPANY_NAME: BASE_URL + 'userDetails/getCompanyList?companyName=',
    // get state and city by pincode
    GET_STATE_CITY: BASE_URL + 'userDetails/getAreaPincode?pinCode=',
    // merge profile with new user id
    // MERGE_PROFILE: BASE_URL + 'mergeProfile?newUserId=',

    // verify official mail id
    VERIFY_OFFICIAL_MAIL: BASE_URL + 'verifyofficialmail/',
    // save location from website
    SAVE_LOCATION_FROM_WEB: BASE_URL_ANALYSIS + 'userDetails/saveLocationFromWeb',

    //admin
    GET_COMMENT_FOR_FAILURE: BASE_URL + 'enashAndEsign/updatePaymentIdForNach',
    // promotional data
    GET_PROMOTIONAL_DATA: BASE_URL + '/getpromotionaldata?pageNumber=',
    // promotional data filtration
    GET_FILTER_DATA: BASE_URL + '/getfilteroptions',
    // send mail to promotional data
    SEND_PROMOTIONAL: BASE_URL + '/sendEmail',
    // all detail in applicaion status page
    GET_ALL_DETAIL: BASE_URL + 'userDetails/alluserDetail?pageNumber=',
    // get user detail by email id
    GET_ALL_DETAIL_BY_EMAIL: BASE_URL + 'userDetails/allDetailByEmail?emailId=',
    // get user detail by mobile number
    GET_ALL_DETAIL_BY_MOBILE: BASE_URL + 'userDetails/allDetailByNumber?mobileNumber=',
    // // filter by application number
    // LOAN_FILTER_BY_APPLICATION: BASE_URL + 'loan/listByApplication?applicationId=',
    // // filter by emailId
    // LOAN_FILTER_BY_EMAILID: BASE_URL + 'loan/listByEmail?emailId=',
    // // filter by mobile number
    // LOAN_FILTER_BY_NUMBER: BASE_URL + 'loan/listByNumber?mobileNumber=',
    // get admin notification
    GET_CRM_NOTIFICATION: BASE_URL + 'getNotificationDetails',
    GET_CRM_NOTIFICATION_BY_DATE: BASE_URL + 'getNotificationDetailsByDate',
    GET_CRM_NOTIFICATION_STATS_BY_DATE: BASE_URL + 'getNotificationStatsByDate',
    UPDATE_CRM_NOTIFICATION_TOUCHED: BASE_URL + 'updateCrmNotificationTouched',
    GET_CRM_NOTIFICATION_SUMMARY_BY_EMAIL: BASE_URL + 'getCrmNotificationSummaryByEmail',
    // notification count 0
    GET_READ_NOTIFICATION: BASE_URL + 'getAdminNotificationRead?type=',
    // delete notification one by one    
    DELETE_CRM_NOTIFICATION_ONE: BASE_URL + 'getNotificationDelete?id=',
    // delete all notifications
    DELETE_CRM_NOTIFICATION: BASE_URL + 'deleteCrmNotifications',
    // get all loans
    GET_LOAN_APPROVAL_LEAD_TESTING: BASE_URL + 'userDetails/getAllUserLoanApprovalLead?status=',
    // get all loans
    // GET_LOAN_APPROVAL_LEAD: BASE_URL + 'loanLeadTesting?status=',
    // get loanAdd leads
    GET_LOAN_ADDA_LEAD: BASE_URL + 'getLoanApprovalLeadByThirdParty?status=',
    // loan status change by action page
    LOAN_SANCTION: BASE_URL + 'loan/loanSanction',
    // role assign
    ROLE_ASSIGN: BASE_URL + 'roleAssign',

    GET_LEAD_BY_MOBILE_NUMBER: BASE_URL + 'getNewLeadsByMobileNumbers',
    // show all employees role
    ROLE_ASSIGN_VIEW: BASE_URL + 'roleAssignView?emailId=',
    ATTENDECE_LOGIN_BY_MAIL_ID: FINANCE_BACKEND + 'attendance/login?employeeEmail=',
    ATTENDECE_LOGOUT_BY_MAIL_ID: FINANCE_BACKEND + 'attendance/logout?employeeEmail=',
    ATTENDECE_CHECKER_BY_MAIL_ID: FINANCE_BACKEND + 'attendance/heartbeat?employeeEmail=',
    // admin login
    ADMIN_LOGIN: BASE_URL + 'adminrole',
    ADMIN_LOGIN_UPDATED: BASE_URL + 'adminLogin',
    ADMIN_LOGIN_UPDATED_NEW: BASE_URL + 'accessAndSessions/login',
    // status change in communication page
    PUSH_NOTIFICATION: BASE_URL + 'pushNotification',
    // view all messages
    VIEW_USER_MSG: BASE_URL + 'getsms?userId=',
    // view all locations
    VIEW_USER_LOCATION: BASE_URL + 'getlocation?userId=',
    // logs view in admin
    GET_COMMENT_ADMIN: BASE_URL + 'getComment?userId=',
    // action page loan disbursed
    // DISBERSE_API: BASE_URL + 'loan/disberse?loanId=',

    DISBERSE_API: BASE_URL + 'disbursedStatus?loanId=',
    DISBERSE_API_EV: BASE_URL + 'disbursedStatusEV?loanId=',
    // save button in document link send via mail
    DOC_MAIL_SAVE: BASE_URL + 'loan/uploadDocumentData?userId=',
    // action page loan paid
    // PAID_STATUS: BASE_URL + 'loan/paidStatus',

    PAID_STATUS: BASE_URL + 'paidStatuss',

    // update transaction
    UPDATE_TRANSACTION: BASE_URL + 'updateTransaction?transactionId=',
    // push notification in admin
    REGISTER_PUSH_NOTIFICATION: BASE_URL + 'register/push?token=',

    REGISTER_TO_GROUP_NOTIFICATION: BASE_URL + '/register/push/group?token=',
    //get loan agreement in admin
    // GET_LOAN_AGREEMENT: BASE_URL + 'enashAndEsign/getloanUrl?loanId=',
    GET_LOAN_AGREEMENT: BASE_URL + 'enashAndEsign/getDocxLoanAgreement?loanId=',
    // all loan status
    GET_ALL_STATUS: BASE_URL + 'getAllStatus',
    // export excel in admin
    EXPORT_EXCEL: BASE_URL + 'getDataByStatus?status=',
    // view all role list
    GET_ALL_USER_ROLE: BASE_URL + 'getAllRole',
    // send name and url for bank statement
    // SEND_BANK_DATA: BASE_URL + 'getStatementAnalysis',
    SEND_BANK_DATA: STATEMENT_URL + 'getDetails',

    USER_MSG_ANALYSIS: STATEMENT_URL + 'getmsg?userid=',
    //get bank data
    GET_BANK_DATA: BASE_URL + 'finBoxGetUserStatement?userId=',
    //get contact data
    GET_ACCOUNT_FINBOX: BASE_URL + 'finBoxGetContacts?userId=',
    // get all bank list
    GET_BANK_LIST: BASE_URL + 'getAllBank',
    // save promotional data
    SAVE_PROMOTATIONAL_OFFER_DATA: BASE_URL + 'savePromotational',
    // get all saved promotional data
    GET_ALL_PROMOTATION_OFFER: BASE_URL + 'getPromotational',
    // get status wise loan count by date
    FORM_STATUS_COUNT_BY_GIVEN_DATE: BASE_URL + 'formStatusCountByGivenDate?date=',
    // get status wise loan count by month
    FORM_STATUS_COUNT_BY_GIVEN_MONTH: BASE_URL + 'formStatusCountByGivenMonth?year=',
    // get status wise loan count between two days
    FORM_STATUS_COUNT_BETWEEN_TWO_DATES: BASE_URL + 'formStatusCountBetweenTwoDates?startdate=',

    GET_ALL_STATUS_BULLET_EMI: BASE_URL + 'getAllStatusCount?startdate=',
    // bulk status change
    BULK_STATUS_CHANGE: BASE_URL + 'bulkStatus',
    // incomplete application count
    GET_INCOMPLETE_APP_COUNT: BASE_URL + 'getIncompleteApplicationBetweenDates?startdate=',

    GET_INCOMPLETE_COUNT_BY_FILTER: BASE_URL + 'getIncompleteCountByFilter?startDate=',
    // send mail to incomplete applicaion
    SEND_MAIL_FOR_INCOMPLETE: BASE_URL + 'sendingMailforIncompleteForms',
    // show feedback by userId
    GET_FEEDBACK_BY_USERID: BASE_URL + 'userDetails/getAllFeedbackDetails?userId=',
    // bulk communication by status
    COMMUNICATE_BY_STATUS: BASE_URL + 'sendingMailAccordingToStatus',
    // bulk communication by status LOGS
    COMMUNICATE_BY_STATUS_LOGS: BASE_URL + 'getBulkLog',
    // incoming loan payment next week
    INCOMING_PAYMENT_BY_WEEK: BASE_URL + 'getIncomingPaymentDetailsbyWeek?count=',
    // last 5 days document upload
    LATEST_DOCUMENT_UPLOAD: BASE_URL + 'getLastFiveDaysDoc?pageNumber=',
    // Emi incoming loan payment next week
    EMI_INCOMING_PAYMENT_BY_WEEK: BASE_URL + 'getEMIIncomingPaymentDetailsbyWeek?count=',
    // incoming loan payment by selected date
    INCOMING_PAYMENT_BY_DATE: BASE_URL + 'getIncomingPaymentDetailsbyGivenDate?date=',
    // Emi incoming loan payment by selected date
    EMI_INCOMING_PAYMENT_BY_DATE: BASE_URL + 'getEMIIncomingPaymentDetailsbyGivenDate?date=',
    // all due loan payment
    DUE_PAYMENT_BY_WEEK: BASE_URL + 'getDuePaymentDetailsbyWeek?count=',
    DUE_PAYMENT_BY_WEEK_ABHICASH: BASE_URL + 'getBulletLoanRecoveryList?count=',
    // all emi due loan payment
    EMI_DUE_PAYMENT_BY_WEEK: BASE_URL + 'getEMIDuePaymentDetailsbyWeek?count=',
    // due loan payment by selected date
    DUE_PAYMENT_BY_DATE: BASE_URL + 'getDuePaymentDetailsbyGivenDate?date=',
    // emi due loan payment by selected date
    EMI_DUE_PAYMENT_BY_DATE: BASE_URL + 'getEMIDuePaymentDetailsbyGivenDate?date=',
    // save application number and cheque number for field boys
    SAVE_APPNO_CHECK: BASE_URL + 'applicationToCheckSave',
    // todays loan count
    TODAYS_LOAN_COUNT: BASE_URL + 'todaysLoanCount?date=',
    // assign loan task for members
    ASSIGN_LOAN: BASE_URL + 'assignLoan?loanId=',
    ///load cache data
    LOAD_CACHE: BASE_URL + 'phocketReloadCacheData',
    // loan process tracking
    STATUS_ACTIVITY_DATA: BASE_URL + 'loan/getLoanTrack?loanId=',
    // get all admin roles
    GET_ALL_ADMIN_ROLE: BASE_URL + 'allUserRole?emailId=',
    // save score by company name and userId
    SAVE_SCORE_BY_COMPANY_USERID: BRE_BASE_URL + 'creditScorebyUserId?userId=',
    // FILTER_EXPORT_EXCEL: BASE_URL + 'sheetDownload?status=',
    FILTER_EXPORT_EXCEL: BASE_URL + 'sheetDownloadbyColumn',
    //Get Credit Rating
    GET_RATING_FOR_CUSTOMER_INFO: BRE_BASE_URL + 'creditScorebyUserId?userId=',
    // Update credit rating
    UPDATE_CREDIT_SCORE: CREDIT_BASE_URL + 'getcreditScoreList',
    // column list for export to excel
    LIST_FOR_EXCEL_REPORT: BASE_URL + 'sheetColumnList',
    // excel sheet by choice
    SHEET_BY_CHOICE: BASE_URL + 'sheetDownload',
    // enash verification
    LOAN_VARIFICATION: BASE_URL + 'enashAndEsign/verifyRegistrationEnash?loanId=',
    // schedule enash
    LOAN_TRANSACTION_SCHEDULE: BASE_URL + 'enashAndEsign/scheduleTransactionEnash?loanId=',
    // calculate payble amount
    CALC_UTILITY: BASE_URL + 'getPayableAmount',
    // All credit scores
    ALL_CREDIT_SCORE: CREDIT_BASE_URL + 'getAllCustomerCreditScore',
    // save user action logs
    SAVE_USER_ACTION_LOGS: BASE_URL + 'userActionLog',
    SAVE_SOFT_REJECT_REASON_STATUS: BASE_URL + 'loan/softRejectedLoan',
    // change admin password
    // CHANGE_ADMIN_PASSWORD: BASE_URL + 'changePassword?emailId=',
    CHANGE_ADMIN_PASSWORD: BASE_URL + 'changePassword',
    // save important loan
    SAVE_IMPORTANT_LOANS: BASE_URL + 'saveValuableCustomersData',
    // delete employee from admin
    DELETE_EMPLOYEE: BASE_URL + 'deleteUser?emailId=',
    // delete transaction
    DELETE_TRANSACTION: BASE_URL + 'deleteTransaction?transactionId=',
    // get mail activity
    GET_ACTIVITY: BASE_URL + 'getActivity',
    //mail activity login
    ACTIVITY_LOGIN: BASE_URL + 'fetchMail',
    // status count by week
    STATUS_COUNT_BY_WEEK: BASE_URL + 'statusCountByWeek',
    // status count by month
    STATUS_COUNT_BY_MONTH: BASE_URL + 'statusCountByMonth?year=',
    // status count between days 
    STATUS_COUNT_BETWEEN_DATES: BASE_URL + 'statusCountBetweenDay?startdate=',
    // send mail for approval
    APPROVE_VERIFICATION: BASE_URL + 'enashAndEsign/sendMailForApproval?loanId=',
    // stamp duty upload
    UPLOAD_STAMP_DUTY: BASE_URL + 'uploadStampDuty',
    // display coupon stats
    COUPON_STATS: BASE_URL + 'couponStat',
    // merchant login
    MERCHANT_LOGIN: BASE_URL + 'loginMerchant',
    // get merchat detail
    MERCHANT_ALL_DATA_API: BASE_URL + 'getMerchantDetails',

    MERCHANT_REDUMPTION_DETAIL: BASE_URL + 'getPendingCoupons',

    REDEEM_COUPON: BASE_URL + 'redeemcoupon',

    MERCHANT_DOCUMENT_UPLOAD: BASE_URL + 'saveMerchantLogo',

    COUPON_DOCUMENT_UPLOAD: BASE_URL + 'saveCouponImage',

    MERCHANT_AGREEMENT_UPLOAD: BASE_URL + 'saveAgreement',

    GET_MERCHANT_IMAGES: BASE_URL + 'getMerchantLogo',

    GET_COUPON_IMAGE: BASE_URL + 'getOfferImage',

    GET_COUNT_BY_STATES: BASE_URL + 'getLoanCountByStates?date=',

    GET_COUNT_BY_AGENT: BASE_URL + 'getApplicationCountByAgent?date=',

    GET_APPLICATION_STATUS_COUNT: BASE_URL + 'getApplicationStatusByCount?startDate=',

    GET_LOAN_SCORE: BASE_URL + 'getNewScore?loanId=',

    MAP_COUPON_LOANSTATUS: BASE_URL + 'saveOffersForLoanStatus',

    // SAVE_CERTIFICATE_NUMBER: BASE_URL + 'saveCertificateNumber?loanId=',

    GET_COUPON_ON_OUTLET: BASE_URL + 'getCouponOnOutlet',

    AUTOMATION_MAIL_LOGS: BASE_URL + 'getAutomationMailLog',

    GET_USERS_USED_COUPONS: BASE_URL + 'getAvailCouponUserByCoupon',

    SAVE_WEBSITE_DATA: BASE_URL + 'saveWebsiteData',

    GET_WEBSITE_DATA: BASE_URL + 'getWebsiteData',

    TOTAL_AMBASSADOR_COUNT: BASE_URL + 'ambassadorCount',

    SAVE_NACH: BASE_URL + 'loan/saveNachData',

    SAVE_EXTENSION_TIME: BASE_URL + 'loan/saveExtensionTime?loanId=',
    // GET_FROUD_DETAIL: BASE_URL + 'getFraudMatchDetails',
    GET_FROUD_DETAIL: BASE_URL + 'getFraudMatchDetail?userId=',


    GET_FROUD_DETAIL_NEW: BRE_BASE_URL + 'getFraudMatchDetailNew?userId=',

    GENERATE_DISBURSE_REPORT: BASE_URL + 'getDisbursedSheet',

    GENERATE_CIBIL_REPORT: BASE_URL + 'cibilData?startDate=',

    SAVE_FIELDBOY_DETAILS: BASE_URL + 'saveEmployeeDetails',

    GET_FIELDBOY_DETAILS: BASE_URL + 'getEmployeeDetails',

    DELETE_FIELD_BOY: BASE_URL + 'deleteFieldBoyRegistration?empId=',

    UPDATE_ASSIGN_FIELD_BOY: BASE_URL + 'updateFieldAssign',

    SAVE_LOAN_ID: BASE_URL + 'loan/saveApplicationToLoan',
    DELETE_SIGNDESK_ENTRY: BASE_URL + 'deleteSignDeskEntry?loanId=',

    LOAN_LIST_BY_LOAN: BASE_URL + 'loan/listByloan?loanId=',

    GET_EMAIL_DEVICE: BASE_URL + 'getEmailAndDevice?page=',

    SEND_RECOVERY_COMMUNICATION: BASE_URL + 'saveRecoveryMail',

    GET_RECOVERY_LOGS: BASE_URL + 'getRecoveryMail',

    SAVE_CHEQUE_NOTICE: BASE_URL + 'saveChequeNotice',

    GET_CHEQUE_DATA: BASE_URL + 'getChequeData?count=',

    GET_NOTICE_DATA: BASE_URL + 'getNoticeData?count=',

    GET_USER_DEVICE_DATA: BASE_URL_ANALYSIS + 'getUserDeviceData?userId=',

    GET_NACH_DATA: BASE_URL + 'getNachBounceData?count=',

    SAVE_CHEQUE_LIMIT: BASE_URL + 'saveChequeLimit?userId=',

    UPDATE_USING_CSV: BASE_URL + 'uploadsheetcsv',

    UPDATE_DB_DATA: BASE_URL + 'updatecsv',

    UPDATE_MOBILE_AND_EMAIL: BASE_URL + 'updateMobileAndEmail?userId=',

    DELETE_COMPLETE_USER: BASE_URL + 'removeUser?userId=',

    DELETE_COMPLETE_AMBASSADOR: BASE_URL + 'deleteAmbassador?ambassadorId=',

    DOC_UPLOAD_SAVE_FROM_MAIL: BASE_URL + 'docUploadSave',

    SEND_WHATSAPP_MSG: BASE_URL + 'sendWhatsAppMsg',

    GET_WHATSAPP_MSG: BASE_URL + 'getWhatsAppMsg?mobileNo=',

    SEND_WHATSAPP_FILE: BASE_URL + 'sendWhatsAppFile',

    GENERATE_REPORT_LOGS: BASE_URL + 'downloadReportByEmploy',

    GET_FIELDBOY_DETAIL: BASE_URL + 'getEmployeeDetails',

    ASSIGN_APPLICATION: BASE_URL + 'assignApplication',

    ASSIGNED_APPLICATIONS: BASE_URL + 'getAssignedApplicationByLoanId?loanId=',

    REFERRAL_COMPANY: BASE_URL + 'saveMerchantReferral',

    DAILY_DISTANCE_COVERED: BASE_URL + 'getDistanceCoveredDateWise?empId=',

    SAVE_AMBASSADOR_COMMENTS: BASE_URL + 'saveAmbassadorAdminLog',

    GET_AMBASSADOR_COMMENTS: BASE_URL + 'getAmbassadorAdminLog?ambassadorId=',

    START_FIELD_BOY_TIMING: BASE_URL + 'saveEndTimeFieldBoy?time=',

    SAVE_TENTATIVE_DATA: BASE_URL + 'loan/tentativeApproveAmount',

    NOTIFICATION_IMAGE_UPLOAD: BASE_URL + 'uploadAnypdf',

    GET_IBD_DETAILS: BASE_URL + 'getibddetails/',

    GET_OBD_DETAILS: BASE_URL + 'getobddetails',

    SAVE_COUPON_CODE: BASE_URL + 'saveCouponCodes',

    GET_CALLBACK_STATUS_CHANGE: BASE_URL + 'ivr/changeCallBackStatus?mobileNumber=',

    GET_IVR_FILTER_API: BASE_URL + 'ivr/getibddetails?date=',

    GET_IVR_RESPONSE: BASE_URL + 'getIVRResponse',

    SAVE_LOAN_INSTALLMENT: BASE_URL + 'loan/saveLoanEmi',

    GET_LOAN_INSTALLMENT: BASE_URL + 'loan/getLoanEmiDetailByLoanId?loanId=',

    DELETE_LOAN_INSTALLMENT: BASE_URL + 'loan/deleteLoanEmi?id=',

    SEND_MAIL_VERIFICATION_REQUEST: BASE_URL + 'sendverificationRequest',

    EMI_DETAIS_SAVE: BASE_URL + 'saveemiforuser',

    EMI_DETAIS_GET: BASE_URL + 'getemitopayuser/',

    // EMI_PAID_SAVED: BASE_URL + 'updateemiforuser',

    EMI_PAID_SAVED: BASE_URL + 'updateemiforuserNew',


    FIELD_BOY_DOCUMENTS: BASE_URL + 'updateUserDocs',

    GET_SCHEDULED_LOAN_DATA: BASE_URL + 'getScheduledLoanDetails/',

    COMMUNICATION_COUNT_BY_FILTER: BASE_URL + 'getCommunicationCountByFilter?state=',

    BULK_COMMUNICATION: BASE_URL + 'sendingMailAccToFilter',

    UPDATE_CONVERT_EMI_BTN: BASE_URL + 'updateloanstatusbyadmin/',

    GET_LOAN_PAGE_MSG: BASE_URL + 'getValidationMsg',

    GET_CALCULATIO_FOR_ADMIN: BASE_URL + 'getemiamountbyadmin/',

    GET_EMI_HISTORY: BASE_URL + 'getallemiforadminbyuser/',

    // USER_DETAIL_BY_LOANID: BASE_URL + 'userDetails/userDetailByLoanId?loanId=',

    USER_DETAIL_BY_LOANID: BASE_URL + 'getLoanDetailByLoanIdNew?loanId=',
    USER_DETAIL_BY_LOANID_OPTIMISED: BASE_URL + 'getLoanDetailByLoanIdNewOptimised?loanId=',
    GET_MFI_AGGREGATOR_DETAILS_BY_LOANID: BASE_URL + 'loan/getMfiAggregatorDetailByLoanId?loanId=',
    DOWNLOAD_EMI_DATA_AUDIT_REPORT: FINANCE_BACKEND + 'getEmiDataAuditReport',

    ADD_AMBASSADOR_ID_IN_APPLICATION: BASE_URL + 'adminAmbassasorApplication?ambassadorId=',

    CHANAGE_EMI_STATUS: BASE_URL + 'changeEMIStatus?userId=',

    GET_ALL_STATE: BASE_URL + 'getAllState',

    BULK_APPLICATION_ASSIGN: BASE_URL + 'bulkApplicationAssign',

    GET_USER_ASSIGN_STATE: BASE_URL + 'getAssignByState',

    GET_COUNT_BY_STATUS: BASE_URL + 'getCountToEachStatus?date=',

    UPDATE_ASSIGN_STATUS: BASE_URL + 'updateAssignStatus?emailId=',

    MANUAL_ASSIGN_BY_LOAN_ID: BASE_URL + 'bulkApplicationAssignByLoanId',

    SAVE_ASSIGN_BY_STATUS: BASE_URL + 'saveAssignByStatusUpdated',

    GET_ASSIGN_BY_STATUS: BASE_URL + 'getAssignByStatusUpdated',

    MARK_APPLICATION_COMPLETE: BASE_URL + 'markApplicationComplete?userId=',

    PINCODE_UPLOAD: BASE_URL + 'pincodeUpload',

    APPROVE_T0_DISBURSE: BASE_URL + 'getDisbursedDetailByCsv',

    CONVERT_TO_PAID_BULK: BASE_URL + 'getPaidDetailByCsv',

    GET_PINCODE_DATA: BASE_URL + 'getAllPincode',

    NACH_UPLOAD_BULK: BASE_URL + 'loan/updateBulkNachStatus',

    GET_PRIORITY_COMPANY: BASE_URL + 'getPriorityCompany',

    ADD_PRIORITY_COMPANY: BASE_URL + 'addPriorityCompany',

    GET_LOAN_BREAK_BY_LOANID: BASE_URL + 'loan/getLoanBreakAmountByLoanId?loanId=',

    GET_PAYMENT_TRANSACTION: BASE_URL + 'loan/getLoanBreakDetailOfSinlgeEmi?loanId=',

    GET_LIST_OF_NBFC: BASE_URL + 'getListOfNbfc?nbfcName=',

    SOFT_APPROVAL_TO_NBFC: BASE_URL + 'softApprovalToNbfc?loanId=',

    SAVE_NBFC: BASE_URL + 'saveNbfc',

    VERIFY_MENDATE_SAVE_TOKEN: BASE_URL + 'enashAndEsign/verifyMandateAndSaveToken?userId=',

    BANK_DETAIL_ANALYSIS: STATEMENT_URL + 'api?id=',

    APP_ANALYSIS: STATEMENT_URL + 'app_api?userid=',

    UPDATE_ACC_INFO_CSV: BASE_URL + 'updateAccInfo',

    NACH_REPORT_DATA: BASE_URL + 'enashAndEsign/getEnachDataLead?pageNumber=',

    SEND_MAIL_TO_NACH_FAIL: BASE_URL + 'sendEnachRepeatMail?loanId=',

    BULK_COM_BY_CSV: BASE_URL + 'bulkCommunicationByCSV',

    UPLOAD_CSV_FILE: BASE_URL + 'uploadCsvFile',

    UPLOAD_CIBIL_FILE: BASE_URL + 'uploadCibilScoreData',

    DEDUCT_PAYMENT: BASE_URL + 'enashAndEsign/deductUserPayment?loanId=',

    DEDUCT_PAYMENT_BY_TECH_PROCESS: BASE_URL + 'enashAndEsign/scheduleTransactionEnash?loanId=',

    GET_SOURCE_OF_ENACH_BY_USERID: BASE_URL + 'getSourceOfEnachByUserId?userId=',
    GET_PAYMENT_SERVICE_SOURCE_OF_ENACH_BY_USERID: PAYMENT_SERVICE_URL + 'api/payment-service/getSourceOfEnachByUserId?userId=',

    GET_DATA_FOR_BULK_UPDATE: BASE_URL + 'loan/getDataForBulkUpdate?applicationId=',

    // GET_CIBIL_SCORE_BY_USERID: BASE_URL + 'loan/getCibilScoreDataByUserId?userId=',
    GET_CIBIL_SCORE_BY_USERID: BRE_BASE_URL + 'loan/getCibilScoreDataByUserIdLoanId?userId=',

    // GET_CRIF_DATA: BRE_BASE_URL + (CHECK_COMPANY_TENANT(CREDFIN_LIKE) ? 'getCrifDataV2?userId=' : "getCrifDataLV3?userId="),
    GET_CRIF_DATA: BRE_BASE_URL + 'getCrifDataV2?userId=',
    GET_CRIF_SOFT_DATA: BRE_BASE_URL + 'crifSoftPullLV3?userId=',
    // GET_CRIF_DATA: BASE_URL + 'getCrifData?userId=',

    GET_CRIF_ANALYSIS_DATA: BASE_URL + 'getCrifDataInJsonV2?userId=',

    EDIT_CIBIL_SCORE_BY_USERID: BRE_BASE_URL + 'loan/updateCibilScoreData',

    REMOVE_APPLICATION_FROM_NBFC: BASE_URL + 'assignNbfcWithoutStatus?loanId=',

    GET_PSYCHOMETRY_DATA: PSYCHOMETRIC_URL + 'ques',

    GET_APPLICATION_ANALYSIS_DATA: BI_GRAPH_URL + 'Application_Analysis',

    GET_FORM_STAGE_COUNT: BI_GRAPH_URL + 'Form_Stage_Count',

    GET_PROFILE_ANALYSIS_DATA: BI_GRAPH_URL + 'Profile_Analysis',

    GET_LOAN_ANALYSIS_DATA: BI_GRAPH_URL + 'Loan_Analysis',

    GET_OVERDUE_ANALYSIS_DATA: BI_GRAPH_URL + 'Overdue_Analysis',

    GET_LOGIN_DEVICE_DATA: BI_GRAPH_URL + 'eda/login_device_status',

    GET_EVENT_DATA: BI_GRAPH_URL + 'eda/sourceofinfo_plateform_events',

    GET_LOAN_DATA: BI_GRAPH_URL + 'eda_loan_amount_range',

    GET_DETAILS_DATA: BI_GRAPH_URL + 'eda_user_login2 ',

    GET_LOGIN_DATA: BI_GRAPH_URL + 'eda_user_login',

    GET_EDA_USER_LOAN: BI_GRAPH_URL + 'eda_user_to_loan',

    PUSH_LEAD_TO_RETRA: BASE_URL + 'retraPushData?loanId=',

    BULK_PUSH_RETRA: BASE_URL + 'retraSendDataByLoanId',

    CREDIT_VIDYA_LEADS: BASE_URL + 'getCreditVidyaLeads?pageNumber=',

    CREDIT_VIDYA_LEADS_BY_FILTER: BASE_URL + 'getCreditVidyaLeadsByFilter?pageNumber=',

    UNSUBSCRIBE_MAIL: BASE_URL + 'unSubscribeMailByUserId?userId=',

    AUTH_TOKEN: BASE_URL + 'oauth/token',

    // ambassador

    //google login
    AMB_GOOGLE_LOGIN: BASE_URL + 'ambassador/authorize?ambassadorId=',
    //facebook login
    AMB_FACEBOOK_LOGIN: BASE_URL + 'ambassador/authorize/facebook?userId=',
    // Ambasador Details
    ALL_AMBASADOR_DETAILS: BASE_URL + 'allAmbasadorDetail?ambassadorId=',
    // All Ambasador Data
    ALL_AMBASSADORS: BASE_URL + 'allAmbasador?count=',
    // Update ambassador status
    UPDATE_AMBASSADOR_STATUS: BASE_URL + 'updateAmbassadorStatus?ambassadorId=',
    // ambassador basic detail save
    AMBASSADOR_BASIC_DETAIL: BASE_URL + 'ambasadorDetailSave',

    AMBASSADOR_ADDRESS_DETAIL: BASE_URL + 'ambasadorAddressSave',

    AMBASSADOR_BANK_DETAIL: BASE_URL + 'ambasadorBankDetailSave',

    AMBASSADOR_ALL_DATA: BASE_URL + 'ambasadorAllDetail?ambassadorId=',

    UPLOAD_AMBASSADOR_DOCUMENT: BASE_URL + 'ambassadordocument',

    DELETE_CATEGORY: BASE_URL + 'deleteCategory',

    DELETE_SUBCATEGORY: BASE_URL + 'deleteSubCategory',

    DELETE_COUPON: BASE_URL + 'deleteCoupon',

    DELETE_MERCHANT: BASE_URL + 'deleteMerchant',

    DELETE_MERCHANT_IMAGE: BASE_URL + 'deleteMerchantImage',

    DELETE_MERCHANT_OUTLET: BASE_URL + 'deleteMerchantOutlet',

    DELETE_CITY: BASE_URL + 'deleteCity',

    DELETE_COUPON_ON_OUTLET: BASE_URL + 'deleteCouponOnOutlet',

    SEND_AGGREMENT: BASE_URL + 'enashAndEsign/sendMailloanUrl?loanId=',

    SAVE_EXISTING_USER: BASE_URL + 'saveAndCheckForExistingUser',

    USER_TO_AMBASSADOR: BASE_URL + 'moveUserToAmbassador',

    GET_AMBASSADOR_ID: BASE_URL + 'getAmbassadorId?emailId=',
    // document next btn
    AMB_DOC_NEXT: BASE_URL + 'completeDocument?ambassadorId=',

    SHARE_AMB_ID_WITH_MAIL: BASE_URL + 'shareMail?emailId=',

    SHARE_AMB_ID_WITH_MSG: BASE_URL + 'shareMessage?number=',

    GET_ENACH_LOAN_DETAIL: BASE_URL + 'enashAndEsign/getloanDetail?loanId=',



    GET_RAJORPAY_ORDER_ID: BASE_URL + 'enashAndEsign/getRajorPayOrderIdCustomerId?loanId=',



    GET_TECHPROCESS_HASH_VALUE: BASE_URL + 'enashAndEsign/getHashValue?loanId=',

    GET_PAYNIMO_ORDER_ID: BASE_URL + 'enashAndEsign/getHashValue?loanId=',

    RAJORPAY_CALLBACK: BASE_URL + 'enashAndEsign/razorPayCallBack?type=',

    // GET_ESIGN_PDF_URL: BASE_URL + 'enashAndEsign/getloanUrl?loanId=',

    GET_ESIGN_PDF_URL: BASE_URL + 'enashAndEsign/getloanUrlUpdated?loanId=',

    ESIGN_AND_ENACH_INITIATE: BASE_URL + 'enashAndEsign/initiateEsign?loanId=',

    EMI_CALC_WITH_NBFC: BASE_URL + 'getmonthemiamountForNbfc/',

    // Loyality

    // save loyality offer
    LOYALITY_OFFER: BASE_URL + 'loyalityOffer',
    // Get all loyality offers
    GET_ALL_LOYALITY_OFFER: BASE_URL + 'getloyalityOffer',
    // get loyality list by userId
    GET_LOYALITY_LIST_BY_USERID: BASE_URL + 'getloyalityListByUserId?userId=',
    // Get all loyality detail
    GET_ALL_LOYALITY_DETAIL: BASE_URL + 'getAllloyalityList?count=',
    //marchant offer
    MARCHANT_OFFER_SAVE: BASE_URL + 'saveOffer',

    GET_MARCHANT_OFFER_LISTING: BASE_URL + 'getAllCoupons',

    GET_MARCHANT_OUT_LET: BASE_URL + 'getMerchantsOutlet',

    SAVE_MARCHANT_OUT_LET: BASE_URL + 'saveOffersonOutlet',

    GET_MARCHANT_OFFER: BASE_URL + 'getAdminDiscountDetails',

    GET_MERCHENT_DETSILS: BASE_URL + 'getmerchnatsdetails',

    SAVE_OFFR_LOCATION: BASE_URL + 'saveLocation',

    SAVE_OFFER_MERCHANT: BASE_URL + 'saveMerchant',

    SAVE_OFFER_CATEGORY: BASE_URL + 'saveCategory',

    SAVE_OFFER_SUBCATEGORY: BASE_URL + 'saveSubCategory',

    GET_COUPON_LIST_FOR_MERCHANTS: BASE_URL + 'getOffersForMerchants',

    SAVE_MARCHANT_OUT_LET_ADDRESS: BASE_URL + 'saveOutlet',

    GET_OUTLET_LOCATIONS: BASE_URL + 'getOutlets',

    APPROVE_REJECT_REASON: BASE_URL + 'approveRejectReason?status=',

    DOWNLOAD_REPORT_LOG: BASE_URL + 'downloadReportByEmploy',

    AMBASSADOR_LOGIN: BASE_URL + 'loginPhocketAmbassdor',

    THIRD_PARTY_LOGIN: BASE_URL + 'logincampaignusers ',

    THIRD_PARTY_REGISTRATION: BASE_URL_MARKETING + 'saveeventcampaigndata',

    GET_CAMPAIGN_TRACK: BASE_URL + 'getUsersByCampaign/',

    GET_REGISTER_DATA: BASE_URL + 'getRegisteredUsers',

    SAVE_CAMPAIN_DATA: BASE_URL + 'saveEventCampaign',

    GET_ALL_CAMPAIN_NAME: BASE_URL + 'getAllCampaign',

    GET_USERS_DETAILS: BASE_URL + 'getRegisteredUsersDetails/',

    GET_ALL_CAMPAIGN: BASE_URL + 'getAllCampaign',

    GET_CAMPAIGN_BY_MERCHANT: BASE_URL + 'getCampaignByMerchant/',

    DELETE_CAMPAIGN_URL: BASE_URL + 'deleteMerchantByAdmin',

    GET_EXCEL_DATA_URL: BASE_URL + 'downloadThirdPartySheet?url=',

    DEACTIVATE_NACH: BASE_URL + 'enashAndEsign/deactivateEnach?userId=',

    SEND_MSG_BY_MOBILE_CSV: BASE_URL + 'sendMsgFromCsvByMobileNumber',

    AADHAR_EXIST_CHECK: BASE_URL + 'userDetails/aadharExist?userId=',

    INITIATE_BULK_PAYMENT_RAZORPAY: BASE_URL + 'enashAndEsign/initiateRazorPayPaymentBulk',


    /////Api After Gift Card///////////
    GET_LOAN_APPROVAL_LEAD: BASE_URL + 'loanLeadTestingNew?status=',

    GET_LOAN_DETAIL_BY_USERID: BASE_URL + 'getLoanDetailByUserId?userId=',

    GET_USER_DOCUMENTS_BY_USER_ID: BASE_URL + 'getUserDocumentDetailByUserId?userId=',

    GET_GIFTCARD_EMI: BASE_URL + 'getEmiToPayGiftCard/',

    GET_EMI_HISTORY_GIFTCARD: BASE_URL + 'getAllLoanEmiForUserGiftCard/',

    GIFT_CARD_APPROVE_API: BASE_URL + 'approvedGiftCard/',

    DISBURSE_GIFT_CARD_API: BASE_URL + 'disbursedGiftCard?giftCardId=',

    CHANGE_FOLLOW_UP_GIFT_CARD: BASE_URL + 'applicationStatuss?giftCardId=',

    CHANGE_EMI_STATUS_GIFT_CARD: BASE_URL + 'changeEMIStatuss?userId=',

    APPROVE_VERIFICATION_GIFTCARD: BASE_URL + 'enashAndEsign/sendMailForApprovalGiftCard?giftCardId=',

    SAVE_TENTATIVE_DATA_GIFT_CARD: BASE_URL + 'tentativeApproveAmountGiftCard',

    GET_ENACH_LOAN_DETAIL_GIFT_CARD: BASE_URL + 'enashAndEsign/getLoanDetailById?id=',

    GET_ACCOUNT_DETAILS_USER_ID: BASE_URL + 'getAccountDetailByUserId?userId=',


    LOAN_FILTER_BY_APPLICATION: BASE_URL + 'listByApplication?applicationId=',

    LOAN_FILTER_BY_EMAILID: BASE_URL + 'listByEmail?emailId=',

    LOAN_FILTER_BY_NUMBER: BASE_URL + 'listByNumber?mobileNumber=',

    SAVE_CERTIFICATE_NUMBER: BASE_URL + 'saveCertificateNumberGiftCard?loanId=',

    APPLY_GIFT_CARD_API: BASE_URL + 'applyForGiftCard',

    GET_GIFT_CARD_LEADS: BASE_URL + 'loanLeadTestingNewGiftCard?status=',

    GIFTCARD_SANCTION: BASE_URL + 'loanSanction',

    REPEAT_USER_CHECK: BASE_URL + 'repeatUser?userId=',

    SHEET_BY_CHOICE_NEW: BASE_URL + 'sheetDownloadUpdated',

    GIFTCARD_DETAIL_BY_USER_ID: BASE_URL + 'getGiftCardDetailByUserId?userId=',

    GET_MONTHLY_EMI: BASE_URL + 'getMonthlyEmi',


    GET_SINGLE_EMI_BREAK_UP: BASE_URL + 'loan/getLoanBreakDetailOfSinlgeEmiByEmiAndGiftCardId?giftCardId=',

    GIFTCARD_PAID: BASE_URL + 'paidGiftCard',

    CHANGE_EMI_STATUS_GIFT_CARD_PAID: BASE_URL + 'changeEMIStatuss?giftCardId=',

    EMI_PAID_SAVED_GIFT_CARD: BASE_URL + 'updateEmiToPaidForGiftCard',

    GET_GIFT_VOUCHER_DETAILS: BASE_URL + 'getVoucherDetailByGiftCardId?giftCardId=',

    GET_CRIF_ANALYSIS_DATA_NEW: BRE_BASE_URL + 'getCrifDataInJsonUpdatedV2?userId=',

    GET_FINBIT_DATA: BRE_BASE_URL + 'getFinBitData?userId=',

    GET_DIGITAB_BASIC_DATA: BRE_BASE_URL + 'getDigitapBasicData?userId=',
    GET_FRAUD_FILTER_LIST: BRE_BASE_URL + 'getFraudFilterList?userId=',
    GET_DIGITAP_DATA_BY_TYPE: BRE_BASE_URL + 'getDigitapDataByType?userId=',

    GENERATE_COLLECTION_REPORT: BASE_URL + 'generateCollectionReport?startDate=',

    GET_FINBIT_DATA_DETAILS: BRE_BASE_URL + 'getAccountUUID?userId=',

    GET_ENACH_DEACTIVATION_BY_USERID: BASE_URL + 'enashAndEsign/getENachDeactivationbyUserId?userId=',

    GET_ENACH_DEACTIVATION_BY_LOANID: BASE_URL + 'enashAndEsign/getENachDeactivationbyLoanId?loanId=',

    ENACH_DEACTIVATION_BY_USERID_AND_LOANID: BASE_URL + 'enashAndEsign/saveENachDeactivation',

    GET_ASSIGN_FOR_COLLECTION: BASE_URL + 'getAssignForCollection',

    SAVE_FOR_COLLECTION: BASE_URL + 'saveAssignForCollection',

    BULK_NACH_BOUNCE_BY_CSV: BASE_URL + 'updateNachBounceOfCsv',

    BULK_PAYMENT_LEADS: BASE_URL + 'getLeadsForBulkPayment?type=',

    DOWNLOAD_INCOMING_PAYMENT_REPORT: BASE_URL + 'getIncomingPaymentReport?dateFrom=',

    NEXOPAY_USER_REGISTRATION: BASE_URL + 'directUserRegistration',



    GET_DASHBOARD_COUNT_FOR_STATUS: BASE_URL + 'getDashBoardCountForStatus?empId=',



    ESIGN_AND_ENACH_INITIATE_NEW: BASE_URL + 'eSignRequest?loan_id=',

    WIDGET_API: BASE_URL + 'widgetToken?loan_id=',

    RFD_API: BASE_URL + 'loan/changeLoanSubStatus?loanId=',

    GET_DOCKET_INFO: BASE_URL + 'getDocketInfo?loan_id=',

    GET_SIGNATURE_STATUS: BASE_URL + 'getSignatureStatus?document_id=',

    BULK_ICICI_PAYMENT: BASE_URL + 'bulkIciciTransactionV2',
    BULK_ICICI_PAYMENT_EV: BASE_URL + 'bulkIciciTransactionV2EV',

    BULK_VERIFY_TRANSACTION: BASE_URL + 'bulkVerifyTransactionV2',

    BUDDY_LOAN_COMPLETE_DATA: BASE_URL + 'getBuddyLoanCompleteData?dateFrom=',

    BUDDY_LOAN_APPLIED_DATA: BASE_URL + 'getBuddyLoanAppliedData?dateFrom=',

    APPLICATION_STATUS_DETAIL_USER: BASE_URL + 'userDetails/alluserDetailByUserIdInComplete?userId=',

    UPDATED_APPLICATION_STATUS: BASE_URL + 'userDetails/alluserDetailUpdated?pageNumber=',
    UPDATED_APPLICATION_STATUS_EV: BASE_URL + 'userDetails/alluserDetailUpdatedEV?pageNumber=',

    AUTOMATION_MAIL_LOGS_UPDATED: BASE_URL + 'getAutomationMailLogUpdated?type=',

    AUTOMATION_TYPES: BASE_URL + 'getAutomationMailLogTypes',

    MOBILE_VERIFIY_API: BASE_URL + 'makeMobileVerified?userId=',

    GET_COMPANY_PERFORMANCE_COUNT: BASE_URL + 'getCompletePerformanceCount?startDate=',

    DELETE_FACEBOOK_USER_DATA: BASE_URL + 'deleteFaceBookAccountDetail?userId=',

    GET_RAZORPAYDATA: BASE_URL + 'getRazorPayReportData?dateFrom=',

    GET_FLIPKART_BALANCE: BASE_URL + 'getFlipkartBalance',

    USER_REFERENCE_SAVE_API: BASE_URL + 'userDetails/saveUserReferences?userId=',

    GET_USER_REFERENCE: BASE_URL + 'userDetails/getUserReferences?userId=',

    MARK_APPLICATION_INCOMPLETE: BASE_URL + 'markApplicationInComplete?userId=',

    GET_COMPANY_PERFORMANCE_COUNT_DEPARTMENT: BASE_URL + 'getCompletePerformanceCountByDepartment?startDate=',

    DEPARTMENTWISE_LOAN_COUNT: BASE_URL + 'getDepartmentWiseLoanCount?date=',

    BADA_BUISNESS_LEAD_CREATE_API: BASE_URL + 'saveBazarBussinessLead',

    DOWNLOAD_DEPARTMENTWISE_DATA: BASE_URL + 'downloadCompletePerformanceCountByDepartment?startDate=',

    BADA_BUISNESS_TRIGGER_API: BASE_URL + 'badaBussinessTrigger?applicationId=',

    // BADA_BUISNESS_TRANSACTION: BASE_URL + 'getBadaBusinessTransactionDetails?loanId=',

    GET_PAN_PROFILE_DETAILS: BASE_URL + 'karza/api/getPanProfileDetails?user_id=',

    GET_PAN_PROFILE_POST_CALL: BASE_URL + 'karza/api/panStatusCheck?user_id=',

    GET_AADHAR_VERIFICATION_DETAILS: BASE_URL + 'karza/api/getAadhaarVerificationDetails?user_id=',

    GET_AADHAR_XML_DETAILS: BASE_URL + 'karza/api/getAadhaarXmlDetailByUserId?user_id=',

    GET_AADHAR_XML_DATA: BASE_URL + 'karza/api/getAadhaarXmlDataByUserId?user_id=',

    POST_CALL_DIGILOCKER: BASE_URL + 'karza/api/downloadXmlAadhaarDigiLocker?user_id=',

    // POST_CALL_AADHAR_VERFICATION: BASE_URL + 'karza/api/aadhaarNumberVerification?user_id=',
    POST_CALL_AADHAR_VERFICATION: 'xyz',

    GET_MANUAL_ASSIGNED_LEADS: BASE_URL + 'loanLeadTestingManualAssignment?status=',

    //card utility api//

    CARD_UTILITY: CARD_URL + '/cardUtility',

    GET_ALL_CARD_USERS: CARD_URL + '/getAllCardLeads?pageNumber=',

    GET_CARD_USER_DETAIL_BY_USER_ID: CARD_URL + '/getUserDetails?userId=',

    GET_TRANSACTION_DETAIL_BY_USER_ID: CARD_URL + '/getTransactionDetailsByUserId?userId=',

    GET_BANK_DETAIL_BY_USER_ID: CARD_URL + '/getBankDetails?userId=',

    GET_ADDRESS_DETAIL_BY_USER_ID: CARD_URL + '/getAddressDetails?userId=',

    GET_CARD_LIMIT_BY_USER_ID: CARD_URL + '/getCardLimitHistory?userId=',

    GET_CARD_DETAILS_BY_USER_ID: CARD_URL + '/getCardDetailsByUserId?userId=',

    EDIT_CARD_BANK_DETAILS: CARD_URL + '/addBankDetail',

    EDIT_CARD_ADDRESS_DETAILS: CARD_URL + '/addAddress',

    EDIT_CARD_BASIC_DETAILS: CARD_URL + '/addPhocketUser',

    ADD_FALCON_VIRTUAL_CARD: CARD_URL + '/addFalconVirtualCard?userId=',

    ADD_CARD_FUNDS: CARD_URL + '/addFunds',

    ADD_FALCON_USER: CARD_URL + '/addFalconUser?userId=',

    GET_ALL_CARD_STATUS: CARD_URL + '/getAllStatus?type=',

    GET_CARD_FUNDS_DETAIL: CARD_URL + '/getFunds?cardId=',

    UPLOAD_CARD_CSV: CARD_URL + '/uploadCardUserCreationCsvFile',

    COMPLETE_ZERO_TOUCH_KYC: CARD_URL + '/completeZeroTouchKYC?userId=',

    SAVE_FOLLOW_UP_STATUS_CARD: CARD_URL + '/saveCardApplicationStatus?cardId=',

    GET_CARD_TRANSACTION_DETAILS: CARD_URL + '/getTransactionDetailByUserId?userId=',

    PAN_AUTHENTICATION_API: BASE_URL + 'karza/api/panAuthenticationCheck?user_id=',

    GET_CARD_ACTIVITY_API: CARD_URL + '/getUserActivityById?userId=',

    ENABLE_OR_DISABLE_CARD: CARD_URL + '/enableDisableCard?userId=',

    BLOCK_CARD: CARD_URL + '/blockCard?userId=',

    GET_TESTING_CARD_LEADS: CARD_URL + '/getCardLoanLeads',

    CARD_STATUS_DATA: CARD_URL + '/getCardStatusDetail?cardId=',

    GET_CVV: CARD_URL + '/getCardCVV?cardId=',

    CARD_POLICY_DETAILS: CARD_URL + '/getCardPolicy?cardId=',

    ENABLE_DISABLE_CAHNNEL: CARD_URL + '/enableDisableChannel?cardId=',

    GET_RAJORPAY_ORDER_ID_CARD: CARD_URL + '/enachAndEsign/getRazorPayOrderIdCustomerId?userId=',

    GET_UPDATE_LOAN_AGREEMENT_URL: CARD_URL + '/enachAndEsign/getLoanUrlUpdated?userId=',

    GET_CARD_LOAN_LEADS: CARD_URL + '/getCardLoanLeads?status=',

    TODAYS_LOAN_COUNT_CARD: CARD_URL + '/todaysLoanCount?date=',

    USER_DETAIL_BY_ID_CARD: CARD_URL + '/userDetails/userDetailById?userId=',

    USER_DETAIL_BY_LOANID_CARD: CARD_URL + '/getLoanDetailByLoanIdNew?userId=',

    GET_PAN_PROFILE_DETAILS_CARDS: CARD_URL + '/karza/api/getPanProfileDetails?user_id=',

    GET_CARD_LOAN_DETAIL_BY_USER_ID: CARD_URL + '/getCardLoanDetailByUserId?userId=',

    EMI_DETAIS_GET_CARDS: CARD_URL + '/getemitopayuser/',

    GET_EMI_HISTORY_CARDS: CARD_URL + '/getAllLoanEmiForUserGiftCard/',

    GET_EMIS_HISTORY_CARDS: CARD_URL + 'getallemiforadminbyuser/',

    GET_TRANSACTIONS_CARDS: CARD_URL + '/getTransaction?userId=',

    GET_LOAN_INSTALLMENT_CARDS: CARD_URL + '/loan/getLoanEmiDetailByLoanId?loanId=',

    STATUS_ACTIVITY_DATA_CARDS: CARD_URL + '/loan/getLoanTrack?loanId=',

    GET_ENACH_LOAN_DETAIL_CARD: CARD_URL + '/enachAndEsign/getUserDetailsByUserId?userId=',

    APPROVE_REJECT_REASON_CARD: CARD_URL + '/approveRejectReason?status=',

    RAJORPAY_CALLBACK_CARD: CARD_URL + '/enachAndEsign/razorPayCallBack?type=',

    GET_EMI_HISTORY_CARDS: CARD_URL + '/getallemiforadminbyuser/',

    BANK_VERIFICATION_API: BASE_URL + 'setu/verifyBank?ifsc=',
    BANK_VERIFICATION_SYNG3_API: BASE_URL + 'bank-verification/verify/sign3-pennydrop?userId=',
    BANK_VERIFICATION_DIGITAP_API: BASE_URL + 'digitapBankAccountVerification?userId=',
    BANK_VERFICATION_SYNZY_API: BASE_URL + 'hybridBankAccountVerification?userId=',

    // GET_BANK_ACCOUNT_VERIFICATION_BY_USERID : BASE_URL + 'karza/api/getBankAccVerificationByUserId?user_id=',
    // BANK_VERIFICATION_API: BASE_URL + 'karza/api/bankAccountCheck?ifsc=',

    ESIGN_AND_ENACH_INITIATE_NEW_CARDS: CARD_URL + '/eSignRequest?userId=',

    WIDGET_API_CARDS: CARD_URL + '/widgetToken?userId=',

    GET_DOCKET_INFO_CARDS: CARD_URL + '/getDocketInfo?userId=',

    GET_SIGNATURE_STATUS_CARDS: CARD_URL + '/getSignatureStatus?document_id=',

    ADD_PHYSICAL_CARD_API: CARD_URL + '/addFalconPhysicalCard?userId=',


    //TeaGarden
    GET_USER_DETAILS_BY_EMPID: BASE_URL + 'getUserDetailByEmpId?empId=',

    UPLOAD_TEA_GARDEN_USERS: BASE_URL + 'uploadCSV',

    SAVE_OR_UPDATE_BASIC_DETAILS_TEA_FLOW: BASE_URL + 'addOrUpdateUserDetailTeaGarden',

    APPLY_TEA_GARDEN_LOAN: BASE_URL + 'saveLoanDataTeaGarden',

    ADD_AMBASSADOR_TEA_GARDEN: BASE_URL + 'addAmbassador',

    GET_ALL_TEA_GARDEN_LIST: BASE_URL + 'getAllGardenDetail?pageNumber=',

    GET_ALL_TEA_GARDEN_AMBASADOR_LIST: BASE_URL + 'getAllAmbassador?pageNumber=',

    GET_USERS_DETAILS_BY_USER_ID: BASE_URL + 'getUserDetailByUserId?userId=',

    TEA_GARDEN_AMBASADOR_LOGIN: BASE_URL + 'processOtp?mobileNumber=',

    VERIFY_AMBASADOR_OTP: BASE_URL + 'verifyOtp?mobileNumber=',

    GET_AMBASSADOR_DETAILS_BY_USER_ID: BASE_URL + 'getAmbassadorDetailByUserId?userId=',

    GET_AMBASSADOR_LEADS: BASE_URL + 'loanLeadAmbassador?status=',

    PAN_VERIFICATION_KARZA: BASE_URL + 'karza/api/panAuthenticationCheck?user_id=',

    APPLY_GIFT_CARD_API_TEA_GARDEN: BASE_URL + 'applyForTeaGiftCard',

    TEA_GARDEN_GIFT_CARD_LEADS: BASE_URL + 'loanLeadTestingNewGiftCard?status=',

    GIFTCARD_AMBASSADOR_LEADS: BASE_URL + 'phocketGiftCardLoanAmbassador?status=',

    UPLOAD_TEA_GARDEN_ATTENDANCE: BASE_URL + 'uploadAttendance',

    UPLOAD_TEA_GARDEN_WAGES: BASE_URL + 'getWagesJson',

    THIRD_USER_ACIVE_INACTIVE: BASE_URL + 'changeEventUserActiveInActiveStatus?status=',

    GET_DBR_CALCULATION_DETAILS_BY_USER_ID: BRE_BASE_URL + 'loan/getDbrScores?userId=',

    SAVE_DBR_SCORES: BRE_BASE_URL + 'loan/DBRCalculation',

    GET_DBR_ALL_DATA: BRE_BASE_URL + 'loan/getDbrDetails?userId=',

    GET_REPEAT_AUTOMATION_USER_ID: BRE_BASE_URL + 'loan/getRepeatAutomation?userId=',

    GET_TEA_USER_BY_PAN: BASE_URL + 'getUserDetailByPan?pan=',

    UPLOAD_STAMP_DUTY_ALL: BASE_URL + 'splitAndUploadStampDutyPdf',

    GET_STAMP_DUTY: BASE_URL + 'getStampDuty?usedStatus=',

    GET_STAMP_DUTY_COUNT: BASE_URL + 'getStampDutyCount?usedStatus=',

    KYC_FORM_APP: BASE_URL + 'loan/changeKycStatus?loanId=',

    BULK_ASSIGN_VIA_CSV: BASE_URL + 'bulkAssignmentLeads',

    CHANGE_EMPID_TEA_GARDEN: BASE_URL + 'changeEmpIdTeaGarden?teaGardenId=',

    GET_BRANCH_DATA: BASE_URL + 'getBranchData?sDate=',

    RECEIPT_DOWNLOAD_TEA: BASE_URL + 'generateTeaGardenReciept?loanId=',

    SAVE_BANK_DETAIL: BASE_URL + 'userDetails/addAccountDetailsBnplReownDevice',



    EMI_CALCULATOR_CARD: BASE_URL + 'getMonthlyEmi/',

    PAYMENT_TRANSFER_API_RAZORPAY: BASE_URL + 'enashAndEsign/transferRazorpay?amount=',

    GET_RAZORPAY_TRANSACTION: BASE_URL + 'enashAndEsign/getTransferData?noOfEntry=',

    UPLOAD_NBFC_LOGO: BASE_URL + 'uploadNbfcLogo?nbfcName=',

    NBFC_PRODUCT_CONFIG_SAVE: BASE_URL + 'saveOrUpdateLoanUtility',

    GET_PRODUCT_BY_NBFC_ID: BASE_URL + 'getLoanUtility?nbfcId=',

    GET_PRODUCT_NBFC_COUNT: BASE_URL + 'getLoanUtilityCount?nbfcId=',

    SAVE_PROCESSING_CHARGES: BASE_URL + 'saveOrUpdateProcessingFee',

    GET_PROCESSING_FEE_COUNT: BASE_URL + 'getProcessingFeeCount?nbfcId=',

    GET_NBFC_CHARGES: BASE_URL + 'getProcessingFee?nbfcId=',

    SAVE_ESIGN_CONFIG: BASE_URL + 'saveOrUpdateEsignConfig',

    SAVE_ENACH_CONFIG: BASE_URL + 'saveOrUpdateEnachConfig',

    GET_ESIGN_CONFIG: BASE_URL + 'getEsignConfig?nbfcId=',

    GET_ESIGN_CONFIG_COUNT: BASE_URL + 'getEsignConfigCount?nbfcId=',

    GET_ENACH_CONFIG: BASE_URL + 'getEnachConfig?nbfcId=',

    GET_ENACH_CONFIG_COUNT: BASE_URL + 'getEnachConfigCount?nbfcId=',

    CREATE_BILL_DESK_ORDER: BASE_URL + 'createMandateOrder?loanId=',

    SAVE_MANDATE_DETAILS_BILL_DESK: BASE_URL + 'saveMandateDetails',

    CREATE_PAYMENT_LINK: BASE_URL + 'createPaymentLink?loanId=',

    CREATE_PAYMENT_BY_LINK_ID: BASE_URL + 'createPaymentOrderByLinkId?linkId=',

    SAVE_PAYMENT_DETAILS_BILL_DESK: BASE_URL + 'saveTransactionDetails',

    GET_PAYMENT_DETAILS_BY_LINKID: BASE_URL + 'getTransactionDetailByLinkId?linkId=',

    GET_API_COSTING_DATA: BASE_URL + 'getApiCostingData',

    GET_THIRD_PARTY_HIT_DATA: BASE_URL + 'getThirdPartyHitsByDate?startDate=',

    GET_FINBIT_HIT_STATS: BASE_URL + 'getFinBitHitStats?startDate=',

    UPDATE_COSTING: BASE_URL + 'updateApiCostingData',

    GET_BILL_DESK_TXN_BY_LOAN_ID: BASE_URL + 'getBillDeskTransactionByLoanId?loanId=',

    SAVE_BUISNESS_DATA_MANUAL: BASE_URL + 'saveManualBusinessReport',

    GET_BUISNESS_DATA_MANUAL: BASE_URL + 'getManualBusinessReport',

    GET_BUISNESS_REPORT_LIST: BASE_URL + 'getManualBusinessReportList?pageNumber=',

    GET_PERSONAL_ANALYSIS_REPORT: BRE_BASE_URL + 'karza/api/getPersonlAnalysis?userId=',

    GET_BILLDESK_NACH_REPORT: BASE_URL + 'getEnachDataLeadBillDesk?pageNumber=',

    // GET_BILLDESK_NACH_REPORT: 'https://backend.phocket.in/getEnachDataLeadBillDesk?pageNumber='
    GET_ANALYSIS_DASHBOARD_MATCH_DATA: BRE_BASE_URL + 'getAgregatedResult?userId=',

    GET_CONCLUDED_DATA: BRE_BASE_URL + 'getConcludedStats?userId=',

    GET_SMS_ANALYSIS_STATUS: BRE_BASE_URL + 'getSmsAnalysisStatus?userId=',

    GET_CRIF_ANALYSIS_STATUS: BRE_BASE_URL + 'getCrifAnalysisV2?userId=',
    // GET_CRIF_ANALYSIS_STATUS: BASE_URL + 'getCrifAnalysis?userId=',

    GET_FINBIT_ANALYSIS_DATA: BRE_BASE_URL + 'getFinBitAnalysis?userId=',

    GET_SIMILAR_ANALYSIS_DATA: BRE_BASE_URL + 'getSimilarProfileAnalytics?loanId=',

    GET_BRANCH_DATA_NEW: BASE_URL + 'getBranchStats?startDate=',

    DOWNLOAD_BRANCH_REPORT: BASE_URL + 'downloadBranchReport?dateFrom=',

    GET_FIDY_PAY_TRANSACTION_DETAILS: BASE_URL + 'enashAndEsign/getFidyPayTransactionId?loanId=',

    GET_EVENTS_LIST: BASE_URL + 'getEventList',

    SAVE_EMAIL_VERIFICATION_API: BASE_URL + 'saveEmailVerificationGenerateReport',

    CODE_VRIFY_MAIL: BASE_URL + 'mainEmailVerificationGenerateReport/emailVerfication/',

    VERIFY_REFRENCE_DETAILS: BASE_URL + 'userDetails/updateReferenceVerifiedStatus?userId=',

    SAVE_AGREEGATOR_DATA: BASE_URL_MARKETING + 'saveeventcampaigndata',

    SAVE_CREDIT_ASSESMENT_NOTES: BRE_BASE_URL + 'saveNotesForCreditAssessment',

    GET_CREDIT_ASSESSMENT_COMMENT: BRE_BASE_URL + 'getNotesForCreditAssessment?loanId=',

    GENERIC_FILE_UPLOAD_AND_GET_URL: BASE_URL + 'uploadpdfGeneric',

    GET_MARKETING_LIST: BASE_URL + 'getEventDataByPageNo?pageNumber=',

    GET_NBFC_BANK_CODE_BY_BANK_NAME: BASE_URL + 'getNbfcBankCodeByBankName?bankName=',

    GET_AGREEGATOR_LIST: BASE_URL_MARKETING + 'getAggregatorName',

    SAVE_BUDGET_PLAN: BASE_URL_MARKETING + 'saveOrUpdateMarketingMonthlyPlanning',

    SIGN_DESK_MANDATE: BASE_URL + 'createMandate?loanId=',

    GET_REASONS_API: BRE_BASE_URL + 'getDataAnalysisStatusByLoanId?loanId=',

    GET_CREDIT_LEADS_API: BRE_BASE_URL + 'getDataAnalysisStatusByPageNo?pageNo=',

    GET_EVENT_DATA_BY_PAGE: BASE_URL_MARKETING + "getAllEventPartnerData",
    GET_AGGREGATORE_LINK_DATA_BY_AGGREGATORID: BASE_URL_MARKETING + "getAggregatorLinkData?aggregatorId=",
    GET_AGGREGATORE_APPLICATION_LINK_DATA_BY_AGGREGATORID: BASE_URL_MARKETING + "getAggregatorApplicationData?aggregatorId=",
    DOWNLOAD_AGGREGATOR_LINK_DATA_BY_IDS: BASE_URL_MARKETING + "downloadAggregatorLinkData?aggregatorId=",
    DOWNLOAD_AGGREGATOR_APPLICATION_LINK_DATA_BY_IDS: BASE_URL_MARKETING + "downloadAggregatorApplicationData?aggregatorId=",
    DOWNLOAD_AGGREGATOR_LONK_DATA: BASE_URL_MARKETING + "downloadAggregatorLinkData",
    // GET_EVENT_DATA_BY_PAGE: BASE_URL_MARKETING + "getEventDataByPageNo?pageNumber=",

    // push leads
    GET_IN_COMPLETE_STATS_BY_AGGREGATOR: BASE_URL_MARKETING + "getInCompleteStatsByAggregator?aggregatorName=",
    GET_IN_COMPLETE_STATS_BY_AGGREGATOR_LEADS: BASE_URL_MARKETING + "getInCompleteStatsByAggregatorLeads?aggregatorName=",
    GET_IN_COMPLETE_STATS_BY_BRANCH: BASE_URL_MARKETING + "getInCompleteStatsByBranchData?partnerName=",
    GET_IN_COMPLETE_STATS_BY_BRANCH_LEADS: BASE_URL_MARKETING + "getInCompleteStatsByBranchDataLeads?partnerName=",

    // applied Leads

    GET_APPLIED_STATS_BY_AGGREGATOR_SUBMITTED: BASE_URL_MARKETING + "getAppliedCountStatsForAggregatorSubmited?from=&to=&aggregatorName=n",
    GET_APPLIED_STATS_BY_BRANCH: BASE_URL_MARKETING + "getAppliedCountStatsBranchData?from=",

    // configuration
    GET_AGGREGATOR_NAME: BASE_URL_MARKETING + "getAggregatorName",
    GET_AGGREGATOR_NAME_DISTINCT: BASE_URL_MARKETING + "assignAggregatorIds",



    GET_EVENT_DATA_BY_PARTNER_ID: BASE_URL_MARKETING + "getEventDataByPartnerId?partnerId=",
    GET_AGGREGATOR_PAYOUT: BASE_URL_MARKETING + "getAggregatorPayoutsByAggregatorId?aggregatorId=",
    ADD_AGGREGATOR_PAYOUT_SLAB: BASE_URL_MARKETING + "addAggregatorPayoutSlab",
    UPDATE_AGGREGATOR_PAYOUT_SLAB: BASE_URL_MARKETING + "updateAggregatorPayoutSlab",
    DELETE_AGGREGATOR_PAYOUT_SLAB: BASE_URL_MARKETING + "deleteAggregatorPayoutSlab?id=",

    // push leads
    GET_IN_COMPLETE_STATS_BY_PARTNER_ID: BASE_URL_MARKETING + "getInCompleteStatsByPartnerId?partnerId=",
    GET_IN_COMPLETE_DATA_BY_PARTNER_ID: BASE_URL_MARKETING + "getInCompleteDataByPartnerId?partnerId=",
    BULK_COMMUNICATION_BY_FORM_STATUS: BASE_URL_MARKETING + "bulkCommunicationByFormStatusPartnerId",

    // lead breakdown

    GET_BRANCH_STATS_BY_PARTNERID: BASE_URL_MARKETING + "getBranchStatsByPartnerId?partnerId=",
    GET_BRANCH_COMMUNICATE_BY_EVENT_NAME: BASE_URL_MARKETING + "getBranchCommunicateByEventName",

    // applied Leads

    GET_APPLIED_COUNT_STATS_BY_PARTNER_ID: BASE_URL_MARKETING + "getAppliedCountStatsByPartnerId?partnerId=",
    GET_APPLIED_DATA_BY_PARTNER_ID: BASE_URL_MARKETING + "getAppliedDataByPartnerId?partnerId=",

    // disbursed leads

    GET_APPLIED_DATA_BY_PARTNER_ID_LOAN_STATUS: BASE_URL_MARKETING + "getAppliedDataByPartnerId?partnerId=",
    GET_DISBURSED_COUNT_STATS_BY_PARTNER_ID: BASE_URL_MARKETING + "getDisbursedCountStatsByPartnerId?partnerId=",
    // configuration

    SAVE_OR_UPDATE_AGGREGATOR_PAYOUTS: BASE_URL_MARKETING + "saveOrUpdateAggregatorPayouts",
    GET_ANALYSIS_COUNT_API: BRE_BASE_URL + 'getDataAnalysisStats?sDate=',
    GET_COUNT_BY_STATUS_BY_PARTNER_ID: BASE_URL_MARKETING + "getCountByStatusByPartnerId?partnerId=",
    GET_DISBURSMENT_STATS: BASE_URL_MARKETING + "getDisbursmentStats?partnerId=",
    GET_REJECT_REASON_COUNT: BASE_URL_MARKETING + "getRejectReasonCount?partnerId=",
    GET_TOTAL_LEADS_RECIEVED: BASE_URL_MARKETING + "getTotalLeadsRecieved?partnerId=",
    GET_LEAD_PARTICULAR: BASE_URL_MARKETING + "getLeadParticular?partnerId=",
    GET_CONVERSTION_DETAILS: BASE_URL_MARKETING + "getConverstionDetails?partnerId=",
    GET_DEVIATION_REPORT: BASE_URL_MARKETING + 'deviationReport?startDate=',
    BULK_COMMUNICATION_BY_LOAN_STATUS: BASE_URL_MARKETING + 'bulkCommunicationByLoanStatusPartnerId',
    COMMUNICATE_VIA_FILTER: BASE_URL + 'communicateByFilter?startDate=',
    BUISNESS_FROM_AGREEGATORS: BASE_URL_MARKETING + 'businessFromAggregators?startDate=',
    GET_AUTOMATION_LOGS_NEW: BASE_URL + 'getAutomationMailLogUpdatedNew?startDate=',
    GET_AUTOMATION_LOGS_COUNT: BASE_URL_MARKETING + 'getAutomationMailLogCount?startDate=',
    GET_EVENTS_COUNTS: BASE_URL_MARKETING + 'getEventListCount?pageNumber=',
    GET_LEAD_PARTICULAR_OVERALL: BASE_URL_MARKETING + 'getMarketingLeadParticular?startDate=',
    GET_DASHOBARD_COUNTS_MARKETING: BASE_URL_MARKETING + 'getAggregatorDashboard?startDate=',
    GET_OVERALL_DASHBOARD_COUNTS: BASE_URL_MARKETING + 'getMarketingCounts?startDate=',
    GET_LEADS_COUNT_DASHBOARD_DATA: BASE_URL_MARKETING + 'getMarketingLeadCountDetails?startDate=',
    GET_DEVIATION_COUNT: BASE_URL_MARKETING + 'getMarketingDeviationReport?startDate=',
    GET_REJECT_REASON_COUNT_OVERALL: BASE_URL_MARKETING + 'getMarketingRejectReasonCount?startDate=',
    GET_DISBURSE_OVERALL_COUNT: BASE_URL_MARKETING + 'getMarketingDisbursmentStats?startDate=',
    GET_CREDIT_ANALYSIS_DATA: BRE_BASE_URL + 'getPolicyDetailsByLoanIdList?userId=',
    GET_ALL_POLICY_LIST: BRE_BASE_URL + 'getCreditPolicyByPageNo?pageNo=1&count=100',
    SAVE_OR_UPDATE_POLICY_DETAILS: BRE_BASE_URL + 'saveOrUpdateCreditPolicy',
    SAVE_OR_UPDATE_CREDIT_POLICY_LIST: BRE_BASE_URL + 'savePolicyDetailsList',
    GET_AGREEGATOR_CONFIG_BY_AGREEGATOR_ID: BASE_URL_MARKETING + 'getAggregatorPayoutsListByAggregatorId?aggregatorId=',
    GET_AGREEGATOR_MONTHLY_PLANING_BY_ID: BASE_URL_MARKETING + 'getMarketingMonthlyPlanningListByAggregatorId?aggregatorId=',
    GET_LOS_APPLICATION: BI_URL + 'api/loan_origination_system/application',
    GET_LOS_APPLICATION_OPPORTUNITY: BI_URL + 'api/loan_origination_system/Opportunity',
    GET_GENDER: BI_URL + 'api/loan_origination_system/gender',
    GET_DEVICE: BI_URL + 'api/loan_origination_system/device',
    GET_AGE_ANALYSIS: BI_URL + 'api/loan_origination_system/Age',
    GET_GROUP_SALARY: BI_URL + 'api/loan_origination_system/Groupped_salary',
    GET_OCCUPATION_ANALYSIS: BI_URL + 'api/loan_origination_system/Occupation',
    GET_AGE_COUNT: BI_URL + 'api/loan_origination_system/Age',
    GET_STATE_COUNT: BI_URL + 'api/loan_origination_system/State',
    GET_AVERAGE_LOAN_DETAILS: BI_URL + 'api/loan_origination_system/Average_loan_details',
    GET_APPLY_VS_APPROVE: BI_URL + 'api/loan_origination_system/ApplyVSapprove_system',
    GET_APPLY_VS_REJECT: BI_URL + 'api/loan_origination_system/rejectVSapprove_system1',
    GET_MANDATE_DATA_BY_REF_ID: BASE_URL + 'getMandateStatusByRefId?refId=',
    AADHAAR_CONSENT_API: BASE_URL + "karza/api/consentAadhaarNumberVerification?user_id=",

    INITIATE_AADHAAR_CONSENT: BASE_URL + "karza/api/initiateAadhaarConsent?user_id=",
    GET_AADHAAR_OTP: BASE_URL + 'karza/api/getAadhaarOtp?user_id=',
    SHARE_CODE_API: BASE_URL + 'karza/api/downloadAadhaarXml?user_id=',
    GET_USER_DATA: BASE_URL + 'userDetails/getUserDetailsByUserId?userId=',
    UPDATE_KYC_DETAILS: BASE_URL + 'userDetailsUpdated/updateKycDetails?userId=',
    GET_PAN_NOTIFY: BASE_URL + 'userDetailsUpdated/getKycNotify?userId=',
    GET_EMI_REDUCING_USER: BASE_URL + 'getemitopayReducinguser/',
    GET_EMI_REDUCING_USER_Ev: BASE_URL + 'getemitopayReducinguserEV/',
    GET_CRIF_ACCESS_CHECK: BRE_BASE_URL + 'getCreditReportAccessByUserId?userId=',
    SAVE_CREDIT_CONFIG: BRE_BASE_URL + 'saveOrUpdateCreditAttributePt',
    MAP_CREDIT_POLICY: BRE_BASE_URL + 'saveOrUpdateCreditToAttr',
    GET_CONFIGURATION: BRE_BASE_URL + 'getCreditAttributePtByPageNo?pageNumber=',
    SAVE_MAPPING: BRE_BASE_URL + 'saveOrUpdateCreditToAttr',
    GET_MAPPED_DATA: BRE_BASE_URL + 'getCreditToAttrByPageNoPolicyId?pageNumber=',
    DELETE_MAPPING_API: BRE_BASE_URL + 'deleteCreditToAttrByCreditAttId?creditAttId=',
    DETELE_POLICY_API: BRE_BASE_URL + 'deleteCreditPolicyByPolicyId?policyId=',
    DETELE_ATTRIBUTE_API: BRE_BASE_URL + 'deleteCreditAttributePtByCreditAttId?creditAttId=',
    SEND_NOC_API: BASE_URL + 'loan/sendNocToUser?loanId=',
    FINBIT_ANALYSIS_API: BRE_BASE_URL + 'getFinBitAnalysis?userId=',
    DOWNLOAD_API_FILE: BASE_URL + 'downloadTrackerReport',
    GET_DEVIATION_VALUES: BRE_BASE_URL + 'getDeviationPts',
    SAVE_DEVIATION_POINT: BRE_BASE_URL + 'saveDeviationPts',
    UPLOAD_STATEMENT_TO_FINBIT: BRE_BASE_URL + 'getFinBitDataOnUpload?userId=',
    UPLOAD_STATEMENT_FOR_PARSING: BRE_BASE_URL + 'uploadStatementForParsing?userId=',
    SHOW_DISABLE_ESIGN: BASE_URL + 'userDetailsUpdated/getEsignRepeatFlag?userId=',
    GET_LOAN_DETAIL_BY_USERID_OPTIMISED: BASE_URL + 'getLoanDetailByUserIdOptimised?userId=',
    GET_LOAN_LEADS_NEW_API: BASE_URL + 'loanLeadTestingNewNew?status=',
    GET_LOAN_DISBURSED_LEADS_NEW_API: BASE_URL + 'loanDisburseDataByDisburseDate?startDate=',
    GET_LOAN_DISBURSED_DOWNLOAD_LEADS_NEW_API: BASE_URL + 'loanDataByDateExcel?startDate=',
    GET_LOAN_LEADS_NEW_EV_API: BASE_URL + 'loanLeadTestingNewNewEV?status=',
    // GET_COMMENTS_API: BASE_URL + 'getCommentForLeads?status=',

    GET_LEAD_PARTICULAR_LEADS_DATA_DATE_WISE: BASE_URL + 'getMarketingLeadParticularDateWise?startDate=',
    NEW_ACTIVITY_LOGS_API: BASE_URL + 'loan/getLoanTrackUpdated?loanId=',
    GET_OPERATION_CHECK_DATA: BASE_URL + 'getOperationCheckInfo?userId=',
    GET_OPERATION_FLOW: BASE_URL + 'getOperationFlowStatus?userId=',
    QUALITY_CHECK_API: BASE_URL + 'updateQualityCheck?loanId=',
    NEW_ACTIVITY_LOGS_API_SHORT: BASE_URL + 'loan/getLoanTrackLimit?loanId=',
    LEAD_MANAGEMENT_COUNT: BASE_URL + 'getLeadManagmentCounts?empId=',
    LEAD_MANAGEMENT_LEADS_API: BASE_URL + 'loanLeadTestingNewBucket?status=',
    GET_DASHBOARD_GRAPH_LM: BASE_URL + 'getOverAllDashboardCount?startDate=',
    GET_EMAIL_ID_VIA_DEPARTMENT: BASE_URL + 'getEmpIdByDepartmentList',
    DELETE_ASSIGNED_ENTRY: BASE_URL + 'deleteAssignApplicationById?id=',
    GET_SALARY_WISE_COUNT_DASHBOARD_DATA: BASE_URL_MARKETING + 'salaryRangeWiseCount?startDate=',
    GET_AGE_WISE_COUNT_DASHBOARD_DATA: BASE_URL_MARKETING + 'ageRangeWiseCount?startDate=',
    GET_EMI_WISE_COUNT_DASHBOARD_DATA: BASE_URL_MARKETING + 'emiWiseCount?startDate=',
    GET_GENDER_WISE_COUNT_DASHBOARD_DATA: BASE_URL_MARKETING + 'genderWiseCount?startDate=',
    GET_LOAN_STATUS_WISE_COUNT_DASHBOARD_DATA: BASE_URL_MARKETING + 'loanStatusWiseCount?startDate=',
    GET_REJECT_REASON_WISE_COUNT_DASHBOARD_DATA: BASE_URL_MARKETING + 'rejectReasonWiseCount?startDate=',
    GET_STATE_WISE_COUNT_DASHBOARD_DATA: BASE_URL_MARKETING + 'stateWiseCount?startDate=',
    SAVE_UNDERWRITTER_API: BRE_BASE_URL + 'saveUnderWriterDecision',
    GET_NOTES_API_NEW: BRE_BASE_URL + 'getNotesListForCreditAssessment?loanId=',
    GET_ANALYSIS_API_NEW: BASE_URL + 'karza/api/getKycAnalsis?userId=',
    CREDIT_ANALYSIS_NEW_API: BRE_BASE_URL + 'getAnalysisFinBitSmsSalaryAnalysis?userId=',
    GET_COMMENTS_API: BASE_URL + 'getCommentForLeadsBucket?status=',
    SAVE_WORKING_HISTRORY_API: BRE_BASE_URL + 'saveCreditWorkingHistory',
    GET_WORKING_HISTORY_DATA: BRE_BASE_URL + 'getWorkingHistoryByUserId?userId=',
    GET_ORG_DETAILS: BRE_BASE_URL + 'getOrganizationAnalysis?userId=',
    REPEAT_USER_CHECK_UPDATED: BASE_URL + 'repeatUserUpdated?userId=',
    GET_ALL_FORM_STATS: BASE_URL_MARKETING + 'getInCompleteStats?startDate=',
    DOWNLOAD_REPEAT_DATA: BASE_URL + 'downloadRepeatData?empId=',
    CHECK_MOBILE_EXIST: BASE_URL + 'checkMobileExists?mobileNo=',
    GET_SCORE_CATEGORY_LIST: BRE_BASE_URL + 'getScoreCategoryList',
    SAVE_SCORE_CATEGORY_LIST: BRE_BASE_URL + 'saveOrUpdateCreditScoreCategory',
    GET_POINTERS_CATEGORY_LIST: BRE_BASE_URL + 'getCreditScoreConfigList',
    GET_SAVED_CATEGORY_BY_USERID: BRE_BASE_URL + 'getUserCreditScoreByUserId?userId=',
    PROJECTION_DATA_MONTHS: BASE_URL_MARKETING + 'projection?noOfMonths=',
    GET_AUTOMATED_SCORING: BRE_BASE_URL + 'getAutomatedScoringByUserId?userId=',
    SAVE_POINTERS_MAP_API: BRE_BASE_URL + 'saveOrUpdateCreditScoreConfig',
    SAVE_SCORE_OF_AUTOMATED: BRE_BASE_URL + 'getDbrCalculationNewScoring',
    FACE_MATCH_API: BASE_URL + 'karza/api/getFaceSimilarityResult?userId=',
    GET_FACE_DATA: BASE_URL + 'karza/api/getFaceSimilarityDetailsByUserId?userId=',
    READ_LOAN_ID_CSV: BASE_URL + 'readCSVOfUpdateLoanId',
    SAVE_LOAN_ID_CSV: BASE_URL + 'updateLoanIdByCSV',
    PROJECTION_DAY_WISE: BASE_URL_MARKETING + 'projectionPerDay?noOfMonths=',
    DELETE_RAZORPAY_TOKEN: BASE_URL + 'enashAndEsign/deleteTokenByUserIdList',
    // DATA_FOR_RECONCILAIATION: BASE_URL + 'getPaymentsDataForReconciliation?startDate=',
    UPLOAD_RAZORPAY_REPORT: BASE_URL + 'getRazorpayReportCsv',
    GET_COUNT_RECONCILAIATION: BASE_URL + 'getSelectedReconciliationCount',
    GET_DATA_BY_TYPE: BASE_URL + 'getSelectedReconciliationDataByType',
    GET_OPERATIONS_EMPLOYEE: FINANCE_BACKEND + 'operations/getTeamMembers?page=',
    GET_PERFORMANCE_DATA_BY_EMAIL: BASE_URL + 'operations/report?startDate=',
    GET_THIRD_PARTY_HIT_COUNT_BY_APPLICATIONID: BASE_URL + 'getThirdPartyHitCountsByApplicationId?applicationId=',
    GET_VERIFIED_BANK_DETAILS_API: BASE_URL + 'karza/api/getBankAccVerificationByUserId?user_id=',
    GET_OPETRATION_PERFORMANCE_API: FINANCE_BACKEND + 'operations/empPerformanceAnalysis?startDate=',
    GET_SOFTAPPROVAL_API: FINANCE_BACKEND + 'operations/empCommentStats?startDate=',
    DOWNLOAD_KARZA_REPORT_BY_TYPE: BASE_URL + 'downloadKarzaReportByType',
    GET_LOAN_COUNT_BY_DATE: BASE_URL + 'getLoanCountByDate',
    KYC_START_STOP_API: BASE_URL + 'updateRepeatKyc?flag=',
    GET_KYC_FLAGS: BASE_URL + 'getKycFlags',
    GET_SMALL_DASHBOARD_OPERATION_API: BASE_URL + 'operations/getPerformanceStats?startDate=',
    OPERTAIONS_TABULAR_DATA_API: BASE_URL + 'operations/detailProcessReport?startDate=',
    DOWNLOAD_OPERATION_REPORT_API: FINANCE_BACKEND + 'operations/detailProcessReportDownload?startDate=',
    GET_PENDING_KYC_LEADS: BASE_URL + 'karza/api/getPendingKycList?startDate=',
    BULK_RFD_BY_NBFC: BASE_URL + 'rfdLeadByNbfc',
    INITIATE_SETU_OKYC: BASE_URL + 'setu/initiateOKyc',
    SETU_VERIFY_PAN: BASE_URL + 'setu/verifyPan?pan=',
    PAN_EXTENSIVE_SIGNZY_VERIFY_PAN: BASE_URL + 'panExtensiveSignzy?userId=',
    PAN_EXTENSIVE_SIGNZY_BY_ID: BASE_URL + 'panExtensiveSignzy?userId=',
    CREATE_SIGNZY_DIGILOCKER_REQUEST_BY_USERID: BASE_URL + 'createSignzyDigiLockerRequest?userId=',
    CREATE_DIGILOCKER_REQUEST_BY_USERID: BASE_URL + 'createDigitapDigilockerRequest?userId=',
    SEND_OTP_KYC_VERIFY: BASE_URL + 'setu/verifyOKyc?aadhaarNo=',
    COMPLETE_AADHAR_KYC: BASE_URL + '/setu/completeOKyc?otp=',
    UPLOAD_STATEMENT_FOR_PARSING_DIGITAP: BRE_BASE_URL + 'uploadStatementForParsing?userId=',
    GET_DIGITAB_BASIC_DATA: BRE_BASE_URL + 'getDigitapBasicData?userId=',
    GET_FRAUD_FILTER_LIST: BRE_BASE_URL + 'getFraudFilterList?userId=',
    GET_DIGITAP_DATA_BY_TYPE: BRE_BASE_URL + 'getDigitapDataByType?userId=',
    GET_BANK_STATEMENT_PARSE_SOURCE: BRE_BASE_URL + 'getstatementparsesource?userId=',
    GET_CUSTOMER_SERVICE_EMPLOYEE: FINANCE_BACKEND + 'businessDevelopment/getTeamMembers?page=',
    GET_PERFORMANCE_DATA_BY_EMAIL_CUSTOMER_SERVICE: BASE_URL + 'businessDevelopment/report?startDate=',
    GET_CUSTOMER_SERVICE_PERFORMANCE_API: FINANCE_BACKEND + 'businessDevelopment/empPerformanceAnalysis?startDate=',
    GET_SOFTAPPROVAL_API_CUSTOMER_SERVICE: FINANCE_BACKEND + 'businessDevelopment/empCommentStats?startDate=',
    GET_SMALL_DASHBOARD_OPERATION_API_CUSTOMER_SERVICE: BASE_URL + 'businessDevelopment/getPerformanceStats?startDate=',
    OPERTAIONS_TABULAR_DATA_API_CUSTOMER_SERVICE: BASE_URL + 'businessDevelopment/detailProcessReport?startDate=',
    DOWNLOAD_OPERATION_REPORT_API_CUSTOMER_SERVICE: BASE_URL + 'businessDevelopment/detailProcessReportDownload?startDate=',
    GET_REPEAT_FRESH_EMPLOYEE: FINANCE_BACKEND + 'credit/freshCredit/getTeamMembers?page=',
    GET_PERFORMANCE_DATA_BY_EMAIL_REPEAT_FRESH: BASE_URL + 'credit/freshCredit/report?startDate=',
    GET_REPEAT_FRESH_PERFORMANCE_API: FINANCE_BACKEND + 'credit/freshCredit/empPerformanceAnalysis?startDate=',
    GET_SOFTAPPROVAL_API_REPEAT_FRESH: FINANCE_BACKEND + 'credit/freshCredit/empCommentStats?startDate=',
    GET_SMALL_DASHBOARD_OPERATION_API_REPEAT_FRESH: BASE_URL + 'freshCredit/getPerformanceStats?startDate=',
    OPERTAIONS_TABULAR_DATA_API_REPEAT_FRESH: BASE_URL + 'credit/freshCredit/detailProcessReport?startDate=',
    DOWNLOAD_OPERATION_REPORT_API_REPEAT_FRESH: BASE_URL + 'freshCredit/detailProcessReportDownload?startDate=',
    GET_REPEAT_EMPLOYEE: FINANCE_BACKEND + 'performance/repeatCredit/getTeamMembers?page=',
    GET_PERFORMANCE_DATA_BY_EMAIL_REPEAT: BASE_URL + 'performance/repeatCredit/report?startDate=',
    GET_REPEAT_PERFORMANCE_API: FINANCE_BACKEND + 'performance/repeatCredit/empPerformanceAnalysis?startDate=',
    GET_SOFTAPPROVAL_API_REPEAT: FINANCE_BACKEND + 'performance/repeatCredit/empCommentStats?startDate=',
    GET_SMALL_DASHBOARD_OPERATION_API_REPEAT: BASE_URL + 'repeatCredit/getPerformanceStats?startDate=',
    OPERTAIONS_TABULAR_DATA_API_REPEAT: BASE_URL + 'performance/repeatCredit/detailProcessReport?startDate=',
    DOWNLOAD_OPERATION_REPORT_API_REPEAT: BASE_URL + 'repeatCredit/detailProcessReportDownload?startDate=',
    DOWNLOAD_KYC_PENDING_DATA: BASE_URL + 'karza/api/downLoadPendingKycList?startDate=',
    ENACH_DATA_LEADS: BASE_URL + 'enashAndEsign/getEnachDataLeadNew?pageNumber=',
    GET_AML_DATA_BY_USERID: BASE_URL + 'getAMLDataByUserId?userId=',
    DOWNLOAD_DISBURSE_REPORT: BASE_URL + 'getDisbursedReportData?sDate=',
    SAVE_KYC_UNDERWRITTER: BASE_URL + 'karza/api/saveKycAnalysisOfUserApplication?userId=',
    GET_KYC_BOX_DATA: BASE_URL + 'karza/api/getKycAnalysisOfUserApplication?userId=',
    DOWNLOAD_INCOME_BREAKUP_REPORT: BASE_URL + 'getIncomeBreakdownData?sDate=',
    DOWNLOAD_CUSTOMER_DATA_EXCEL_BY_DATE: BASE_URL + 'downloadCustomerDetailsExcel?startDate=',
    DOWNLOAD_PARTNER_LEAD_DATA_EXCEL_BY_DATE: BASE_URL + 'getPartnerLeadUserReport?startDate=',
    DOWNLOAD_PARTNER_LEAD_DATA_QUID_EXCEL_BY_DATE: BASE_URL + 'quid/getAggregatorLeadReport?aggregatorId=',
    DOWNLOAD_QUID_PRE_APPROVAL_REPORT_BY_DATE: BASE_URL + 'quid/getPreApprovalReport?startDate=',
    DOWMLOAD_AGGREGATOR_LINK_DATA_BYDATA: FINANCE_BACKEND + 'downloadAggregatorLinkData?aggregatorId=',
    DOWMLOAD_QUID_REVERSAL_REPORTBY_DATA: BASE_URL + 'quid/getQuidReverseLeadReport?startDate=',
    DOWMLOAD_GROMO_REVERSAL_REPORTBY_DATA: BASE_URL + 'getGroMoReverseLeadReport?startDate=',
    DOWNLOAD_EMI_MODIFY_REPORT: BASE_URL + 'getEMIModifyReportData?sDate=',
    DOWNLOAD_EMI_COLLECTION_REPORT: BASE_URL + 'getEmiCollectionReportData?sDate=',
    DOWNLOAD_EMI_COLLECTION_REPORT_BULLET: BASE_URL + 'getBulletLoanCollectionReport?sDate=',
    DOWNLOAD_EMI_DAILY_HIT_REPORT: BASE_URL + 'getEmiDailyHitReportData?sDate=',
    GET_INTERNAL_DEDUPE_DATA: BRE_BASE_URL + 'loan/getInternalDedupeAnalysisOfUserApplication?userId=',
    SAVE_DEDUPEDATA: BRE_BASE_URL + 'loan/saveInternalDedupeAnalysisOfUserApplication?userId=',
    GET_ORGANISATION_ANALYSIS_DATA: BRE_BASE_URL + 'getUserLoanOrganisationAnalysis?userId=',
    GET_OUTSTANDING_DUE_REPORT: BASE_URL + 'getOutstandingReportData?disbursedDate=',
    UPDATE_NAME_AS_ON_PAN: BASE_URL + 'updatePanNameInUserInformation?userId=',
    GET_REJECTION_REPORT: BASE_URL + 'getRejectionReportData?sDate=',
    UPDATE_BANK_STATEMENT_STATUS: BRE_BASE_URL + 'updateBankStatementStatus?loanId=',
    UPDATE_REAPEAT_CUSTOMER: BRE_BASE_URL + 'updateNewUserStatus?loanId=',
    GET_DAILY_EMIT_HIT_REPORT: BASE_URL + 'getDailyEmiReportData?sDate=',
    GET_DISBURSE_CREDIT_DATA: BASE_URL + 'getDisbursedReportCreditData?sDate=',
    GET_DATA_ANALYSIS_STATUS_BY_USERID: BRE_BASE_URL + 'getDataAnalaysisStatusByUserId?userId=',
    GET_APPLICATION_ID_LIST_REGISTERED_WITH_DRP: BASE_URL + 'getLastUserEmiWithDRPMandate?loanStatus=',
    BULK_DEACTIVATE_DRP_NACH: BASE_URL + 'enashAndEsign/deactivateEnachList',
    BULK_DEACTIVATE_DRP_NACH_FOR_ACTIVE_LIST: BASE_URL + 'enashAndEsign/deactivateEnachForActiveServiceList?service=',
    UPLOAD_OVERDUE_SMS_CSV: BASE_URL + 'getCitraBulkCommunicationOverdueCsv',
    SEND_MSG_BULK: BASE_URL + 'sendCitraOverdueSMS',
    GET_RECEIVED_EMI_AMOUNT_REPORT: BASE_URL + 'emiAmountReceivedReport?sDate=',

    GENERATE_PAYMENT_LINK: BASE_URL + 'payments/razorpay/createPaymentLink',
    GET_GENERATED_PAYMENT_LINK_HISTORY: BASE_URL + 'payments/razorpay/getAllPaymentLinkByLoanId?loanId=',
    GET_GENERATED_PAYMENT_LINK_HISTORY_PAYMNET_SERVICE: PAYMENT_SERVICE_URL + 'api/payment-service/getAllPaymentLinkByLoanId?loanId=',
    DELETE_GENERATED_PAYMENT_LINK: BASE_URL + 'payments/razorpay/deactivatePaymentLink?loanId=',
    DELETE_GENERATED_PAYMENT_LINK_PAYMENT_SERVICE: PAYMENT_SERVICE_URL + 'api/payment-service/deactivatePaymentLinkByLoanId?loanId=',

    GET_ACCOUNTING_DISBURSE_DATA: BASE_URL + 'getDailyAccountingDisbursementReport?sDate=',
    GET_TRACKWIZZ_RESPONSE: BASE_URL + 'getTrackWizzResponseByUserId?userId=',
    GET_TXN_BY_LOANID: BASE_URL + 'getTransactionByLoanId?loanId=',
    GET_BILL_DESK_LEADS: BASE_URL + 'getUnpaidEmiWithBillDeskMandate',
    CREATE_INVOICE_BILLDESK: BASE_URL + 'createInvoice?loanId=',
    CHECK_USER_DOC: BASE_URL + 'userDocumentsExists?userId=',
    STAMP_DUTY_UPLOAD_HISTORY: BASE_URL + 'getStampDutyUploadedHistory?pageNo=',
    STAMP_USED_HISTORY: BASE_URL + 'getStampDutyUsageHistory?sDate=',
    GET_CALULATED_AMOUNT: BASE_URL + 'getEMIBreakUpAfterWaiver',
    GET_EMI_BREAKUP_FOR_ONE_EMI: BASE_URL + 'getbulletemitopayuser/',
    GET_ALL_PAYMENTS_API: BASE_URL + 'payments/getAllPayments?startDate=',
    GET_ALL_VERIFIED_PAYMENTS_API: FINANCE_BACKEND + 'getPaymentsByVerifiedStatus?isVerified=',
    GET_PAYMENT_ANALYTICS_LIST_API: FINANCE_BACKEND + 'getPaymentAnalyticsList?isVerified=',
    SET_ORGANIZATION_API: BASE_URL + 'orgEmailVerifiedViaByUserId?userId=',
    // GET_DETAILS_OF_TXN: BASE_URL + 'payments/getBreakdownDetailsByEmiId?emiId='
    GET_DETAILS_OF_TXN: FINANCE_BACKEND + 'getBreakdownDetailsByPaymentId?paymentId=',
    ADD_OR_UPDATE_EMAIL_TEMPLATE: BASE_URL + 'saveOrUpdateEmailTemplate',
    GET_EMAIL_TEMPLATES: BASE_URL + 'getAllEmailTemplates',
    DELETE_TEMPLATE_EMAIL: BASE_URL + 'deleteEmailTemplateByName?templateName=',
    GET_SMS_TEMPLATES: BASE_URL + 'getAllSmsTemplates',
    ADD_OR_UPDATE_SMS_TEMPLATE: BASE_URL + 'saveOrUpdateSmsTemplate',
    DELETE_TEMPLATE_SMS: BASE_URL + 'deleteSmsTemplateByName?templateName=',
    GET_COMPLETE_APPLICATION_STATUS: BASE_URL + 'getStatusCountAnalysisByDateAndDateType?sDate=',
    GET_BANK_STATEMENT_STATUS: BRE_BASE_URL + 'getBankStatementsStatus?userId=',
    GET_BANK_NAME_LIST: BRE_BASE_URL + 'getInstitutionList',

    // Executor 
    GET_ALL_AUTOMATED_PROCESS: BASE_URL + 'getLatestAutomatedExecutorData',
    SAVE_UPDATE_AUTOMATED_PROCESS: BASE_URL + 'saveOrUpdateAutomatedProcess',
    UPDATE_AUTOMATED_PROCESS_STATUS: BASE_URL + 'updateAutomatedProcessActiveStatus?processName=',
    DELETE_PROCESS_BY_PROCESS_NAME: BASE_URL + 'deleteProcessByName?processName=',
    GET_AUTOMATED_PROCESS_BY_FILTER: BASE_URL + 'getAutomatedProcessByFilter?',
    GET_ALL_PROCESS_NAMES: BASE_URL + 'getAllProcessNames',
    // loan utility
    GET_ALL_LOAN_UTILITY: BASE_URL + 'getAllLoanUtilityByPagination?pageNo=',
    SAVE_UPDATE_LOAN_UTILITY: BASE_URL + 'saveOrUpdateLoanUtility',
    DELETE_LOAN_UTILITY: BASE_URL + 'deleteLoanUtility?id=',
    GET_LOAN_UTILITY_BY_PRODUCTID: BASE_URL + 'getLoanUtilityByProductName?productName=',
    //  Processing fee 
    GET_ALL_PROCESSING_FEE: BASE_URL + 'getAllProcessingFeeByPagination?pageNo=',
    DELETE_PROCESSING_FEE: BASE_URL + 'deleteProcessingFee?id=',
    GET_PROCESSING_FEE_BY_PRODUCTID: BASE_URL + 'getProcessingFeeByProductId?productId=',
    SAVE_UPDATE_PROCESSING_FEE: BASE_URL + 'saveOrUpdateProcessingFee',

    SAVE_UPDATE_AUTOMATED_PROCESS: BASE_URL + 'saveOrUpdateAutomatedProcess',
    UPDATE_AUTOMATED_PROCESS_STATUS: BASE_URL + 'updateAutomatedProcessActiveStatus?processName=',
    ///productApi////
    SAVE_DOC_PRODUCTS: BASE_URL + 'saveOrUpdateProductDetails',
    GET_DOC_PRODUCTS: BASE_URL + 'getProductDetails?pageNo=',
    GET_PRODUCTS_COUNT: BASE_URL + 'getProductDetailsCount',
    DELETE_PRODUCTS: BASE_URL + 'deleteProductDetails?productId=',
    GET_PRODUCT_BY_NBFC_ID_NEW: BASE_URL + 'getAllProducts?nbfcId=',
    GET_CALCULATION: BASE_URL + 'getCalculations?productId=',
    EDIT_CALCULATION: BASE_URL + 'editCalculation',
    GET_PRODUCT_BY_DOCTORID: BASE_URL + 'getAllProductDetail?doctorId=',
    ASSIGN_PRODUCT_TO_DOCTOR: BASE_URL + 'assignProductToDoctor?doctorId=',
    CHANGE_PRODUCT_STATUS: BASE_URL + 'changeProductActivationStatus?status=',
    UN_ASSIGN_PRODUCT_TO_DOCTOR: BASE_URL + 'deleteDoctorProduct?doctorId=',
    UPLOAD_DOCTOR_RATING_FILE: BASE_URL + 'uploadDoctorDetails',
    SAVE_PROCESSING_FEE_TYPE: BASE_URL + 'updateProcessingFeeTypeUsingProductId?productId=',
    RESTART_PROCESS: BASE_URL + 'automation/restartAutomationProcessByProcessName?processName=',
    GET_LOGS_BY_EXECUTOR_NAME: BASE_URL + 'getExecutorLogsByFilter?executorName=',
    GET_ALL_ORGANISATION: BASE_URL + 'getAllOrganisation',
    ////
    SAVE_EMPLOYEE_DATA_FOR_TARGET: FINANCE_BACKEND + 'employee/saveAndUpdateEmployeeDetail',
    GET_ALL_EMPLOYEES: FINANCE_BACKEND + 'employee/getAllEmployeeDetails?monthName=',
    DELETE_EMPLOYEE_BY_ID: FINANCE_BACKEND + 'employee/deleteEmployeeDetailsById?id=',
    SAVE_EXPENSE_DATA: FINANCE_BACKEND + 'expense/saveAndUpdateExpense',
    GET_ALL_EXPENSE: FINANCE_BACKEND + 'expense/getExpenseDashboardData?sDate=',//new
    DELETE_EXPENSE_BY_ID: FINANCE_BACKEND + 'expense/deleteExpenseById?id=',
    SAVE_EXPENSE_CATEGORY: FINANCE_BACKEND + 'expense/saveAndUpdateExpenseCategory',
    GET_ALL_EXPENSE_CATEGORY: FINANCE_BACKEND + 'expense/getAllExpenseCategoryList',
    DELETE_EXPENSE_CATEGORY_BY_ID: FINANCE_BACKEND + 'expense/deleteExpenseCategoryById?id=',
    SAVE_EXPENSE_SUB_CATEGORY: FINANCE_BACKEND + 'expense/saveAndUpdateExpenseSubCategory',
    GET_ALL_EXPENSE_SUB_CATEGORY: FINANCE_BACKEND + 'expense/getAllExpenseSubCategoryList',
    UPLOAD_EXPENSE_CSV_FILE: FINANCE_BACKEND + 'api/expenses/upload-expense-csv',
    GET_SORT_CRED_TRANSACTION: FINANCE_BACKEND + 'api/v1/cred-transactions/sort?field=',
    GET_MONTHLY_CASHFLOW: FINANCE_BACKEND + 'api/v1/monthly-cashflow',
    GET_Business_Statement: FINANCE_BACKEND + 'api/v1/business-statement',
    SAVE_PRODUCT: FINANCE_BACKEND + 'api/v1/product',
    EXPENSE_STATEMENT: FINANCE_BACKEND + 'api/v1/expense-statement',
    DELETE_EXPENSE_SUBCATEGORY_BY_ID: FINANCE_BACKEND + 'expense/deleteExpenseSubCategoryById?id=',
    SAVE_EXPENSE_DESCRIPTION: FINANCE_BACKEND + 'expense/saveAndUpdateExpenseDescription',
    GET_ALL_DESCRIPTION: FINANCE_BACKEND + 'expense/getAllExpenseDescription',
    DELETE_EXPENSE_DESCRIPTION_BY_ID: FINANCE_BACKEND + 'expense/deleteExpenseDescription?id=',
    SAVE_EXPENSE_TARGET: FINANCE_BACKEND + 'expense/saveAndUpdateExpenseTarget',
    GET_EXPENSE_TARGET: FINANCE_BACKEND + 'expense/getAllExpenseTarget?sDate=',
    DELETE_EXPENSE_TARGET_BY_ID: FINANCE_BACKEND + 'expense/deleteExpenseTarget?id=',
    GET_EXPENSE_PROVISION_DETAILS: FINANCE_BACKEND + 'getExpenseProvisionDetail?sDate=',
    SAVE_EXPENSE_PROVISION_DETAILS: FINANCE_BACKEND + 'saveOrUpdateExpenseProvision',
    GET_EXPENSE_PROVISION_DETAILS_BY_CATEGORYID: FINANCE_BACKEND + 'getExpenseProvisionByCategoryId?categoryId=',

    // business
    GET_ALL_BUSINESS: FINANCE_BACKEND + 'businessPlanning/getAllBusinessPlanning',
    SAVE_BUSINESS_DATA: FINANCE_BACKEND + 'businessPlanning/saveBusinessPlanning',
    UPDATE_BUSINESS_DATA: FINANCE_BACKEND + 'businessPlanning/updateBusinessPlanning',

    GET_ALL_BUSINESS_RETURN: FINANCE_BACKEND + 'businessPlanning/getAllBusinessReturn',
    SAVE_BUSINESS_RETURN_DATA: FINANCE_BACKEND + 'businessPlanning/saveBusinessReturn',
    UPDATE_BUSINESS_RETURN_DATA: FINANCE_BACKEND + 'businessPlanning/updateBusinessReturn',

    GET_ALL_BUSINESS_TARGET_CATEGORY: FINANCE_BACKEND + 'businessPlanning/getAllBusinessTargetCategory',
    SAVE_BUSINESS_TARGET_CATEGORY_DATA: FINANCE_BACKEND + 'businessPlanning/saveBusinessTargetCategory',
    UPDATE_BUSINESS_TARGET_CATEGORY_DATA: FINANCE_BACKEND + 'businessPlanning/updateBusinessTargetCategory',

    GET_ALL_BUSINESS_TARGET_SUBCATEGORY: FINANCE_BACKEND + 'businessPlanning/getAllBusinessTargetSubCategory',
    SAVE_BUSINESS_TARGET_SUBCATEGORY_DATA: FINANCE_BACKEND + 'businessPlanning/saveBusinessTargetSubCategory',
    UPDATE_BUSINESS_TARGET_SUBCATEGORY_DATA: FINANCE_BACKEND + 'businessPlanning/updateBusinessTargetSubCategory',

    GET_ALL_BUSINESS_TARGET: FINANCE_BACKEND + 'businessPlanning/getAllBusinessTarget',
    SAVE_BUSINESS_TARGET_DATA: FINANCE_BACKEND + 'businessPlanning/saveBusinessTarget',
    UPDATE_BUSINESS_TARGET_DATA: FINANCE_BACKEND + 'businessPlanning/updateBusinessTarget',

    GET_ALL_DEPARTEMENT_LIST_OLD: FINANCE_BACKEND + 'getDepartmentList',
    GET_ALL_DEPARTEMENT_LIST: FINANCE_BACKEND + 'getDepartmentWiseTargetAndExpense?emailId=',

    SAVE_DEPARTMENT_DATA: FINANCE_BACKEND + 'saveDepartment',
    UPDATE_DEPARTMENT_DATA: FINANCE_BACKEND + 'updateDepartment',
    DELETE_DEPARTMENT_DATA: FINANCE_BACKEND + 'deleteDepartmentById?id=',
    ////
    REGENERATE_CRIF_CHECK: BRE_BASE_URL + 'isCrifGenerated?userId=',
    NBFC_DATA_NEW: BASE_URL + 'getLoanUtilityByNbfcSeparation',
    SAVE_EMAIL_KEY: BASE_URL + 'saveEmailDirectory?key=',
    GET_EMAIL_KEYS: BASE_URL + 'getAllEmailDirectory',
    UPDATE_EMAIL_KEY: BASE_URL + 'updateEmailDirectory?key=',
    DELETE_EMAIL_KEY: BASE_URL + 'deleteEmailDirectoryByKey?key=',
    APPLICATION_STATUS_COUNT: BASE_URL + 'getApplicationStatsByDate?startDate=',
    INCOMING_PAYMENT_COUNT: BASE_URL + 'getIncomingPaymentStatsByDateAndType?eDate=',
    EMI_OVERDUE_LIST: BASE_URL + 'payments/getAllOverdueEMIsList?startDate=',
    EMI_OVERDUE_LIST_NEW: BASE_URL + 'payments/getAllOverdueEMIsAging?startDate=',

    // NPA Dashboard 
    GET_MONTH_WISE_OVERDUE_STATS: FINANCE_BACKEND + 'getMonthWiseOverdueStats?sDate=',
    GET_MONTH_WISE_OVERDUE_STATS_DETAILED: FINANCE_BACKEND + 'getMonthlyOverdueStatsDetailed?sDate=',

    GET_DUE_OVERDUE_COUNTS: FINANCE_BACKEND + 'getDueVsOverdueCounts?sDate=',
    GET_INVOICED_PAID_AMOUNT_MONTHLY: FINANCE_BACKEND + 'getInvoicedVsPaidAmountMonthly?sDate=',
    GET_OVERDUE_AGE_SUMMARY: FINANCE_BACKEND + 'getOverdueAgeSummary?sDate=',


    GET_KPI_LOAN_DASHBOARD_STATS: FINANCE_BACKEND + 'getKPILoanDashboardStats?nbfcId=',
    GET_LOAN_AMOUNT_TRENDS_GRAPH: FINANCE_BACKEND + 'getLoanAmountTrendGraph?nbfcId=',
    GET_YEAR_WISE_LOAN_AMOUNT_GRAPH: FINANCE_BACKEND + 'getYearWiseLoanAmountGraph?nbfcId=',
    GET_UPCOMING_DUE_PAYMENTS: FINANCE_BACKEND + 'getUpcomingDuePayments?nbfcId=',
    GET_LOAN_STATUS_WISE_COUNT: FINANCE_BACKEND + 'getLoanStatusWiseCounts?nbfcId=',


    GET_OVERDUE_EMI_PORTFOLIO: FINANCE_BACKEND + 'getOverdueEmiPortfolio?nbfcId=',

    GET_PAYMENTS_STATS: FINANCE_BACKEND + 'getPaymentStats?sDate=',
    GET_PAYMENTS_MODES_BREAKDOWN: FINANCE_BACKEND + 'getPaymentModesBreakdown?sDate=',
    GET_PAYMENTS_RECEIVED_BY_DATE: FINANCE_BACKEND + 'getPaymentReceivedByDate?sDate=',
    GET_PAYMENTS_RECEIVED_BY_DPD: FINANCE_BACKEND + 'getPaymentReceivedByDPD?sDate=',
    GET_CIRF_SAVE_DATA: BRE_BASE_URL + 'getCrifReportV2DataByUserIdAndLoanId?userId=',
    GET_CIRF_ORIGINAL_SAVE_DATA: BRE_BASE_URL + 'softPullUpdatedV2?userId=',
    ALL_APLLICATION_STATS: BASE_URL + 'userDetails/alluserDetailStats?startDate=',
    ALL_APLLICATION_STATS_EV: BASE_URL + 'userDetails/alluserDetailStatsEV?startDate=',
    CHANGE_USERS_TO_RFD_API: BASE_URL + 'changeUserToPFD',
    GET_FORMS_LIST: BASE_URL + 'getFormStatusList',
    GET_FORMS_LIST_EV: BASE_URL + 'getFormStatusListEV',

    //singular 

    SAVE_SINGULAR_LOGS_CSV: BASE_URL_MARKETING + 'saveSingularLogsCsv',
    SAVE_GOOGLE_LOGS_CSV: BASE_URL_MARKETING + 'saveGoogleLogsCsv?file=',
    GET_LATEST_EVENT_TIMESTAMP: BASE_URL_MARKETING + 'getLatestEventTimestampAndAddedDate',
    SEND_CUSTOM_AGGREGATOR_REPORT_BYFITLERS: FINANCE_BACKEND + 'sendCustomAggregatorReport?startDate=',
    GET_SINGULAR_DASHBOARD_DATA: BASE_URL_MARKETING + 'getSingularDashboardData?',
    GET_SINGULAR_DASHBOARD_REPORT: BASE_URL_MARKETING + 'getSingularDashboardReport?',
    GET_ALL_PARTNER_NAME_BY_AGGREGATOR_NAME: BASE_URL_MARKETING + 'getAllPartnerNameByAggregatorsName',
    GET_DISTINCT_EVENT_NAMES_FOR_FILTERATION: BASE_URL_MARKETING + 'getDistinctEventNames',
    GET_ALL_AGGREGATORS_NAMES: BASE_URL_MARKETING + 'getAllAggregatorEvents',
    DELETE_EVENT_LIST_BY_ID: BASE_URL_MARKETING + 'deleteEvent?id=',
    ADD_EVENT_USING_DATA: BASE_URL_MARKETING + 'createEvent',
    UPDATE_EVENT_USING_DATA: BASE_URL_MARKETING + 'updateEvent?id=',
    GET_SINGULAR_COUNTS_BY_PARTNER_EVENT_NAME: BASE_URL_MARKETING + 'getSingularCountsByPartnerAndEventName?sDate=',
    GET_ALL_SINGULAR_CSV_LOGS_BY_DATE: BASE_URL_MARKETING + 'getAllCsvLogs?sDate=',
    GET_AGGREGATOR_DATA_BY_MONTH: BASE_URL_MARKETING + 'getAggregatorData?monthStart=',


    SAVE_EMP_ATTENDATNCE: FINANCE_BACKEND + 'saveEmployeeMonthlyAttendance',
    GET_ATTENTENCE_API: FINANCE_BACKEND + 'getEmployeeAttendanceData?employeeId=',


    ADD_NEW_USER_ROLE: BASE_URL + 'addNewUserRole?roleName=',
    GET_SET_TARGET: FINANCE_BACKEND + 'getSalaryTargetDetailByDepartment?emailId=',
    DELETE_SALARY_TARGET_DATA: FINANCE_BACKEND + 'deleteSalaryTargetDetail?id=',
    SAVE_SALARY_TARGET_API: FINANCE_BACKEND + 'saveOrUpdateSalaryTarget',
    GET_PAYMENT_INSIGHTS_DASHBOARD: FINANCE_BACKEND + 'paymentsInsights/getPaymentInsightsDashboard?startDate=',
    GET_PAYMENT_INSIGHTS_DETAILS_DASHBOARD: FINANCE_BACKEND + 'paymentsInsights/getRazorpayMandateData?sDate=',
    DOWNLOAD_PAYMENT_INSIGHTS_DETAILS_DASHBOARD: FINANCE_BACKEND + 'getRazorpayMandateDataReport?sDate=',
    GET_REPEAT_CHECK_LIST: BASE_URL + 'mandatoryChecksForRepeatUser?userId=',
    GET_KFS_DETAILS_BY_LOAN_ID: BASE_URL + 'getKfsConsentById?loanId=',
    UPDATE_REPEAT_CONFIG: BASE_URL + 'updateRepeatCheckPointStatus?check_point=',
    GET_REPEAT_CHECKLIST: BASE_URL + 'getRepeatCheckPoints',
    GET_FRESH_CHECK_LIST: BASE_URL + 'freshLeadChecks?userId=',
    GET_FRESH_CHECK_POINTS: BASE_URL + 'getFreshleadCheckPoints',
    UPDATE_FRESH_CONFIG: BASE_URL + 'updateFreshLeadCheckPointStatus?check_point=',
    GET_AUTO_ENACH_CREATION_FAILURE: BASE_URL + 'payments/getAutoENachCreationFailureList?startDate=',
    REGISTER_NACH_WITH_SIGNDESK: 'https://backend.phocket.co.in/getMandateStatus?userId=',
    DEDUCT_BULK_PAYMENT_API: BASE_URL + 'enashAndEsign/deductUserPaymentBulk',
    GET_ATTENDANCE_ALL_EMP_MONTH_WISE: FINANCE_BACKEND + 'getAllEmployeesAttendanceDataMonthWise?month=',
    GET_ALL_EMPLOYEE_FOR_REPORTING: FINANCE_BACKEND + 'employee/getAllEmployeeForReporting',
    EDIT_USER_ROLE: BASE_URL + 'editUserRole?roleName=',
    DISABLE_ESIGN_API: BASE_URL + 'deleteSignDeskEsignDataByUserId?userId=',
    DEACTIVATE_NACH_API: BASE_URL + 'enashAndEsign/deactivateEnachByTPS',
    DEACTIVATE_NACH_API_FOR_ACTIVE_SERVICE_BY_USERID: BASE_URL + 'enashAndEsign/deactivateEnachForActiveService?userId=',
    UPDATE_PAYMENT_BREAKUP: FINANCE_BACKEND + 'verifyPaymentBreakup',
    GET_CRON_JOB_LIST_API: BASE_URL + 'payments/getTransactionUpdatedByCronJob?startDate=',
    GET_LINE_GRAPH_DATA_BY_CAT_ID: FINANCE_BACKEND + 'expense/getLineGraphForCategory?categoryId=',
    GET_BAR_GRAPH_DATA_BY_CAT_ID: FINANCE_BACKEND + 'expense/getExpenseAndTargetGraphData?categoryId=',
    GET_TRANSACTION_DATA_BY_CAT_ID: FINANCE_BACKEND + 'expense/getCategoryWiseExpense?categoryId=',
    CALCULATE_PAYMENT_LINK_DETAILS: BASE_URL + 'getEMIBreakUpAfterWaiver?calculationType=',
    GENERATE_PAYMENT_LINK_NEW: BASE_URL + 'payments/razorpay/createPaymentLink',
    GENERATE_PAYMENT_LINK_NEW_PAYMNET_SERVICE: PAYMENT_SERVICE_URL + 'api/v1/payment/razorpay/createLink',
    GENERATE_PAYMENT_LINK_NEW_PAYMNET_SERVICE_EASEBUZZ: PAYMENT_SERVICE_URL + 'api/v1/payment/easebuzz/createLink',
    GENERATE_PAYMENT_LINK_NEW_CASHFREE: BASE_URL + 'api/cashfree/createPaymentLink',
    GENERATE_PAYMENT_LINK_NEW_CASHFREE_PAYMENT_SERVICE: PAYMENT_SERVICE_URL + 'api/v1/payment/cashfree/createLink',
    GENERATE_PAYMENT_LINK_NEW_PAYU_PAYMENT_SERVICE: PAYMENT_SERVICE_URL + 'api/v1/payment/payu/createLink',

    GET_EXPECTED_PAYMENTS_STATS_BY_DATE: FINANCE_BACKEND + 'getExpectedPaymentsStatsByDate?sDate=',
    GET_EXPECTED_PAYMENTS_V1_STATS_BY_DATE: FINANCE_BACKEND + 'v1/getExpectedPaymentsStatsByDate?sDate=',
    GET_EXPECTED_PAYMENTS_LIST_BY_DATE: FINANCE_BACKEND + 'getExpectedPaymentsListByDate?sDate=',
    GET_EXPECTED_PAYMENTS_LIST_BY_DATE_V1: FINANCE_BACKEND + 'v1/getExpectedPaymentsListByDate?sDate=',
    GET_RECIEVED_PAYMENTS_STATS_BY_DATE: FINANCE_BACKEND + 'getReceivedPaymentsStatsByDate?sDate=',
    GET_RECIEVED_PAYMENTS_LIST_BY_DATE: FINANCE_BACKEND + 'getReceivedPaymentsListByDate?sDate=',
    GET_RECIEVED_PAYMENTS_STATS_BY_PAYMENT_BUCKET: FINANCE_BACKEND + 'getReceivedPaymentsStatsByPaymentBucket?sDate=',
    GET_RECIEVED_PAYMENTS_LIST_BY_PAYMENT_BUCKET: FINANCE_BACKEND + 'getReceivedPaymentsListByPaymentBucket?sDate=',
    GET_OVERDUE_DETAIL_STATS_BY_DUEDATE: FINANCE_BACKEND + 'getOverdueDetailsStatsTillDueDate?dueDate=',
    GET_OVERDUE_DETAIL_DATA_BY_DUEDATE: FINANCE_BACKEND + 'getOverdueDetailsDataTillDueDate?dueDate=',
    DOWNLOAD_EMP_REPORT_API: FINANCE_BACKEND + 'getEmployeeDetailReport?emailId=',
    GET_RECEIVED_OVERDUE_PAYMENT_BY_AGINGSTATS: FINANCE_BACKEND + 'getReceivedOverduePaymentsByAgingStats?sDate=',
    GET_RECIEVED_OVERDUE_PAYMENTS_BY_AGING: FINANCE_BACKEND + 'getReceivedOverduePaymentsByAging?sDate=',
    GET_EXPECTED_RECEIVED_BY_FILTER: FINANCE_BACKEND + 'getExpectedVsReceivedByFilter?sDate=',
    GET_ALL_PAYMENT_CHANNEL: FINANCE_BACKEND + 'getAllPaymentChannels',
    BULK_VERIFY_PAYMENT_BREAKUP: FINANCE_BACKEND + 'bulkVerifyPaymentBreakup?verifiedBy=',

    DOWNLOAD_PAYMENT_REPORT_BY_VERIFIFED_STATUS: FINANCE_BACKEND + 'getPaymentsReportByVerifiedStatus?sDate=',
    UPLOAD_PAYMENTS_BY_VERIFIFED_STATUS_LOGS: FINANCE_BACKEND + 'savePaymentsByVerifiedStatusLogs?verifiedBy=',
    DOWNLOAD_OVERDUE_STATS_REPORT: FINANCE_BACKEND + 'getOverdueStatsReport?sDate=',

    GET_ALL_PAYMENT_MODES: FINANCE_BACKEND + 'getAllPaymentModes',
    GET_CATEGORY_TARGET_BY_DATE_RANGE: FINANCE_BACKEND + 'expense/getCategoryTargetByDateRange?categoryId=',
    SAVE_UPDATE_VENDOR_MASTER: FINANCE_BACKEND + 'saveOrUpdateVendorMaster',
    GET_VENDOR_MASTER_DETAILS: FINANCE_BACKEND + 'getVendorMasterDetail?sDate=',
    DELETE_VENDOR_MASTER: FINANCE_BACKEND + 'deleteVendorMasterDetail?id=',
    GET_VENDOR_DETAILS_FOR_EXPENSE: FINANCE_BACKEND + 'getVendorDetailForExpense',
    GET_ALL_EXPENSE_SUB_CATEGORY_BY_CATEGORYID: FINANCE_BACKEND + 'expense/getAllExpenseSubCategoryByCategory?categoryId=',

    GET_CATEGORY_WISE_TARGET_LIST_GRAPH_DATA: FINANCE_BACKEND + 'expense/getCategoryWiseTargetListGraphData?categoryId=',
    UPDATE_EMI_PENALTY_AND_NACH_WAIVER: BASE_URL + 'updateEmiPenaltyAndNachWaiver?',
    DOWNLOAD_NOC_BY_LOANID_EMPID: BASE_URL + 'loan/downloadNoc?loanId=',
    GET_OBLIGATION_CALCULATOR_BY_USERID: BRE_BASE_URL + 'getObligationCalculator?userId=',
    GET_APPROVE_AMOUNT_BY_LOANID: BRE_BASE_URL + 'getApprovedAmount?loanId=',
    GET_CRIF_SUMMARY_BY_USERID: BRE_BASE_URL + 'getCrifSummary?userId=',
    GET_CRIF_LOANS_BY_USERID: BRE_BASE_URL + 'getCrifLoans?userId=',
    ADD_NEW_OBLIGATION_API: BRE_BASE_URL + 'addNewObligation?userId=',
    UPDATE_OBLIGATION_DATA_API: BASE_URL + 'saveOrUpdateLoanInfo?userId=',
    DELETE_LOAN_INFO_API: BRE_BASE_URL + 'deleteLoanInfo?userId=',
    GET_ADMIN_LEAD_REPORT_API: BASE_URL + 'getAdminLeadsReport?sDate=',

    DATE_WISE_GRAPH_DATA: BASE_URL + 'getEmployeePerformanceStats?assignedTo=',
    HOURS_WISE_DATA: FINANCE_BACKEND + 'getHourlyEmployeePerformanceStatsNew?assignedTo=',
    DATE_WISE_GRAPH_DATA_NEW: FINANCE_BACKEND + 'getEmployeePerformanceStatsNew?assignedTo=',
    HOURS_WISE_DATA_NEW: FINANCE_BACKEND + 'getHourlyEmployeePerformanceStatsNew?assignedTo=',
    GET_EMPLOYEE_LEAD_ACTIVITY: FINANCE_BACKEND + 'getEmployeeLeadActivity?',
    ADMIN_ACTIVITY_LOG_API: BASE_URL + 'updateLeadTouchedByAssignedToAndLoanId?assignedTo=',


    GET_ALL_SETTLEMENTS_BY_FILTER: BASE_URL + 'getAllSettlementByFilter',
    GET_ALL_SETTLEMENTS_REPORT_BY_FILTER: BASE_URL + 'getAllSettlementReportByFilter',
    DOWNLOAD_ALL_SETTLEMENTS_DATA_BY_FILTER: BASE_URL + 'downloadAllSettlementDataByFilter',
    DOWNLOAD_ALL_SETTLEMENTS_REPORT_DATA_BY_FILTER: BASE_URL + 'downloadAllSettlementReportDataByFilter',
    GET_SETTLEMENTS_STATS_BY_FILTER: BASE_URL + 'getSettlementStatsByFilter',
    GET_SETTLEMENTS_REPORT_STATS_BY_FILTER: BASE_URL + 'getAllSettlementReportStatsByFilter',

    UPDATE_OVERDUE_EXPECTED_DETAILS: BASE_URL + 'payments/updateOverdueExpectedDetails?emiId=',
    UPDATE_TRANSACTION_COMMENT_BY_TRANSACTIONID: BASE_URL + 'updateTransactionComment?transactionId=',
    GET_KFS_HTML: BASE_URL + 'getKfsHtmlByLoanId?loanId=',
    UPDATE_KFS_DATA: BASE_URL + 'updateKFSConsent?loanId=',
    GET_KFS_STATUS: BASE_URL + 'getKfsConsentStatus?loanId=',
    IS_SALARY_VERIFIED: BRE_BASE_URL + 'isSalaryVerified?userId=',
    SAVE_UPDATE_SALARY: BRE_BASE_URL + 'saveOrUpdateSalary?userId=',

    /////NBFC_APIS////

    ALL_NBFC_COUNTS_API: BASE_URL + 'getNbfcCount',
    GET_ONBAORDING_GRAPH_DATA: BASE_URL + 'getOnboardingStatusByNbfcName',
    GET_LOAN_STATUS_DATA: BASE_URL + 'getLoanStatusByNbfcId?nbfcId=',
    GET_REPAYMENT_STATUS: BASE_URL + 'getRepaymentStatusByNbfcId?nbfcId=',
    GET_CONVERSION_RATIO_DATA: BASE_URL + 'getConversionRateByNbfc',
    GET_NBFC_PERFORMANCE_DATA: BASE_URL + 'getNbfcPerformanceStats',
    NBFC_STATS_API: BASE_URL + 'getNbfcOverviewStats',
    INDIVIDUAL_DASHBOARD_API: BASE_URL + 'getTotalLeadsMonthWise?sDate=',
    GET_CUSTOMER_CRITERIA_BY_NBFCID: BASE_URL + 'getCustomerCriteriaByNbfcId?nbfcId=',
    GET_PROCESSING_FEE_DETAILS_BY_NBFCID: BASE_URL + 'getProcessingFeeDetailsByNbfcId?nbfcid=',
    GET_LOAN_UTILITY_STATS_BY_NBFCID: BASE_URL + 'getLoanUtilityStatsByNbfcId?nbfcId=',
    GET_ENACH_CONFIG_BY_NBFCID: BASE_URL + 'getEnachConfigByNbfcId?nbfcId=',
    GET_ESIGN_CONFIG_BY_NBFCID: BASE_URL + 'getEsignConfigByNbfcId?nbfcId=',
    SAVE_UPDATE_NBFC_CUSTOMER_CRITERIA: BASE_URL + 'saveOrUpdateNbfcCustomerCriteria',

    GET_NBFC_DOCS_URL_BY_NBFCID: BASE_URL + 'getNbfcDocsUrlByNbfcId?nbfcId=',
    UPLOAD_NBFC_DOCUMENTS_BY_NBFC_NAME: BASE_URL + 'uploadNbfcDocuments?nbfcName=',
    GET_NBFC_RECENT_ACTIVITY: BASE_URL + 'getNbfcRecentActivity',
    GET_COMMENTS_BY_NBFCID: BASE_URL + 'getCommentsByNbfcId?nbfcId=',
    SAVE_UPDATE_NBFC_COMMENTS: BASE_URL + 'saveOrUpdateNbfcComment',
    GET_LOANLEAD_COUNT_BY_LOAN_STATUS: BASE_URL + 'getLoanLeadsCountByLoanStatus?nbfcId=',
    GET_LOAN_LEAD_BYID: BASE_URL + 'getLoanLeadsByNbfcId?nbfcId=',

    GET_AADHAAR_VALIDATION_BY_SUREPASS: BASE_URL + 'surePass/aadhaarValidation?userId=',
    GET_AADHAAR_VALIDATION_BY_ONGRID: BASE_URL + 'ongird/aadhaarValidation?userId=',

    GENERATE_AADHAAR_OTP_FOR_KYC_USING_SURE_PASS_ONLY: BASE_URL + 'surePass/generateAadhaarOtp?aadhaarNo=',
    SUBMIT_AADHAAR_OTP_FOR_KYC_USING_SURE_PASS_ONLY: BASE_URL + 'surePass/submitAadhaarOtp?otp=',
    GENERATE_AADHAAR_OTP_FOR_KYC_USING_SURE_PASS: BASE_URL + 'ongird/generateAadhaarOtp?aadhaarNo=',
    SUBMIT_AADHAAR_OTP_FOR_KYC_USING_SURE_PASS: BASE_URL + 'ongird/submitAadhaarOtp?otp=',
    // Portofolio Overview Section
    GET_RUNNING_LOAN_COUNT: BASE_URL + 'getRunningLoanCount?sDate=',
    GET_RUNNING_LOANS_DETAILS_BY_DATE: BASE_URL + 'getRunningLoanDetails?sDate=',
    GET_DISBURSED_LOAN_DETAILS_BY_DATE: BASE_URL + 'getDisbursedLoanDetails?sDate=',
    GET_STATS_BY_NPA_AGENING_DAYS_BY_DATE: BASE_URL + 'getStatsByNPAAgeingDays?sDate=',
    GET_OVERDUE_EMI_PORTFOLIO_90_PLUS: FINANCE_BACKEND + 'getOverdueEmiPortfolioByDpd?sDate=',
    GET_LOAN_RECOVERED_STATS_BY_DATE: BASE_URL + 'getLoanRecoveredStats?sDate=',

    SAVE_UPDATE_USER_COMMENTS: BASE_URL + 'saveOrUpdateUserComments',
    GET_COMMUNICATION_COMMENTS_BY_USERID: BASE_URL + 'getCommunicationCommentsByUserId?userId=',
    GET_COMMUNICATION_STATUS_BY_USERID: BASE_URL + 'getCommunicationStatusByUserId?userId=',

    SAVE_UPDATE_CALL_STATUS: BASE_URL + 'saveOrUpdateApplicationFollowUpLogs',
    GET_AGGREGATED_COUNT_BY_FORM_STATUS_BY_BUCKET_TYPE: BASE_URL + 'getAggregatedCountByFormStatus?startDate=',
    GET_AGGREGATOR_DETAILS_BY_DATE_FILTERS: FINANCE_BACKEND + 'getAggregatorDetails?startDate=',
    GET_LEAKAGE_ANALYSIS_DETAILS_BY_DATE_FILTERS: FINANCE_BACKEND + 'getLeakageAnalysis?startDate=',
    GET_AGGREGATOR_LEADS_PAYOUT_BY_DATE: FINANCE_BACKEND + 'getAggregatorLeadsPayouts?startDate=',
    GET_USER_DATA_BY_COMMUNICATION_TYPE_BY_DATE: BASE_URL + 'getUserDataByCommunicationType?startDate=',
    GET_USER_DATA_COUNT_BY_COMMUNICATION_TYPE_BY_DATE: BASE_URL + 'getUserCountByCommunicationType?startDate=',
    GET_LOAN_STATS_BY_AGGREGATOR_ID_BYDATE: FINANCE_BACKEND + 'getLoanStatsByAggregatorId?startDate=',
    GET_AGGREGATOR_EVENTS_AGGREGATOR_ID_BYDATE: FINANCE_BACKEND + 'getAggregatorEventsByAggregatorId?startDate=',
    GET_PARTNERS_BY_AGGREGATOR_ID_BY_DATE: FINANCE_BACKEND + 'getPartnersByAggregatorId?startDate=',
    GET_CAMPAIGN_BY_AGGREGATOR_ID_BY_DATE: FINANCE_BACKEND + 'getCampaignsByAggregatorId?startDate=',
    DOWNLOAD_CAMPAIGNS_BY_AGGREGATOR_ID: FINANCE_BACKEND + 'downloadCampaignsByAggregatorId?startDate=',
    GET_LEADS_BY_CAMPAIGN_ID: FINANCE_BACKEND + 'getLeadsByCampaignId?startDate=',
    DOWNLOAD_LEADS_BY_CAMPAIGN_ID: FINANCE_BACKEND + 'downloadLeadsByCampaignId?startDate=',
    DOWNLOAD_APPLICATION_AGGREGATOR_MAPPING: FINANCE_BACKEND + 'downloadApplicationAggregatorMapping?startDate=',
    GET_AGRREGATOR_DATA_AGGREGATOR_ID_BY_DATE: FINANCE_BACKEND + 'getAggregatorDataByAggregatorId?startDate=',
    GET_EVENT_DATA_AGGREGATOR_ID_BY_DATE: FINANCE_BACKEND + 'getEventDataByAggregatorId?aggregatorId=',
    UPDATE_EVENT_DATA_AGGREGATOR_ID: FINANCE_BACKEND + 'updateEventDataByAggregatorId?aggregatorId=',
    GET_BUDGET_AGGREGATOR_BY_DATA: FINANCE_BACKEND + 'getBudgetByAggregatorId?startDate=',
    GET_BUDGET_STATS_AGGREGATOR_BY_DATA: FINANCE_BACKEND + 'getBudgetStatsByAggregatorId?startDate=',
    SAVE_PARTNER_DATA_BYOBJECT: FINANCE_BACKEND + 'savePartnerData',
    GET_AGGREGATOR_LOAN_STATS_BY_DATE: BASE_URL_MARKETING + "getAggregatorLoanStats?sDate=",
    GET_AGGREGATOR_LOAN_STATS_BY_DATE_NEW: BASE_URL_MARKETING + "getMarketingPerformanceAdminStats?startDate=",
    GET_LIVE_REPORT_OVERVIEW_FUNNEL_DATA_BY_DATE: BASE_URL_MARKETING + "getAggregatorEvents?startDate=",
    GET_REJECTION_HEATMAP_DATA_BY_DATE: BASE_URL_MARKETING + "getRejectionHeatmap?startDate=",
    GET_REJECTION_CHART_DATA_BY_DATE: BASE_URL_MARKETING + "getMonthlyRejectionStats?startDate=",
    GET_AGGREGATOR_DETAILS_DATA_BY_DATE: BASE_URL_MARKETING + "getAggregatorDetails?startDate=",
    GET_CONVERSION_DETAILS_DATA_BY_DATE: BASE_URL_MARKETING + "getActualTargetDisbursement?startDate=",
    GET_BUSINESS_ATS_CHART_DATA_BY_DATE: BASE_URL_MARKETING + "getDisbursementTicketSizeStats?startDate=",
    GET_BUSINESS_CONTRIBUTION_DATA_BY_DATE: BASE_URL_MARKETING + "getBusinessByAggregator?startDate=",
    GET_USER_DETAILS_INCOMPLETE_FUNNEL_STATS_BY_DATE: BASE_URL + "userDetails/incompleteFunnelStats?startDate=",
    POST_ADMIN_AGGREGATOR_LINK_GEENRATE: BASE_URL + "admin/aggregator-links/generate",

    // Test LeadManagement API's
    FETCH_LEAD_MANAGEMENT_DATA: BASE_URL + 'fetchLeadManagementData',
    FETCH_LEAD_MANAGEMENT_STATS: BASE_URL + 'fetchLeadManagementStats',
    DOWNLOAD_LEAD_MANAGEMENT_EXCEL_DATA: BASE_URL + 'downloadLeadManagementExcel',
    UPDATE_LEAD_REDIS_DATA: BASE_URL + 'updateLeadRedisData?loanId=',
    GET_LM_DEPARTMENT_WISE_COUNT_BY_DATE: BASE_URL + 'getLMDepartmentWiseCount?sDate=',
    GET_OVERALL_DEPARTMENT_PERFORMANCE_BY_DATE: BASE_URL + 'getOverallDepartmentPerformance',
    GET_PERFORMANCE_BY_DEPARTMENT_BY_DATE: BASE_URL + 'getPerformanceByDepartment',

    GET_LOAN_DISBURSMENT_REPORT: BASE_URL + 'getLoanDisbursementReport?sDate=',
    GET_INTEREST_REBATE_REPORT: BASE_URL + 'getInterestRebateReport?sDate=',

    DOWNLOAD_LOAN_OVERDUE_REPORT: BASE_URL + 'loanOverdueReport?sDate=',
    GET_ALL_APPLICATION_SHEET_DOWNLOAD_BY_DATE: BASE_URL + 'getAllApplicationSheetDownload?startDate=',

    GET_PORTFOLIO_OVERVIEW_REPORT_BY_DATE: BASE_URL + 'getPortfolioOverviewReport?startDate=',
    GET_PORTFOLIO_OVERVIEW_CURRENT_OUTSTANDING_REPORT_BY_DATE: BASE_URL + 'getCurrentOutstandingReport?startDate=',
    GET_PRODUCT_LIST: BASE_URL + 'getProductDetailList',
    GET_BUREAU_VARIATIONS_BY_USERID_AND_LOANID: BRE_BASE_URL + 'getBureauVariations?userId=',

    GET_ENACH_DATA_LIST_BY_DATE: BASE_URL + 'nachManagement/getENachDataList?startDate=',
    UPDATE_NACH_HIT_DATE_BY_LOANID: BASE_URL + 'nachManagement/updateNachHitDate?loanId=',

    GET_MONTHS_WISE_CUSTOMER_ACQUISITION_COST_BY_DATE: FINANCE_BACKEND + 'getMonthWiseCustomerAcquisitionCost?startDate=',
    GET_MONTHS_WISE_RECIEVED_AMOUNT_BY_DATE: FINANCE_BACKEND + 'getReceivedAmount?startDate=',
    GET_MONTHS_WISE_INCOME_AMOUNT_BY_DATE: FINANCE_BACKEND + 'getIncomeEfficiencyMonthWiseStats?startDate=',
    GET_MONTHS_WISE_ACCURAL_AMOUNT_BY_DATE: FINANCE_BACKEND + 'getAccrualIncome?startDate=',
    DOWNLOAD_LIST_DATA_MIS: FINANCE_BACKEND + 'downloadMISReportCsv?startDate=',


    // communication Module 

    GET_EMAIL_TEMPALTES_LIST: COMMUNICATION_URL + 'api/v1/email-templates',
    DELETE_EMAIL_TEMPALTE_BY_ID: COMMUNICATION_URL + 'api/v1/email-templates/',
    SAVE_EMAIL_TEMPALTE_BY_DATA: COMMUNICATION_URL + 'api/v1/email-templates',
    UPDATE_EMAIL_TEMPALTE_BY_DATA_ID: COMMUNICATION_URL + 'api/v1/email-templates/',
    GET_EMAIL_TEMPLATES_SEARCH_BY_SUBJECT_KEYWORDS: COMMUNICATION_URL + 'api/v1/email-templates/search/by-subject?keyword=',

    GET_SMS_TEMPALTES_LIST: COMMUNICATION_URL + 'api/v1/sms-templates',
    DELETE_SMS_TEMPALTE_BY_ID: COMMUNICATION_URL + 'api/v1/sms-templates/',
    SAVE_SMS_TEMPALTE_BY_DATA: COMMUNICATION_URL + 'api/v1/sms-templates',
    UPDATE_SMS_TEMPALTE_BY_DATA_ID: COMMUNICATION_URL + 'api/v1/sms-templates/',
    GET_SMS_TEMPLATES_SEARCH_BY_SUBJECT_KEYWORDS: COMMUNICATION_URL + 'api/v1/sms-templates/search/by-dlt?dltId=',

    GET_WHATSAPP_TEMPALTES_LIST: COMMUNICATION_URL + 'api/v1/whatsapp-templates',
    DELETE_WHATSAPP_TEMPALTE_BY_ID: COMMUNICATION_URL + 'api/v1/whatsapp-templates/',
    SAVE_WHATSAPP_TEMPALTE_BY_DATA: COMMUNICATION_URL + 'api/v1/whatsapp-templates',
    UPDATE_WHATSAPP_TEMPALTE_BY_DATA_ID: COMMUNICATION_URL + 'api/v1/whatsapp-templates/',
    GET_WHATSAPP_TEMPLATES_SEARCH_BY_SUBJECT_KEYWORDS: COMMUNICATION_URL + 'api/v1/whatsapp-templates/search?subject=',

    GET_NOTIFICATION_TEMPALTES_LIST: COMMUNICATION_URL + 'api/v1/notifications',
    DELETE_NOTIFICATION_TEMPALTE_BY_ID: COMMUNICATION_URL + 'api/v1/notifications/',
    SAVE_NOTIFICATION_TEMPALTE_BY_DATA: COMMUNICATION_URL + 'api/v1/notifications',
    UPDATE_NOTIFICATION_TEMPALTE_BY_DATA_ID: COMMUNICATION_URL + 'api/v1/notifications/',
    GET_NOTIFICATION_TEMPLATES_SEARCH_BY_SUBJECT_KEYWORDS: COMMUNICATION_URL + 'api/v1/notifications/search?keyword=',

    GET_CALL_TEMPALTES_LIST: COMMUNICATION_URL + 'api/v1/call-templates',
    DELETE_CALL_TEMPALTE_BY_ID: COMMUNICATION_URL + 'api/v1/call-templates/',
    SAVE_CALL_TEMPALTE_BY_DATA: COMMUNICATION_URL + 'api/v1/call-templates',
    GET_CALL_TEMPALTE_CAMPAGINS_BY_DATA: COMMUNICATION_URL + 'api/v1/call-templates/campaigns?onlyCampaigns=',
    UPDATE_CALL_TEMPALTE_BY_DATA_ID: COMMUNICATION_URL + 'api/v1/call-templates/',
    GET_CALL_TEMPLATES_SEARCH_BY_SUBJECT_KEYWORDS: COMMUNICATION_URL + 'api/v1/call-templates/search/by-name?name=',

    GET_WORKFLOW_STEPS_ORDERED: COMMUNICATION_URL + 'api/v1/workflow-steps/ordered',
    GET_WORKFLOW_STEPS_ORDERED_NEW: COMMUNICATION_URL + 'api/v1/workflow-steps/ordered/new',
    GET_OVERFLOW_STEPS_BY_NAME_SEARCH: COMMUNICATION_URL + 'api/v1/workflow-steps/search?name=',
    DELETE_WORKFLOW_STEPS_BY_ID: COMMUNICATION_URL + 'api/v1/workflow-steps/',
    SAVE_WORKFLOW_STEPS: COMMUNICATION_URL + 'api/v1/workflow-steps',
    UPDATE_WORKFLOW_STEPS: COMMUNICATION_URL + 'api/v1/workflow-steps/',
    GET_LIST_MAPPED_TEMPLATES_LIST_BY_ID: COMMUNICATION_URL + 'api/v1/workflow-step-mappings/step/',
    MAP_STEPS_WITH_TEMPALTES: COMMUNICATION_URL + 'api/v1/workflow-step-mappings',
    DELETE_MAPPED_STEPS_TEMPLATES: COMMUNICATION_URL + 'api/v1/workflow-step-mappings/',

    TEST_EMAIL_TEMPLATES: COMMUNICATION_URL + 'api/v1/templates/sendEmail?emailId=',
    TEST_SMS_TEMPLATES: COMMUNICATION_URL + 'api/v1/templates/sendSms?mobileNumber=',
    TEST_WHATSAPP_TEMPLATES: COMMUNICATION_URL + 'api/v1/templates/sendWhatsapp?mobileNumber=',
    GET_COMMUNICATION_TEAM_CODES: COMMUNICATION_URL + 'api/v1/communication/team-codes',
    GET_COMMUNICATION_SENDER_HEADERS: COMMUNICATION_URL + 'api/v1/communication/sender-headers',

    GET_EMAIL_TEMPLATE_FILES: COMMUNICATION_URL + 'api/v1/files',
    DELETE_EMAIL_TEMPALTE_FILES: COMMUNICATION_URL + 'api/v1/files?fileId=',
    UPLOAD_EMAIL_TEMPALTE_FILES: COMMUNICATION_URL + 'api/v1/files',
    DO_NOTIFY_API_BYID: COMMUNICATION_URL + 'api/v1/notify/doNotify?stepId=',
    GET_EMAIL_TEMPALTE_HTML: COMMUNICATION_URL + 'api/v1/files/',

    GET_LOGS_LIST: COMMUNICATION_URL + 'api/v1/log?page=',

    UPDATE_SYSTEM_PLAN_MAPPING: COMMUNICATION_URL + 'api/v1/workflow-step-mappings/',


    SAVE_OR_LOCK_CAC_MONTH_DATA: FINANCE_BACKEND + 'lockCacMonthData',
    SAVE_OR_LOCK_CINCOME_EFFICIENCY_MONTH_DATA: FINANCE_BACKEND + 'lockIncomeEfficiencyMonthData',
    UNLOCK_CAC_MONTH_DATA: FINANCE_BACKEND + 'unlockCacMonthData',
    UNLOCK_INCOME_MONTH_DATA: FINANCE_BACKEND + 'unlockIncomeEfficiencyMonthData',
    UNLOCK_TICKET_SIZE_MONTH_DATA: FINANCE_BACKEND + 'unlockTicketSizeDataMonthData',
    UNLOCK_MONTH_WISE_LOAN_MONTH_DATA: FINANCE_BACKEND + 'unlockMonthWiseLoanApplicationData',
    UNLOCK_COLLECTION_EFFCIENCY_LOAN_MONTH_DATA: FINANCE_BACKEND + 'unlockCollectionEfficiencyMonthData',

    GET_PRODUCT_JUNCTION_DETAILS: BASE_URL + 'getProductJunctionDetails',
    UPDATE_PRODUCT_NAME_BY_ID: BASE_URL + 'updateProductName?productId=',

    GET_LOAN_COLLECTION_REPORT_MONTH_WISE_BY_DATE: FINANCE_BACKEND + 'getLoanCollectionReportMonthWise?startDate=',
    SAVE_UPDATE_LOCK_PROVISION_DATA: FINANCE_BACKEND + 'saveUpdateOrLockProvisionData?date=',

    SAVE_TRANSACTION_DETAILS_RAZORPAY: BASE_URL + 'saveTransactionDetailRazorPay',
    SAVE_TRANSACTION_DETAILS_RAZORPAY_PAYMENT_SERVICE: PAYMENT_SERVICE_URL + 'api/v1/payment/manual/saveTransaction',
    GET_RAZORPAY_PAYMENT_DETAILS_PAYMENT_ID: BASE_URL + 'payments/getRazorpayPaymentDetailsByPaymentId?paymentId=',
    GET_RAZORPAY_PAYMENT_DETAILS_PAYMENT_ID_PAYMNET_SERVICE: PAYMENT_SERVICE_URL + 'api/payment-service/getPaymentDetailsByPaymentId?paymentId=',
    UPLOAD_REFUNDS_PAYMENTS: BASE_URL + 'payments/refunds/upload',

    GET_MONTHS_WISE_COLLECTION_EFFICIENCY_BY_DATE: FINANCE_BACKEND + 'getCollectionEfficiencyMonthWiseStats?startDate=',
    SAVE_OR_LOCK_COLLECTION_EFFICIENCY_MONTH_DATA: FINANCE_BACKEND + 'lockCollectionEfficiencyMonthData',

    GET_MONTHS_WISE_TICKET_SIZE_BY_DATE: FINANCE_BACKEND + 'getMonthWiseTicketSizeData?startDate=',
    SAVE_OR_LOCK_TICKET_SIZE_MONTH_DATA: FINANCE_BACKEND + 'lockTicketSizeDataMonthData',

    GET_MONTHS_WISE_LOAN_APPLICATION_BY_DATE: FINANCE_BACKEND + 'getMonthWiseLoanApplicationData?startDate=',
    SAVE_OR_LOCK_LOAN_APPLICATION_MONTH_DATA: FINANCE_BACKEND + 'lockMonthWiseLoanApplicationData',

    // Lead Management New
    GET_EMPLOYEE_TO_RULE: BASE_URL + 'api/emp-to-rule',
    GET_EMPLOYEE_TO_RULE_BY_EMPLOYEEID: BASE_URL + 'api/emp-to-rule/employee/',
    DELETE_EMPLOYEE_TO_RULE_BY_ID: BASE_URL + 'api/emp-to-rule/',
    SAVE_EMPLOYEE_TO_RULE: BASE_URL + 'api/emp-to-rule',

    GET_ALL_RULES_LIST: BASE_URL + 'api/v1/allocation-rules?includeInactive=true',
    GET_ALL_RULES_LIST_BY_RULEID: BASE_URL + 'api/v1/allocation-rules/by-ruleid/',
    DELETE_RULE_BY_RULEID: BASE_URL + 'api/v1/allocation-rules/',
    SAVE_RULES_BY_DATA: BASE_URL + 'api/v1/allocation-rules',
    ACTIVATE_DEACTIVATE_RULES_BY_ID: BASE_URL + 'api/v1/allocation-rules/',
    UPDATE_RULES_BY_RULEID: BASE_URL + 'api/v1/allocation-rules/',

    UPDATE_AADHAAR_STATUS_BY_APPLICATION_ID: BASE_URL + 'updateAadhaarStatus',
    GET_ASSIGNED_LEADS_OLDDER_THAN_PROVIDED_DAYS: BASE_URL + 'getAssignedLeadsOlderThanProvidedDays?noOfDays=',
    GET_STATUS_WISE_COUNT_LEAD_CATEGORIZTION_BY_HOUR: BASE_URL + 'getStatusWiseCountLeadCategorization?hour=',
    GET_STATUS_WISE_LEAD_DATA_BY_HOUR: BASE_URL + 'getStatusWiseLeadsData?hour=',
    GET_STATUS_WISE_LEAD_CATEGORIZATION_DATA_BY_HOUR: BASE_URL + 'getStatusWiseDataLeadCategorization?hour=',
    GET_STATUS_WISE_LEAD_ASSIGNMENT_DATA_BY_HOUR: BASE_URL + 'getStatusWiseDataLeadAssignment?hour=',

    GET_COMMUNICATION_LOGS_USERID_WISE: COMMUNICATION_URL + 'api/v1/log/user?userId=',

    UPDATE_UNLOCK_SUMMARY_DATA: FINANCE_BACKEND + 'unlockSummaryData',

    GET_CREDIT_ANALYSER_CHECKS_BY_USERID: BRE_BASE_URL + 'getCreditAnalyserChecks?userId=',
    GET_CRIF_ANALYSER_BY_USERID: BRE_BASE_URL + 'crifLoanAnalysis',
    GET_CRIF_INCLUDED_LOANS_EXCEPT_CREDIT_BY_USERID: BRE_BASE_URL + 'getIncludedLoansExceptCredit',

    GET_EMI_DATA_AUDIT_BY_DATA: FINANCE_BACKEND + 'getEmiDataAudit',

    DOWNLOAD_EXPECTED_PAYMENT_LIST_REPORT_BY_DATE: FINANCE_BACKEND + 'getExpectedPaymentsListReport?startDate=',
    DOWNLOAD_EXPECTED_PAYMENT_LIST_REPORT_BY_DATE_V1: FINANCE_BACKEND + 'v1/getExpectedPaymentsListReport?startDate=',
    DOWNLOAD_RECIEVED_PAYMENT_LIST_REPORT_BY_DATE: FINANCE_BACKEND + 'getRecievedPaymentsListReport?startDate=',
    GET_PAYEMNET_LIST_REPORT_DOWNLOADBY_LIST: FINANCE_BACKEND + 'getReceivedPaymentsListByPaymentBucketReport?startDate=',

    GET_GROUP_ASSIGNMENT_BY_ASSIGNED_TO_DEPT: BASE_URL + 'groupAssignmentsByAssignedToAndDept?sDate=',

    GET_MONTH_LEAD_FLOW_BY_APPLY_DATE_STATS: BASE_URL + 'monitorLeadFlowByApplyDateStats?sDate=',
    GET_MONTH_LEAD_FLOW_BY_APPLY_DATE_AND_DEPT_DATA: BASE_URL + 'monitorLeadFlowByApplyDateData?sDate=',
    GET_MONTH_LEAD_FLOW_BY_APPLY_DATE_AND_DEPT_STATS: BASE_URL + 'monitorLeadFlowByApplyDateAndDeptStats?sDate=',
    GET_MONTH_LEAD_FLOW_BY_APPLY_DATE_AND_DEPT_DATASS: BASE_URL + 'monitorLeadFlowByApplyDateAndDept?sDate=',

    PAYMENTS_MARKE_REFUNDED_UNVERIFIED_PAYMENTS: BASE_URL + 'payments/markRefund?loanId=',

    GET_OBLIGATION_ANAYLYSIS_BYID: BRE_BASE_URL + 'getObligationAnalysis?userId=',
    PAN_VERIFY_SETU_FOR_DUAL_PAN: BASE_URL + 'setu/panVerifyForDualPan?pan=',

    GET_BUSINESS_DEVELOPMENT_LEAD_PROGRESS_SUMMARY_FOR_EMPLOYEE_BY_DATE: FINANCE_BACKEND + 'businessDevelopment/getLeadProgressSummaryForEmployee?sDate=',
    GET_BUSINESS_DEVELOPMENT_LEAD_PROGRESS_PROGRESS_DATA_FOR_EMPLOYEE_BY_DATE: FINANCE_BACKEND + 'businessDevelopment/getLeadProgressDataForEmployee?sDate=',
    GET_LEAD_PROGRESS_SUMMARY_FOR_EMPLOYEE_BY_ID: FINANCE_BACKEND + 'credit/getLeadProgressSummaryForEmployee?sDate=',
    GET_LEAD_PROGRESS_DATA_FOR_EMPLOYEE_BY_ID: FINANCE_BACKEND + 'credit/getLeadProgressDataForEmployee?sDate=',
    GET_CIBIL_SCORE_DATA_BY_USERID: BRE_BASE_URL + 'loan/getCibilScoreDataByUserId?userId=',
    GET_OPERATIONS_LEAD_PROGRESS_SUMMARY_FOR_EMPLOYEE: FINANCE_BACKEND + 'operations/getLeadProgressSummaryForEmployee?sDate=',
    GET_OPERATIONS_LEAD_PROGRESS_DATA_FOR_EMPLOYEE: FINANCE_BACKEND + 'operations/getLeadProgressDataForEmployee?sDate=',
    GET_MANAGER_EMPLOYEE_FILTER: FINANCE_BACKEND + 'business-sheet/manager-employee-filter',

    SAVE_LOAN_EXPIRE_APPLICATION_STATUS: BASE_URL + 'loan/expireApplicationStatus',

    GET_APPROVAL_CHECKS_FOR_LOADID_BNY_USERID: BASE_URL + 'getApprovalChecksForLoanId?userId=',
    GET_AUTO_LOAN_OFFER_BY_USERID: BASE_URL + 'autoLoanOffer?userId=',

    // custom-reporting api 
    GET_META_DATA: REPORT_URL + "get-metadata?db_key=",
    GET_PREDEFINED_REPORTS: REPORT_URL + "get-predefined-reports?db_key=",
    GET_PREDEFINED_REPORT_COLUMN_BY_REPORTID: REPORT_URL + "get-predefined-columns?db_key=",
    GET_PREVIEW_REPORT_BY_PARAMS: REPORT_URL + "preview-report?db_key=",
    GET_DISTINCT_VALUES_FOR_TABLE_BY_TABLE_AND_COLUMN: REPORT_URL + "get-distinct-values?db_key=",
    DOWNLOAD_PREVIEW_REPORT_BY_PARAMS: REPORT_URL + "download-report?db_key=",

    GET_DASHBOARD_SUMMARY_BY_REPORT_URL: REPORT_URL + "dashboard-summary?db_key=",
    GET_DASHBOARD_DETAILS_BY_REPORT_STATUS: REPORT_URL + "dashboard-details?db_key=",
    BULK_ASSIGN_LOANS_BY_DATA: BASE_URL + 'bulkAssignLoans',

    DOWNLOAD_CICI_REPORT: BASE_URL + 'downloadCICReport?startDate=',

    GET_CRIF_SIMILARITY_WITH_INFO_BY_USERID_LOANID: BRE_BASE_URL + 'getCrifSimilarityWithUserInfo?userId=',
    GET_F1_DATA_AGRREGATOR_FINANCIAL_DETAILS: BRE_BASE_URL + 'getF1Data?userId=',
    GET_F1_STATUS_AGRREGATOR_FINANCIAL_DETAILS: BRE_BASE_URL + 'getStatusOfF1Data?userId=',
    CATEGORISE_TRANSACTION_BY_TYPE_USERID: BRE_BASE_URL + 'categoriseTransactionByType?type=',
    GET_BANK_VERIFICATION_STATUS_BY_USERID: BASE_URL + 'setu/getBankVerificationStatusByUserId?userId=',
    GET_ALL_DETAILS_BY_NAME_IN_ALL_APPLICATION: BASE_URL + 'userDetails/allDetailByName?name=',
    GET_LOGS_LISTBY_USERID_TYPE_DATE: COMMUNICATION_URL + 'api/v1/log/appUsers/',

    GET_AGGREGATED_COUNT_BY_FORM_STATUS_DATE: COMMUNICATION_URL + 'api/v1/log/getAggregatedCountByFormStatus?startDate=',
    GET_APP_USER_COMMUNICATION_LOGS_LIST: COMMUNICATION_URL + 'api/v1/log/appUsers?page=',
    GET_LOAN_LIFE_CYCLE_REPORT_BY_DATE: BASE_URL + 'getLoanLifeCycleReport?startDate=',
    GET_PFD_APPROVAL_REPORT_BY_DATE: BASE_URL + 'getPFDApprovalReport?startDate=',
    GET_CASHFREE_SUCCESS_MANDATES_REPORT_FROM_DATE: BASE_URL + 'getCashfreeSuccessMandates?dateFrom=',

    GET_EMAIL_TEMPLATES_FOR_COLLECTION_TENANT: COMMUNICATION_URL + 'api/v1/email-templates/collections',
    GET_SMS_TEMPLATES_FOR_COLLECTION_TENANT: COMMUNICATION_URL + 'api/v1/sms-templates/collections',
    GET_WHATSAPP_TEMPLATES_FOR_COLLECTION_TENANT: COMMUNICATION_URL + 'api/v1/whatsapp-templates/collections',
    GET_RECOVERY_ALL_COMMENT_LIST: BASE_URL + 'getRecoveryCommentsList',
    GET_COMMUNICATION_COMMENTS_LIST_BY_LOANID: BASE_URL + 'getCommunicationCommentsByLoanId?loanId=',
    SAVE_OR_UPDATE_RECOVERY_COMMENTS: BASE_URL + 'saveOrUpdateRecoveryComments',
    GET_COMMUNICATION_PREVIEW_TEMPLATE_BYTEMPLATEID: COMMUNICATION_URL + 'api/v1/communication/previewTemplate?templateId=',
    GET_COMMUNICATION_PREVIEW_TEMPLATE_WITH_CONTEXT_BYTEMPLATEID: COMMUNICATION_URL + 'api/v1/communication/previewTemplateWithContext?templateId=',
    SEND_DIRECT_TEMPLATE_USING_TEMPLATE_ID_AND_TYPE: COMMUNICATION_URL + 'api/v1/notify/executeDirectTemplate?templateId=',
    SAVE_DIRECT_TEMPLATE_WITH_CONTEXT_USING_TEMPLATE_ID: COMMUNICATION_URL + 'api/v1/notify/executeDirectTemplateWithContext?templateId=',

    GET_CASHFREE_SUBSCRIPTION_CUSTOMERID_BY_LOANID: BASE_URL + 'api/cashfree/getCashfreeSubscriptionAndCustomerId?loanId=',
    GET_RAJORPAY_ORDER_ID_UPI: BASE_URL + 'enashAndEsign/getRajorPayOrderIdCustomerIdUpi?loanId=',
    GET_RAJORPAY_ORDER_ID_EV: BASE_URL + 'enashAndEsign/getRajorPayOrderIdCustomerIdEV?loanId=',
    GET_CASHFREE_CHECK_AUTH_STATUS_BY_USERID: BASE_URL + 'api/cashfree/checkAuthStatus?userId=',

    GET_LEGAL_NOTICE_HTML_FOR_OVERDUE_EMIS: BASE_URL + 'getLegalNoticeHTMLForOverdueEmis?loanId=',
    GET_KFS_HTML_NEW: BASE_URL + 'getKfsHtmlByLoanIdNew?loanId=',
    USER_DETAILS_AADHAR_EXIST_BY_AADHAR_NUMBER: BASE_URL + 'userDetails/aadharExist?aadharNumber=',
    CHECK_PAN_EXIST: BASE_URL + 'userDetails/existPanNumber?panNumber=',
    INITATE_ESIGN: BASE_URL + 'setuEsign/initiateEsign?loanId=',
    INITAITE_ESIGN_SIFGNZY: BASE_URL + 'esignzyMandateByLoanId?loanId=',
    INITATE_ESIGN_EV: BASE_URL + 'setuEsign/initiateEsignEV?loanId=',
    ESIGN_SIGNATURE_STATUS: BASE_URL + 'setuEsign/getSignatureStatusAndDownload?loanId=',
    GET_ESGIN_STATUS_BY_LOANID: BASE_URL + 'getEsignByLoanId?loanId=',
    FETCH_SIGNZY_AADHAAR: BASE_URL + 'fetchSignzyEaadhar?userId=',
    FETCH_DIGILOCKER_DETAILS_BY_USERID: BASE_URL + 'fetchDigitapDigilockerDetails?userId=',

    CREATE_SETU_DIGILOCKER_GET_KYC_STATUS_FOR_KYC: BASE_URL + 'setu/getKycStatusByUserId?userId=',
    CREATE_SETU_DIGILOCKER_REUEST_FOR_KYC: BASE_URL + 'setu/createDigiLockerRequest?userId=',
    CREATE_SETU_DIGILOCKER_GET_STATUS_FOR_KYC: BASE_URL + 'setu/getDigiLockerStatus?requestId=',
    DIGILOCKER_SIGN3_INIT: BASE_URL + 'digilocker/sign3/init?userId=',
    DIGILOCKER_SIGN3_FETCH_DETAILS: BASE_URL + 'digilocker/sign3/fetch-details?userId=',
    // Expense apis

    CRED_TRANSACTIONS_ALL: FINANCE_BACKEND + 'api/v1/cred-transactions/all',
    CRED_TRANSACTIONS_ALL_MONTH: FINANCE_BACKEND + 'api/v1/cred-transactions/by-month/',
    CRED_TRANSACTIONS_SEARCH_TEXT: FINANCE_BACKEND + 'api/v1/cred-transactions/filter?text=',
    SAVE_TRANSACTION_CATEGORY: FINANCE_BACKEND + 'api/v1/transaction-mapping',
    SAVE_TRANSACTION_BY_CSV: FINANCE_BACKEND + 'api/v1/excel/upload',
    CRED_TRANSACTION_FILTER: FINANCE_BACKEND + 'api/v1/cred-transactions/type?debit=',
    CRED_TRANSACTION_MAPPING: FINANCE_BACKEND + 'api/v1/cred-transactions/mapping?mapped=',
    GET_COMBINE_STATS: FINANCE_BACKEND + 'api/v1/business-statement/combineStats',
    GET_CASHFLOW_STATEMENT: FINANCE_BACKEND + 'api/v1/cashflow-statement',



    // EV Module 
    GET_DEALER_LIST_DETAILS: BASE_URL + 'api/dealer/getDealersDetail',
    SAVE_DEALER_DATA: BASE_URL + 'api/dealer/save',
    UPDATE_DEALER_DATA: BASE_URL + 'api/dealer/update',
    DELETE_DEALER_DATA: BASE_URL + 'api/dealer/delete?id=',

    GET_BATTERY_LIST_DETAILS: BASE_URL + 'api/batteryMaster/getBatteryDetail',
    SAVE_BATTERY_DATA: BASE_URL + 'api/batteryMaster/save',
    UPDATE_BATTERY_DATA: BASE_URL + 'api/batteryMaster/update',
    DELETE_BATTERY_DATA: BASE_URL + 'api/batteryMaster/delete?id=',


    ENACH_ESIGN_CHECK_STATUS: BASE_URL + 'enashAndEsign/checkEnachStatus/',
    ENACH_ESIGN_CASHFREE_EV: BASE_URL + 'api/cashfree/getCashfreeSubscriptionAndCustomerIdEV?loanId=',
    CREATE_MANDATE_REQ_PAYU: PAYMENT_SERVICE_URL + 'api/v1/payment/payu/createMandate',
    CREATE_MANDATE_REQ_EASEBUZZ: PAYMENT_SERVICE_URL + 'api/v1/payment/easebuzz/createMandate',

    // EXotel Calling 

    GET_EXOTEL_CALL_LOGS_BY_FITLERS: COMMUNICATION_URL + 'api/v1/log/filter?type=',
    PUSH_EXOTEL_DATA_FOR_CALL: COMMUNICATION_URL + 'api/v1/templates/scheduleCall?templateId=',

    CHECK_DUPLICATE_USER_DETAILS_BY_ID: BASE_URL + 'checkDuplicateUserDetailsByUserId?userId=',

    GET_USER_DETAILS_BY_PRIMARY_NUMBER_EXOTEL: BASE_URL + 'abhicash/getUserDetailsByPrimaryNumber?number=',

    GET_STAMP_DUTY_TRACKER_REPORT_BY_DATE: BASE_URL + 'getStampDutyUsageReport?startDate=',

    UPDATE_NACH_STATUS_BY_USERID: BASE_URL + 'enashAndEsign/updateNachStatusByUserId?userId=',
    UPDATE_NACH_STATUS_BY_USERID_NEW: BASE_URL + 'enashAndEsign/deactivateEnachForActiveService?userId=',
    GET_DEACTIVATE_ENACH_FOR_ACTIVE_SERVICE: PAYMENT_SERVICE_URL + 'api/payment-service/deactivateEnachForActiveService?userId=',
    GET_USER_DOCUMENT_DO_BY_USERID: BASE_URL + 'getUserDocumentDOUserId?userId=',
    UPDATE_USER_DOCUMENTS_DETAILS_DO_BY_DATA: BASE_URL + 'updateUserDocumentDetailsDO',


    CHECK_GAURONTAR_AND_COBORROWER_BY_USERID: BASE_URL + 'checkCoBorrowerAndGuarantor?userId=',
    GET_LOAN_ELIGIBLITY_BY_USERID: BASE_URL + 'getLoanEligibility?userId=',
    GET_ALL_USER_DETAILS_INCOMPLETE_BY_USERID: BASE_URL + 'userDetails/alluserDetailByUserIdInCompleteEV?userId=',
    GET_DOCUMENT_LISTBY_USERID: BASE_URL + "getDocumentsListForUser?pageNumber=",
    SAVE_USER_PERSONAL_INFO_IN_ALL_APPLICATIONS: BASE_URL + 'saveUserBasicInfo',
    SAVE_USER_BASIC_INFO_IN_ALL_APPLICATIONS: BASE_URL + 'saveOrUpdateUserAdditionalInfo',
    SAVE_USER_ADDRESS_INFO_IN_ALL_APPLICATIONS: BASE_URL + 'saveUserAddressInfo',
    SAVE_ASSET_VEHICLE_INFO_IN_ALL_APPLICATIONS: BASE_URL + 'saveOrUpdateAssetAndVehicleDetail',
    SAVE_UPDATE_USER_EMPLOYMENT_DETAILS: BASE_URL + 'saveOrUpdateUserEmploymentDetail',
    SAVE_ACCOUNT_DETAILS_IN_ALL_APPLICATIONS: BASE_URL + 'userDetails/addAccountDetails',
    SAVE_UPLOAD_FILE_DOC_DETAILS: BASE_URL + "saveAndUploadFileAndDocDetail",

    GET_ASSET_AND_VEHICLE_DETAILS: BASE_URL + 'getAssetAndVehicleDetail?userId=',

    GET_PENDING_DOCUMENT_CONFIGS_BY_USERID: BASE_URL + "getPendingDocumentConfigs?userId=",
    DIRECT_DOWNLOAD_ANY_FILE_BY_FILE_NAME: BASE_URL + 'direct-download?fileName=',
    UPLOAD_CSV_URL: LLM_NEW_BASE_URL + "upload-csv-url",

    GET_CASH_FREE_REPORT_DATA_BY_DATE: BASE_URL + 'getCashfreeReportData?dateFrom=',
    UPDATE_PENDING_PAYMENTS_BY_LOANID: BASE_URL + 'payments/updatePendingPaymentsByLoanId?loanId=',

    // Refrence 
    GET_ALL_REFERENCE_DATA: BASE_URL + 'getAllReferenceData',
    GET_DISTINCT_EMPLOYEES: BASE_URL + 'distinctEmployees',
    GET_ALL_REFRENCE_BY_REFRENCE_CODES: BASE_URL + 'getEmployeeReferenceCodes?employeeId=',
    SAVE_OR_GENERATE_REFRENCE_CODES: BASE_URL + 'generateReferenceCode',
    GET_REFRENCE_DASHBOARD_COUNT_BY_DATE: BASE_URL + 'getReferenceDashboardCount?startDate=',
    GET_LOAN_STATUS_REFRENCE_BY_DATE: BASE_URL + 'getLoanStatusByReference?startDate=',
    GET_REJECTION_STATS_REFRENCE_BY_DATE: BASE_URL + 'getRejectionStatsByReference?startDate=',
    GET_CONVERSION_STATS_REFRENCE_BY_DATE: BASE_URL + 'getConversionDetailsByReference?startDate=',
    GET_DISBURSED_STATS_REFRENCE_BY_DATE: BASE_URL + 'getDisbursementStatsByReference?startDate=',
    GET_APPLIED_COUNT_STATS_BY_REFRENCE_BY_DATE: BASE_URL + 'getAppliedCountStatsByReference?startDate=',
    GET_APPLIED_DATA_BY_REFRENCE_BY_DATE: BASE_URL + 'getAppliedDataByReference?startDate=',
    GET_DISBURSED_STATS_BY_REFRENCE_BY_DATE: BASE_URL + 'getDisbursedStatsByReference?startDate=',
    DELETE_REFRENCE_BY_ID: BASE_URL + 'deleteReferenceById?id=',

    GET_PREVIOUS_CALL_LOGS_HISTORY_BY_NUMBER: COMMUNICATION_URL + 'api/v1/log/previousCallHistory?mobileNumber=',
    GET_APPROVED_LEADS_STATS: BASE_URL + 'loan/getApprovedLeadsStats',



    GET_EVBRE_SCORE_UPDATED: BASE_URL + 'getEvBreScoreUpdated?userId=',
    GET_EVBRE_DECISION: BASE_URL + 'getBreDecision?userId=',
    SAVE_UPDATE_BRECONFIG_DATA: BASE_URL + 'saveOrUpdateBreConfigData?userId=',
    GET_BRE_CONFIG_DATA: BASE_URL + 'getBreConfigData',



    GET_RECOVERY_COMMENTS_BY_EMIID: BASE_URL + 'getRecoveryCommentsByEmiId?loanId=',
    GET_RECOVERY_COMMENTS_BY_LOANID: BASE_URL + 'getRecoveryCommentsByLoanId?loanId=',
    GET_ASSET_IMAGES_BY_USERID: BASE_URL + 'getAssetImagesByUserId?userId=',

    GET_CIBIL_LOAN_ELIGIBILITY_BY_LOANID: BASE_URL + 'cibilCheck/getCibilEligibilityByLoanId?loanId=',
    SAVE_CIBIL_CHECK_ELIGIBILITY_BY_DATA: BASE_URL + 'cibilCheck/saveCibilEligibilityCheck',

    GET_TVR_DETAILS_BY_LOANID: BASE_URL + 'tvr/loan/',
    SAVE_TVR_DETAILS_BY_DATA: BASE_URL + 'tvr/save',

    GET_EV_LOAN_DETAILS_BY_ID: BASE_URL + 'getEvLoanDetail?userId=',

    GET_TOTAL_OBLIGATION_AMOUNT_BY_ID: BRE_BASE_URL + 'getTotalObligationAmount?userId=',
    GET_TOTAL_OBLIGATION_AMOUNT_EXCEPT_CREDIT_BY_ID: BRE_BASE_URL + 'getIncludedExceptCreditObligationAmt?userId=',

    GET_WHATSAPP_TEMPLATE_FOR_EV: COMMUNICATION_URL + 'api/v1/whatsapp-templates/ev',


    GET_COLLECTION_REPORT_SUMMARY: REPORT_URL + 'collection-summary',
    GET_COLLECTION_REPORT_WEEKLY: REPORT_URL + 'collection-weekly?month_start=',
    GET_COLLECTION_REPORT_DAILY: REPORT_URL + 'collection-daily?week_start=',
    DOWNLOAD_COLLECTION_RAW_REPORT: REPORT_URL + 'collection-raw',

    SAVE_UPDATED_PENALTY_COINFIG: BASE_URL + 'saveOrUpdatePenaltyConfig',
    GET_PENALTY_CONFIG_BYPAGE: BASE_URL + 'getPenaltyConfigData?pageNo=',
    DELETE_PENALTY_CONFIG_BY_ID: BASE_URL + 'deletePenaltyConfig?id=',

    GET_ACTIVE_PAYMENT_GATEWAY_SERVICE: BASE_URL + 'enashAndEsign/getActivePaymentGatewayService',
    GET_ACTIVE_MANDATES_SERVICE_BY_LOANID: PAYMENT_SERVICE_URL + 'api/payment-service/activeMandateService?loanId=',
    SAVE_UPDATE_NACH_OPTION_BYID_AND_DATA: BASE_URL + 'abhicash/saveOrUpdateNachOption?loanId=',
    GET_ACTIVE_PAYMENT_SERVICE_PAYMENTSERVICE: PAYMENT_SERVICE_URL + 'api/payment-service/activeGatewayService?loanId=',
    DOWNLOAD_KFS_BY_LOANID: BASE_URL + 'downloadKfs?loanId=',
    UPDATE_SETTLEMENT_STATUS_EMI_FOR_USER: BASE_URL + 'updateSettlementStatusEmiForUser',

    SAVE_MODE_OFPAYMENT_BY_USEDID: BASE_URL + 'abhicash/saveModeOfPaymentByUserId?modeOfPayment=',
    SAVE_EMPLOYER_TYPE_BY_USEDID: BASE_URL + 'abhicash/saveEmploymentTypeByUserId?employerType=',

    GET_DECYPTEDNUMBER_FROM_AMEYO_EXOTEL_USING_MASKED_NUMBER: COMMUNICATION_URL + 'api/v1/communication/getDecryptedValueForMaskedNumber?maskNumber=',

    GET_SOA_HTML_BY_LOANID: BASE_URL + 'getSoaHtmlByLoanId?loanId=',
    GET_SOA_EV_HTML_BY_LOANID: BASE_URL + 'getEvSoaHtmlByLoanId?loanId=',


    CHATBOT_CHAT_API: LLM_BASE_URL + "chat",
    CHATBOT_CHAT_DOWNLOAD_API: LLM_BASE_URL + "download/",
    COLLECTION_CHAT_API: LLM_BASE_URL + "query",
    CHAT_CONVERSATION: LLM_BASE_URL + "conversation-history",
    GET_CONVERSATION_LIST: LLM_BASE_URL + "get-conversations-list",
    GET_HEALTH: LLM_BASE_URL + "health",
    SUBMIT_FEEDBACK: LLM_BASE_URL + "submit-feedback",

    UPDATE_FORM_STATUS_BY_ID: BASE_URL + "userDetails/updateFormStatus?userId=",
    GET_PAYMENT_RECIEPT_BY_PAYMENTID: BASE_URL + "payments/receipt?paymentId=",

    SAVE_PARTNER_NAME_BY_CSV_DATA: BASE_URL_MARKETING + "savePartnerNameByCsv",
    GET_LIST_UNMAPPED_CAMPAIGNS: BASE_URL_MARKETING + "unmappedCampaigns",
    GET_ALL_AGGREGATORS_NAMES: BASE_URL_MARKETING + "getAllAggregatorNames",
    GET_ALL_PARTNER_NAMES_BY_AGGREGATOR_NAMES: BASE_URL_MARKETING + "getPartnersByAggregatorName?aggregatorName=",
    SAVE_CAMPAGINS_MAPPINGS_DATA: BASE_URL_MARKETING + "saveCampaignMapping",
    MAPPED_CAMPAIGNS_GET: BASE_URL_MARKETING + "mappedCampaigns",
    DOWNLOAD_MAPPED_CAMPAIGNS_LIST: BASE_URL_MARKETING + "downloadMappedCampaigns",

    GET_DOWNLOAD_REPORT_FOR_COMMUNICATION_LOGS: COMMUNICATION_URL + "api/v1/log/downloadReport?type=",

    SAVE_UPDATE_ASSET_VEHICLE_DETAILS: BASE_URL + "saveOrUpdateAssetAndVehicleDetail",

    GET_CHEQUE_ENABLE_BY_USERID: BASE_URL + "getChequeEnable?userId=",
    UPDATE_CHEQUE_ENABLE_BY_USERID: BASE_URL + "updateChequeEnable?userId=",

    UPDATE_AADHAAR_NUMBER_EV_BYID: BASE_URL + "updateAadhaarNumberEV?userId=",

    GET_MONTHLY_EMI_WITH_PFD_DISCOUNT: BASE_URL + "getMonthlyEmiWithPFDiscount/",

    COLLECTION_CHAT_API: LLM_BASE_URL + "query",
    COLLECTION_DOWNLOAD_API: LLM_BASE_URL + "download",

    GET_USER_DETAILS_EV_FOR_OVERVIEW: BASE_URL + "getUserDetailsEV?userId=",

    GET_CONSENT_STATUS_BY_USERID: BRE_BASE_URL + "getConsentStatus?userId=",
    GET_REQUEST_ANALYSIS_USERID: BRE_BASE_URL + "requestAnalysis?userId=",
    GET_POLL_BSA_ANALYSIS_USERID: BRE_BASE_URL + "pollBsaStatus?userId=",
    GET_BSA_TXN_ANALYSIS_USERID: BRE_BASE_URL + "getBsaTxns?userId=",
    GET_AA_INSIGHTS_DATA_BY_USERID: BRE_BASE_URL + "getAAInsights?userId=",
    GET_FI_DATA_BY_USERID: BRE_BASE_URL + "getFIData?userId=",
    GET_THREE_MONTHS_AGGREGATOR_ANALYSIS_BY_DATA: BRE_BASE_URL + "getThreeMonthAggregatorAnalysis?userId=",
    CREATE_PERIODIC_FETCH_V2_BY_IDS: BRE_BASE_URL + "createPeriodicFetchV2?userId=",
    GET_ANALYZED_STATEMENT_BY_USERID: LLM_BASE_URL + "getAnalyzedStatement?userId=",
    GET_BSA_DATA_BY_USERID: BRE_BASE_URL + "getBsaData?userId=",

    GET_DUE_LIST_EV_BY_DATE: BASE_URL + "collection/getDueList?sDate=",
    DOWNLOAD_DUE_LIST_EV_BY_DATE: BASE_URL + "getEVDueListReport?sDate=",


    // Payment Service 
    CHECK_ENACH_STATUS_PAYMENT_SERVICE: PAYMENT_SERVICE_URL + "api/payment-service/checkEnachStatus/",
    CREATE_MANDATE_RAZORPAY_PAYMENT_SERVICE: PAYMENT_SERVICE_URL + "api/v1/payment/razorpay/createMandate",
    PAYMENT_SERVICE_CALLBACK_URL_RAZORPAY: PAYMENT_SERVICE_URL + "api/v1/payment/razorpay/",


    GET_ENACH_STATUS_BY_USERID: BASE_URL + "getEnachStatusByUserId?userId=",
    GET_WHATSAPP_TEMPLATE_MANUAL_LIST: COMMUNICATION_URL + "api/v1/whatsapp-templates/manual",

    BULK_LEAD_ASSINGMENT_BY_DEPARTMENT_LIST: BASE_URL + "leadAssignments/byDepartment?department=",

    // Aggregator Dashboard 
    GET_AGGREGATOR_EVENTS_BY_MONTH: BASE_URL_MARKETING + "getAggregatorEvents?startDate=",
    GET_AGGREGATOR_ATS_BY_DATE: BASE_URL_MARKETING + "getAggregatorAts?sDate=",
    GET_AGGREGATOR_PAYOUT_BY_DATE: BASE_URL_MARKETING + "getAggregatorPayouts?sDate=",
    GET_AGGREGATOR_LOAN_STATS_BY_DATE: BASE_URL_MARKETING + "getAggregatorLoanStats?sDate=",
    GET_AGGREGATOR_DATA_BY_DATE: BASE_URL_MARKETING + "getAggregatorData?startDate=",

    DOWNLOAD_REJECT_REASON_COUNT_BY_START_DATE: BASE_URL_MARKETING + "downloadRejectReasonCount?startDate=",


    // New Cred Transactions API (Integrated)
    SAVE_CRED_TRANSACTION_NEW: FINANCE_BACKEND + 'api/v1/cred-transactions',
    GET_CRED_TRANSACTION_BY_ID: FINANCE_BACKEND + 'api/v1/cred-transactions/',
    GET_CRED_TRANSACTION_BY_VOUCHER: FINANCE_BACKEND + 'api/v1/cred-transactions/by-voucher/',
    GET_CRED_TRANSACTIONS_BY_DATE_RANGE: FINANCE_BACKEND + 'api/v1/cred-transactions?startDate=',
    GET_CRED_TRANSACTIONS_BY_TYPE_DATE: FINANCE_BACKEND + 'api/v1/cred-transactions/by-type?startDate=',
    UPDATE_CRED_TRANSACTION_PARTICULARS: FINANCE_BACKEND + 'api/v1/cred-transactions/',
    DELETE_CRED_TRANSACTION_NEW: FINANCE_BACKEND + 'api/v1/cred-transactions/',

    // Annual Report APIs (Integrated)
    GET_REPORT_ACTUAL_VS_BUDGET: FINANCE_BACKEND + 'api/v1/annual-report/actual-vs-budget?startDate=',
    GET_REPORT_DISTRIBUTION: FINANCE_BACKEND + 'api/v1/annual-report/distribution?startDate=',
    GET_REPORT_REMAINING_SUMMARY: FINANCE_BACKEND + 'api/v1/annual-report/remaining-summary?startDate=',
    GET_REPORT_INCOME_SPENDING: FINANCE_BACKEND + 'api/v1/annual-report/income-spending?startDate=',
    GET_REPORT_MONTHLY_SUMMARY: FINANCE_BACKEND + 'api/v1/annual-report/monthly-summary?startDate=',
    GET_REPORT_ANNUAL_BREAKDOWN: FINANCE_BACKEND + 'api/v1/annual-report/annual-breakdown?startDate=',
    GET_REPORT_MAIN: FINANCE_BACKEND + 'api/v1/annual-report/report?startDate=',
    GET_REPORT_TOTAL_SUMMARY: FINANCE_BACKEND + 'api/v1/annual-report/total-summary?startDate=',
    GET_REPORT_ACTUAL_BUDGET_SUMMARY: FINANCE_BACKEND + 'api/v1/annual-report/actual-budget-summary?startDate=',
    GET_REPORT_ACTUAL_BUDGET_MONTHLY_BREAKDOWN: FINANCE_BACKEND + 'api/v1/annual-report/actual-budget-monthly-breakdown?month=',
    GET_REPORT_ACTUAL_BUDGET_MONTHLY_SUMMARY: FINANCE_BACKEND + 'api/v1/annual-report/actual-budget-monthly-summary?startDate=',
    EXPENSE_ACTUAL: FINANCE_BACKEND + 'api/expenses/actual',
    EXPENSE_FORECAST: FINANCE_BACKEND + 'api/expenses/forecast',
    EXPENSE_DEVIATION: FINANCE_BACKEND + 'api/expenses/deviation',
    EXPENSE_BULK_DEVIATION: FINANCE_BACKEND + 'api/expenses/save-bulk-deviation',
    SAVE_EXPENSE_DIRECT: FINANCE_BACKEND + 'expense/saveExpense',
    GET_EXPENSE_ACTUAL_DIRECT: FINANCE_BACKEND + 'api/expenses/actual',
    GET_EXPENSE_FORECAST_DIRECT: FINANCE_BACKEND + 'api/expenses/forecast',
    GET_EXPENSE_DEVIATION_DIRECT: FINANCE_BACKEND + 'api/expenses/deviation',
    BUDGET_PLANNING_SAVE: FINANCE_BACKEND + 'api/budget-planning/save',
    BUDGET_PLANNING_GET: FINANCE_BACKEND + 'api/budget-planning/get',
    BUDGET_TARGET_SAVE: FINANCE_BACKEND + 'api/budget-target/save',
    BUDGET_TARGET_GET: FINANCE_BACKEND + 'api/budget-target/get',
    BUDGET_ALLOCATION_SAVE: FINANCE_BACKEND + 'api/budget-allocation/save',
    BUDGET_ALLOCATION_GET: FINANCE_BACKEND + 'api/budget-allocation/get',

    DOWNLOAD_ALL_OVERDUE_EMI_REPORT_DATA: FINANCE_BACKEND + 'getAllOverdueEMIsReport?startDate=',
    // FORECAST_COMPARISION: FINANCE_BACKEND + "api/expenses/getMonthwiseActualExpenseData",
    FORECAST_COMPARISION: FINANCE_BACKEND + "api/expenses/monthly-expense-trends",


    // Expense Direct Endpoints (as per Postman)
    SAVE_EXPENSE_DIRECT: FINANCE_BACKEND + 'expense/saveExpense',
    GET_EXPENSE_ACTUAL_DIRECT: FINANCE_BACKEND + 'api/expenses/actual',
    GET_EXPENSE_FORECAST_DIRECT: FINANCE_BACKEND + 'api/expenses/forecast',
    GET_EXPENSE_DEVIATION_DIRECT: FINANCE_BACKEND + 'api/expenses/deviation',

    // Delete Expense APIs (as per Postman)
    DELETE_EXPENSE_ACTUAL: FINANCE_BACKEND + 'api/expenses/actual/',
    DELETE_EXPENSE_FORECAST: FINANCE_BACKEND + 'api/expenses/forecast/',

    // Update Expense API
    UPDATE_EXPENSE_DATA: FINANCE_BACKEND + 'api/expenses/actual/',

    // Excel Upload API (Integrated)
    UPLOAD_EXCEL_API: FINANCE_BACKEND + 'api/v1/excel/upload',

    // Business Marketing API (Integrated)
    GET_MARKETING_COUNTS_DATE: FINANCE_BACKEND + 'getMarketingCounts?startDate=',


    // new generate report apis 
    UPLOAD_CSV: LLM_NEW_BASE_URL + "upload-csv",
    ASK_AI: LLM_NEW_BASE_URL + "ask",
    GET_SESSIONS: LLM_NEW_BASE_URL + "sessions/",
    GET_CONVERSATION: LLM_NEW_BASE_URL + "conversation/",

    // api tracker 
    GET_API_OVERVIEW_LEAD_JOURNEY_BY_DATE_RANGE: FINANCE_BACKEND + 'apiTracker/getLeadJourneyFunnelByDateRange?startDate=',
    GET_API_OVERVIEW_LEAD_LEAKAGE_INSIGHTS_BY_DATE_RANGE: FINANCE_BACKEND + 'apiTracker/getLeakageInsights?startDate=',
    GET_LEAD_JOURNEY_DROP_OUT_COUSTOMER_REASON: FINANCE_BACKEND + "apiTracker/getDropoutCustomersByReason?startDate=",
    GET_LEAD_JOURNEY_DROP_OUT_ANALYSIS: FINANCE_BACKEND + "apiTracker/getDropoutReasonAnalysis?startDate=",
    GET_LEAD_JOURNEY_STAGE_ANALYSIS: FINANCE_BACKEND + "apiTracker/getStageAnalysis?startDate=",
    GET_DROP_OFF_LEAD_LIST_BY_FILTERS: FINANCE_BACKEND + "apiTracker/dropOffLeadList?stage=",
    GET_API_OVERALL_SUMMARY_BY_DATE_STATUS: FINANCE_BACKEND + 'apiTracker/getApiOverallSummary?startDate=',
    GET_API_COST_SUMMARY_BY_FILTERS: FINANCE_BACKEND + 'apiTracker/getApiCostSummary?startDate=',
    GET_API_COST_SUMMARY_HITS_BY_FILTERS: FINANCE_BACKEND + 'apiTracker/getApiHitsSummary?startDate=',
    GET_API_HIT_TRENDS_BY_DATA_RANGE_APIID: FINANCE_BACKEND + 'apiTracker/getApiHitTrendsByDataRangeAndApiId?startDate=',
    GET_THIRD_PARTY_API_LIST_BY_DATA: FINANCE_BACKEND + 'apiTracker/getThirdPartyApisList',
    GET_THIRD_PARTY_API_LIST_CATEGORY_WISE_BY_DATA: FINANCE_BACKEND + 'apiTracker/getCategoryWiseThirdPartyApisList',
    GET_LEAD_TO_DISBURSMENT_FUNNEL_BY_DATA_RANGE: FINANCE_BACKEND + 'apiTracker/getLeadToDisbursementFunnelByDataRange?startDate=',
    GET_USER_DATA_BY_DATE_RANGE: FINANCE_BACKEND + 'apiTracker/getUsersDataByDataRangeAndApiId?page=',
    GET_API_OVERALL_SUMMARY_FORM_STATUS_BY_DATE: FINANCE_BACKEND + 'apiTracker/getApiOverallSummaryFormStatus?startDate=',
    DOWNLOAD_USER_DATA_BY_DATE_RANGE: FINANCE_BACKEND + 'apiTracker/getUsersDataByDataRangeAndApiId?startDate=',
    GET_LEAD_FUNNEL_BY_DATE_RANGE: FINANCE_BACKEND + 'apiTracker/getLeadStagesFunnelByDateRange?startDate=',
    GET_SANCTION_TREND_DATA_BY_DATE_RANGE: FINANCE_BACKEND + 'apiTracker/getApprovedVsDisbursedTrendsByDataRange?startDate=',
    GET_SANCTION_STATS_DATA_BY_DATE: FINANCE_BACKEND + 'apiTracker/getApprovalVsDisbursementDataByDataRange?startDate=',
    GET_SANCTION_LEADS_BY_DATE_RANGE: FINANCE_BACKEND + 'apiTracker/getApprovedLeadsByDataRange?startDate=',
    GET_DISBURSED_TREND_DATA_BY_DATE_RANGE: FINANCE_BACKEND + 'apiTracker/getDisbursedTrendsByDataRange?startDate=',
    GET_DISBURSED_STATS_DATA_BY_DATE: FINANCE_BACKEND + 'apiTracker/getDisbursedDataByDataRange?startDate=',
    GET_DISBURSED_LEADS_BY_DATE_RANGE: FINANCE_BACKEND + 'apiTracker/getDisbursedLeadsByDataRange?startDate=',
    DOWNLOAD_SANCTION_APPROVED_DATA_BY_DATE_RANGE: FINANCE_BACKEND + 'apiTracker/getApprovedLeadsByDataRangeExcel?startDate=',
    DOWNLOAD_DISBURSED_DATA_BY_DATE_RANGE: FINANCE_BACKEND + 'apiTracker/getDisbursedLeadsByDataRangeExcel?startDate=',
    DOWNLOAD_LEAD_JOURNEY_DROP_OUT_COUSTOMER_REASON: FINANCE_BACKEND + "apiTracker/getDropoutCustomersByReasonExcel?startDate=",

    // Marketing Dashbaord new 
    GET_MARKETING_PERFORMANCE_STATS_BY_DATE: BASE_URL_MARKETING + 'getMarketingPerformanceStats?startDate=',
    GET_MARKETING_PERFORMANCE_STATS_BY_DATE_NEW: BASE_URL_MARKETING + 'getDisbursedStats?sDate=',
    GET_LATEST_EVENT_TIMESTAMP: BASE_URL_MARKETING + 'latestEventTimestamp',
    GET_LEADS_BY_STATUS_DATE: BASE_URL + 'userDetails/leadsByStatus?startDate=',
    DOWNLOAD_LEADS_BY_STATUS_DATE: BASE_URL + 'userDetails/downloadLeadsByStatus?startDate=',

    GET_QUID_EQUIFAX_BY_ID: BASE_URL + 'quid/getQuidEquifaxDataByUserId?userId=',

    GET_TRNSACTION_LIST_BY_PAYMENT_SERVICE: PAYMENT_SERVICE_URL + 'api/payment-service/transactions?loanId=',
    SAVE_COMMENT_FOR_TRANSACTION_LIST_BY_APYMENT_SERVICE: PAYMENT_SERVICE_URL + 'api/payment-service/transaction/comment',
    GET_DISBURSMENT_OTP_SEND: BASE_URL + 'disbursementOtp/sendOtp',
    DOWNLOAD_FEDONE_PAYMENT_UPLOAD_REPORT: BASE_URL + 'getFedOnePaymentUploadReport?status=',
    DOWNLOAD_ICIC_PAYMENT_UPLOAD_REPORT: BASE_URL + 'bulkIciciTransactionExcel',
    GET_DISBURSMENT_OTP_SEND_VERIFY: BASE_URL + 'disbursementOtp/verifyOtp',

    GET_ALL_TRANSACTION_BY_DATE_RANGE: BASE_URL + "getAllTransactionByDateRange?startDate=",
    UPLOAD_PAYMENT_REFUND_SHEET: BASE_URL + "payments/refunds/upload",
    GET_EVENTS_LIST_BY_DATE_RANGE: BASE_URL_MARKETING + "getEventNameAggregator?startDate=",
    GET_ALL_AGGREATOR_LIST: BASE_URL_MARKETING + 'getAggregatorMap',

    // MIS NEW APIS 
    GET_DISBURSAL_DATA: FINANCE_BACKEND + "api/v1/mis/payments/dashboard/summary",
    GET_COLLECTION_DATA: FINANCE_BACKEND + "mis/getCollectionData",
    GET_EMI_BREAKDOWN: FINANCE_BACKEND + "api/v1/mis/payments/dashboard/emiBreakdown",
    GET_COLLECTION_BREAKDOWN: FINANCE_BACKEND + "api/v1/mis/payments/dashboard/collectionBreakdown",
    GET_COLLECTION_SUMMARY: FINANCE_BACKEND + "api/v1/mis/payments/dashboard/collectionSummary",
    GET_FUNNEL: FINANCE_BACKEND + "api/v1/mis/payments/dashboard/funnel",
    GET_EMI_BEHAVIOR: FINANCE_BACKEND + "api/v1/mis/payments/dashboard/emi-behavior",
    GET_PROJECTION: FINANCE_BACKEND + "api/v1/mis/payments/dashboard/projection",
    GET_OVERDUE_SUMMARY: FINANCE_BACKEND + "api/v1/mis/payments/dashboard/overdue-summary",
    GET_FINANCIAL_SUMMARY: FINANCE_BACKEND + "mis/getFinancialSummary",
    GET_ALERTS_DATA: FINANCE_BACKEND + "mis/getAlertsData",
    GET_FUNNEL_STAGES: FINANCE_BACKEND + "mis/getFunnelStages",
    GET_DROPOFF_DATA: FINANCE_BACKEND + "mis/getDropoffData",
    GET_EMI_REAKDOWN_LEAD_LIST_DATA: FINANCE_BACKEND + "api/v1/mis/payments/dashboard/emiBreakdown/detail?startDate=",
    GET_COLLECTION_REAKDOWN_LEAD_LIST_DATA: FINANCE_BACKEND + "api/v1/mis/payments/dashboard/collection/emi-list?startDate=",
    DOWNLOAD_EMI_REAKDOWN_LEAD_LIST_DATA: FINANCE_BACKEND + "api/v1/mis/payments/dashboard/emiBreakdown/export?startDate=",
    DOWNLOAD_COLLECTION_REAKDOWN_LEAD_LIST_DATA: FINANCE_BACKEND + "api/v1/mis/payments/dashboard/collectionBreakdown/detail/export?startDate=",

    GET_OVERVIEW_NACH_DATA_BY_FILTERS: FINANCE_BACKEND + "api/v1/nach/overview?startDate=",
    GET_NACH_LIST_BY_MULTI_FILTERS: FINANCE_BACKEND + "api/v1/nach/list?search=",
    GET_FAILURE_REASON_LIST_FOR_GRAPH: FINANCE_BACKEND + "api/v1/nach/failure-reasons?fromDate=",
    GET_BANK_FAILURE_REASON_LIST_FOR_GRAPH: FINANCE_BACKEND + "api/v1/nach/bank-failure-rate?fromDate=",
    GET_RETRY_SUCESS_RATE_FOR_GRAPH: FINANCE_BACKEND + "api/v1/nach/retry-success-rate?fromDate=",
    GET_DAILY_TREND_RANGE_FROM_FILTERS: FINANCE_BACKEND + "api/v1/nach/daily-trend/range?fromDate=",
    GET_ACTIVE_GATEWAY_SERVICE_LIST: PAYMENT_SERVICE_URL + "api/payment-service/activeGatewayServiceByTenant",
    DOWNLOAD_NACH_EXPORT_API_FROM_FILTERS: FINANCE_BACKEND + "api/v1/nach/export/all?fromDate=",
    DOWNLOAD_NACH_SCHEDULE_EXPORT_API_FROM_FILTERS: FINANCE_BACKEND + "api/v1/nach/schedule/export?fromDate=",
    GET_NACH_OVERVIEW_SCHEDULE_BY_FILTERS: FINANCE_BACKEND + "api/v1/nach/schedule/overview?startDate=",
    GET_NACH_SCHEDULE_UPCOMING_BY_LIMIT: FINANCE_BACKEND + "api/v1/nach/schedule/upcoming?limit=",
    GET_FORECAST_VOLUME_BY_FILTERS_DATE: FINANCE_BACKEND + "api/v1/nach/forecast/volume-forecast?startDate=",
    GET_COLLECTION_VOLUME_BY_FILTERS_DATE: FINANCE_BACKEND + "api/v1/nach/forecast/collection-forecast?startDate=",
    GET_FORECAST_RISK_ASSESSMENT_BY_FILTERS_DATE: FINANCE_BACKEND + "api/v1/nach/forecast/risk-assessment?startDate=",
    GET_FORECAST_INSIGHTS_BY_FILTERS_DATE: FINANCE_BACKEND + "api/v1/nach/forecast/insights?startDate=",
    GET_SCHEDULE_NACH_LIST_BY_FILTERS_DATE: FINANCE_BACKEND + "api/v1/nach/schedule/list?startDate=",
    GET_ALERTS_LIST_BY_FILTERS_DATE: FINANCE_BACKEND + "api/v1/nach/alerts?startDate=",

    DEACTIVATE_ENACH_FOR_ACTIVE_SERVICES: PAYMENT_SERVICE_URL + "api/payment-service/deactivateEnachForActiveService?userId=",
    GET_FINANCIAL_PROFIT_DASHBOARD: FINANCE_BACKEND + "api/v1/mis/payments/dashboard/financial-profit",
    GET_DISBURSAL_CALCULATE: FINANCE_BACKEND + "api/v1/disbursal/calculate",
    GET_MIS_COLLECTION_LIST: FINANCE_BACKEND + "api/mis/collection/filter",
    DOWNLOAD_MIS_COLLECTION_LIST: FINANCE_BACKEND + "api/mis/collection/filter/export",

    MONTHLY_FINANCIAL_SAVE: FINANCE_BACKEND + "monthly-financial/save",
    MONTHLY_FINANCIAL_FILTER: FINANCE_BACKEND + "monthly-financial/filter",


    UPLOAD_LOAN_UTILITY_FILES: BASE_URL + "saveLoanUtility",
    GET_LIST_OF_PRODUCTS: BASE_URL + "get-products",

    GET_EXPENSE_OVERVIEW_BY_DATE_RANGE_FILTERS: FINANCE_BACKEND + "api/expenses/getExpenseOverviewDataByDateRange?from=",
    // GET_EXPENSE_TABLE_BY_DATE_RANGE_FILTERS: FINANCE_BACKEND + "api/expenses/getMonthwiseActualExpenseData?from=",
    GET_EXPENSE_TABLE_BY_DATE_RANGE_FILTERS: FINANCE_BACKEND + "api/expenses/monthly-expense-trends?from=",
    GET_EXPENSE_DASHBOARD_SUMMARY_BY_FILTERS: FINANCE_BACKEND + "api/expenses/dashboard/summary?from=",
    GET_EXPENSE_EXPECTED_INCOME_SUMMARY_BY_FILTERS: FINANCE_BACKEND + "api/expenses/income-expense-graph?from=",
    GET_EXPENSE_MONTHLY_TABLE_FROM_FILTERS: FINANCE_BACKEND + "api/expenses/monthly-table?from=",
    GET_INCOME_GRWTH_MONTHLY_TABLE_FROM_FILTERS: FINANCE_BACKEND + "api/expenses/income-growth?from=",
    GET_EXPENSE_OVERVIEW_DATE_RANGE_BY_DATE: FINANCE_BACKEND + "api/expenses/getExpenseOverviewDataByDateRange?from=",

    GET_MFI_AGGREGATOR_DETAIL_BY_LOAN_ID: BASE_URL + "loan/getMfiAggregatorDetailByLoanId?loanId=",
    GET_WEBSITE_LEADS_BETWEEN_DATES_BY_DATE: BASE_URL + "getWebsitesLeadsBetweenDates?startDate=",
    APPLY_MANUAL_NACH_API_PAYMENT: PAYMENT_SERVICE_URL + "api/v1/payment/enach/triggerManual",
    APPLY_MANUAL_NACH_API_PAYMENT_MAIN_CODE: BASE_URL + "api/payment/manual-nach/trigger",
    GET_AGGREGATOR_SUMMARY_BY_ID: BRE_BASE_URL + "getAggregatorSummary?userId=",

    // Signzy Aggregtor 
    GET_WORK_ORDER_STATUS_BY_SIGNZY: BRE_BASE_URL + "getWorkOrderStatus?userId=",
    DOWNLOAD_UPLOADED_ANALYZED_STATEMENT_BY_SIGNZY: BRE_BASE_URL + "downloadAnalyzedStatement?userId=",
    FETCH_SIGNZY_ANALYSZED_STATEMENT_BYID: BRE_BASE_URL + "fetchSignzyAnalysedData?userId=",
    GET_SGINZY_OVERVIEW_STATEMENT_BYID: BRE_BASE_URL + "getSignzyOverview?userId=",
    ANALYZE_BANK_STATEMENT_DATA_BYID: BRE_BASE_URL + "analyzeSignzyBankStatement?userId=",

    FETCH_MOBILE_PREFILL_DATA_BYID: BASE_URL + "mobilePrefill?userId=",
    COMPARE_MOBILE_PREFILL_DATA_BYID: BASE_URL + "compareUserData?userId=",
    MARK_APPLICATION_HOLD_BYIDS: BASE_URL + "markApplicationHold?userId=",
    GET_FORM_STATUS_MESSAGES_LIST: BASE_URL + "getFormStatusMessages",
    SAVE_FORM_STATUS_MESSAGES_LIST: BASE_URL + "saveFormStatusMessage",

    GET_EMI_DATA_BY_EMIID: BASE_URL + "getemitopayuserByEmiId/",
    GET_USER_CHAT_CONVERSATION: BASE_URL + 'api/user-chat/conversation/',
    MARK_ALL_MESSAGES_AS_READ: BASE_URL + 'api/user-chat/markAllMessagesAsRead',
    MARK_MESSAGE_AS_READ: BASE_URL + 'api/user-chat/markMessageAsRead',
    SEND_USER_CHAT_MESSAGE: BASE_URL + 'api/user-chat/sendMessage',

    GET_USER_LOCATION_BY_USERID: BASE_URL + 'v1/getUserLocations?userId=',
    GET_USER_CONTACTS_BY_USERID: BASE_URL + 'v1/getUserContacts?userId=',
    GET_USER_CALL_LOGS_BY_USERID: BASE_URL + 'v1/getUserCallLogs?userId=',

    RETRIEVE_REPORTS_AA_BY_USERID: BRE_BASE_URL + 'retreiveAAReport?userId=',
    GET_AGGREGTOR_ACCOUNT_DETAIL_BYID: BRE_BASE_URL + 'getAggregatorAccount?userId=',
    GET_AA_DIGITAP_ANALYSIS_BY_ID: BRE_BASE_URL + 'getAADigitapAnalysis?userId=',
    GET_AA_DIGITAP_STATUS_CHECK_ANALYSIS_BY_ID: BRE_BASE_URL + 'statusCheckForAA?userId=',
    HANLDE_PERIODIC_REFETCH_BY_USERID: BRE_BASE_URL + 'periodicRefetch?userId=',
    HANLDE_FETCH_PREVDATA_BY_USERID: BRE_BASE_URL + 'fetchOldData?userId=',
    SUMMARY_FETCH_AA_BY_USERID: BRE_BASE_URL + 'summaryFetch?userId=',
    FETCH_SUMMARY_REPORT_AA_BY_USERID: BRE_BASE_URL + 'fetchSummaryReport?userId=',

    // Post Approval Dashboard APIs
    GET_POST_APPROVAL_SUMMARY: FINANCE_BACKEND + 'api/v1/post-approval/summary?startDate=',
    GET_POST_APPROVAL_FUNNEL: FINANCE_BACKEND + 'api/v1/post-approval/funnel?startDate=',
    GET_POST_APPROVAL_REJECTION_REASONS: FINANCE_BACKEND + 'api/v1/post-approval/rejection-reasons?startDate=',
    GET_POST_APPROVAL_REJECTION_DETAILS: FINANCE_BACKEND + 'api/v1/post-approval/rejection-details?startDate=',
    GET_POST_APPROVAL_REJECTIONS_BY_STAGE: FINANCE_BACKEND + 'api/v1/post-approval/rejections-by-stage?startDate=',
    GET_POST_APPROVAL_REJECTIONS_BY_DEPARTMENT: FINANCE_BACKEND + 'api/v1/post-approval/rejections-by-department?startDate=',
    GET_POST_APPROVAL_EXPIRES_BY_STAGE: FINANCE_BACKEND + 'api/v1/post-approval/expires-by-stage?startDate=',
    GET_POST_APPROVAL_EXPIRES_BY_DEPARTMENT: FINANCE_BACKEND + 'api/v1/post-approval/expires-by-department?startDate=',
    GET_BYPASS_OTP_LIMITBY_NUMBER: BASE_URL + 'otpMessage/bypassOtpLimit?mobile=',
    CREATE_MANDATE_CASHFREE_PAYMENT_SERVICE: PAYMENT_SERVICE_URL + "api/v1/payment/cashfree/createMandate",

    VALIDATE_MANAUL_TRANSACTION_ADDITON: PAYMENT_SERVICE_URL + 'api/v1/payment/manual/validateTransaction',
    GET_ACTIVE_LINK_SERVICE_BYLOANID: PAYMENT_SERVICE_URL + 'api/payment-service/activeLinkService?loanId=',

    GET_ADMIN_REFRESH_TOKEN: BASE_URL + 'adminRefreshToken',
    GET_CONSENT_STATUS_BYID: BRE_BASE_URL + 'getConsentStatus?userId=',
    UPDATE_TO_NEXT_FORM_STATUS_BY_ID: BASE_URL + 'mobile/userDetails/updateToNextFormStatus?userId=',
    GET_REDIRECT_URL_ACCOUTN_AGGREGATOR_BYID: BRE_BASE_URL + 'getRedirectURL?userId=',

    UPLAOD_SELFIE_LNK: BASE_URL + 'uploadpdf',
    COMPARE_PAN_AADHAAR_DATA_BYID: BASE_URL + 'comparePanAadhaarData?userId=',


    CREATE_PTP: FINANCE_BACKEND + 'ptp/create',
    GET_PTP_LIST: FINANCE_BACKEND + 'ptp/list',
    UPDATE_PTP: FINANCE_BACKEND + 'ptp/update',
    DELETE_PTP: FINANCE_BACKEND + 'ptp/delete',
    CHAT_API: BASE_URL + 'api/user-chat',

    FRAUD_KYC_BLACKLIST: FINANCE_BACKEND + 'api/v1/fraud-kyc/blacklist',
    FRAUD_KYC_LIST: FINANCE_BACKEND + 'api/v1/fraud-kyc/list',
    CHECK_FRAUD_KYC_LIST: FINANCE_BACKEND + 'api/v1/fraud-kyc/check?type=',
    GET_DIGITAL_FOOTPRINT_BY_ID: BASE_URL + 'verify/digital-footprint?userId=',
    GET_EVALUATE_CREDIT_AUTOMATION_BY_APPLICAITONID: BASE_URL + 'evaluateCreditAutomation?applicationId=',
    GET_PAN_DETAILS_BYSIGN3_ADVANCE: BASE_URL + 'pan/verify/sign3-advance?panNo=',
    GET_PAN_DETAILS_BYDIGITAP_ADVANCE: BASE_URL + 'digitap/verifyPan?pan=',

    PUSH_NOTIFICATION_LIST: BASE_URL + 'api/admin/notification/config/list',
    PUSH_NOTIFICATION_GET_CONFIG: BASE_URL + 'api/admin/notification/config',
    PUSH_NOTIFICATION_DELETE_CONFIG: BASE_URL + 'api/admin/notification/config/status/',
    GET_TEMP_AUTO_APPROVED_LEADS: BASE_URL + 'tempAutoApprovedLeads',
    GET_NBFC_ID_FOR_REPEAT_USER_BY_ID: BASE_URL + 'getNbfcIdForRepeatUser?loanId=',
    GET_SMS_ALERT_RECIEPIENTS: FINANCE_BACKEND + 'alertNotification/getSmsAlertRecipients',
    GET_API_HIT_RATIO_LIST: FINANCE_BACKEND + 'alertNotification/getApiHitsRatio',

    DELETE_REPORTING_MAILS_BYID: FINANCE_BACKEND + 'deleteReportingEmailById?id=',
    GET_REPORTING_MAILS_BYID: FINANCE_BACKEND + 'getReportingEmailsByAggregatorId?aggregatorId=',
    SAVE_REPORTING_EMAILS_BYDATA: FINANCE_BACKEND + 'saveReportingEmail?aggregatorId=',

    GET_CREDEAU_REPORT_BY_IDS: BRE_BASE_URL + "getCredeauReport?userId=",
    GET_AGGREGATOR_LEADS_LIST: BRE_BASE_URL + "getAggregatorLeads?startDate=",
    DELETE_ESIGN_BY_LOANID: BASE_URL + "deleteEsignByLoanId?loanId=",
    DELETE_ESIGN_NEW_BY_LOANID: BASE_URL + "deleteEsign?loanId=",
    DELETE_KFS_NEW_BY_LOANID: BASE_URL + "deleteKfsConsent?loanId=",
    API_LEAD_FUNNEL_SANCTION_EVALUATE_BY_APPID: LEAD_DASHBOARD_URL + "api/v1/lead-funnel/sanction/evaluate?applicationId=",
    GET_QUALITY_SUMMARY: LEAD_DASHBOARD_URL + "api/v1/lead-funnel/quality/rules/config",
    UPDATE_QUALITY_RULES_CONFIG: LEAD_DASHBOARD_URL + "api/v1/lead-funnel/quality/rules/config",
    GET_QUALITY_RULES_PRIORITIES: LEAD_DASHBOARD_URL + "api/v1/lead-funnel/quality/rules/priorities",
    UPDATE_QUALITY_RULES_PRIORITIES: LEAD_DASHBOARD_URL + "api/v1/lead-funnel/quality/rules/priorities",
    GET_QUALITY_LEAD_COUNTS: LEAD_DASHBOARD_URL + "api/v1/lead-funnel/quality/lead-counts",
    GET_QUALITY_LEAD_LIST: LEAD_DASHBOARD_URL + "api/v1/lead-funnel/quality/lead-list",
    GET_QUALITY_EVALUATION_DETAILS: LEAD_DASHBOARD_URL + "api/v1/lead-funnel/quality/evaluation-details",
    RE_EVALUATE_QUALITY_BY_LOAN: LEAD_DASHBOARD_URL + "api/v1/lead-funnel/quality/evaluate-by-loan",
    GET_AUTOMATION_DASHBOARD_COUNTS: LEAD_DASHBOARD_URL + "api/v1/automation/dashboard/counts",
    GET_AUTOMATION_DASHBOARD_LEADS: LEAD_DASHBOARD_URL + "api/v1/automation/dashboard/leads",
    GET_AUTOMATION_DASHBOARD_DISBURSED_LEADS: LEAD_DASHBOARD_URL + "api/v1/automation/dashboard/disbursed-leads",
    GET_AUTOMATION_ENGINE_EVALUATED_LEADS: LEAD_DASHBOARD_URL + "api/v1/automation/dashboard/engine-evaluated-leads",
    GET_AUTOMATION_PIPELINE_EVALUATE: LEAD_DASHBOARD_URL + "api/v1/automation/pipeline/evaluate",
    CHECK_CREDANCE_STATUS: LEAD_DASHBOARD_URL + "api/v1/automation/pipeline/check-credance-status",
    GET_SMS_TEMPALTELIST_MANUAL: COMMUNICATION_URL + "api/v1/sms-templates/collections/manual",
    PREVIEW_SMS_TEMPLATE: COMMUNICATION_URL + "api/v1/communication/previewTemplate?templateId=",
    EXECUTE_DIRECT_TEMPLATE_WITH_CONTEXT: COMMUNICATION_URL + "api/v1/notify/executeDirectTemplateWithContext?templateId=",


    FETCH_DIGITAP_DIGILICOKER_AADHAAR: BASE_URL + 'fetchDigitapDigilockerDetails?userId=',
    UPDATE_FORM_STATUS_BY_ID: BASE_URL + "userDetails/updateFormStatus?userId=",

    INITATE_ESIGN_DIGITAP: BASE_URL + "digitapEsignByLoanId?loanId=",
    GET_DIGITAP_ESIGN_DOC_BY_ID: BASE_URL + 'getDigitapEsignDoc?docId=',
    


















};

const WEB_URL = webUrl

export {
    APIS,
    BASE_URL,
    WEB_URL,
    ESIGN_KEY,
    CARD_URL,
    TENANT_ID,
    COMPANY_NAME, LLM_BASE_URL,
    REPORT_DB_KEY, LEAD_DASHBOARD_URL
};